{
  "quota": {
    "titre": "Limite atteinte",
    "msg": "Votre offre a atteint sa limite pour cette fonction. Passez à un forfait supérieur pour en ajouter davantage.",
    "msgObjets": "Cet inventaire a atteint le nombre maximal d'objets de votre offre. Passez à un forfait supérieur pour en ajouter davantage.",
    "msgCategories": "Vous avez atteint le nombre maximal de catégories de votre offre pour cet inventaire.",
    "msgProprietes": "Vous avez atteint le nombre maximal de propriétés de votre offre pour cet inventaire.",
    "msgPhotosObjet": "Votre offre limite le nombre de photos par objet. Passez à un forfait supérieur pour en ajouter davantage.",
    "msgPhotoCat": "Votre offre limite le nombre de photos par catégorie."
  },
  "tuto": {
    "precedent": "Précédent",
    "suivant": "Suivant",
    "terminer": "Terminer",
    "reduire": "Réduire le tutoriel",
    "pratique": "Passer à la pratique",
    "choisirPratique": "Choisis une mise en pratique"
  },
  "aide": {
    "aideFonction": "Aide",
    "tutoriel": "Tutoriel",
    "lancerTutoriel": "Lancer le tutoriel",
    "voirTutoriels": "Voir les tutoriels",
    "choisirTutoriel": "Choisis un tutoriel",
    "general": "général",
    "pages": "pages",
    "tutoriels": "Tutoriels",
    "pratiques": "Mises en pratique",
    "voir": "Voir",
    "faire": "Faire",
    "manuel": "Aide et manuel",
    "titre": "Aide"
  },
  "finances": {
    "titre": "Finances",
    "horizon": "Horizon de projection",
    "cumul": "Cumul",
    "recurrentesPrises": "récurrente(s)",
    "impactMensuel": "Impact mensuel moyen",
    "totalMensuel": "Total mensuel",
    "moisCourant": "Mois courant",
    "duree": "Durée",
    "dureeLibre": "Durée libre",
    "reinitPeriode": "Réinitialiser la période",
    "modeGraphique": "Graphique",
    "modeSuivi": "Suivi",
    "suiviPrevu": "Prévu",
    "suiviReel": "Réel",
    "suiviEcart": "Écart",
    "vueMois": "Suivi",
    "ongletProjection": "Projection",
    "tresorerieActuelle": "Trésorerie actuelle",
    "soldeProjete": "Solde projeté",
    "aucunePrevision": "Aucune ligne prévue",
    "aucunePrevisionAide": "Créez des lignes prévues (onglet Budget) pour voir où en sera votre trésorerie dans les mois à venir.",
    "tousBudgets": "Tout",
    "moisVide": "Rien de prévu ni de dépensé ce mois-ci.\nAjoute une ligne prévue avec ＋.",
    "aucuneLigne": "Aucune ligne prévue pour l'instant.",
    "etatDuMois": "État de ce mois",
    "filtrer": "Filtrer",
    "filtrerTrier": "Filtrer et trier",
    "tri": "Tri",
    "tri_statut": "Ce qui réclame une action d'abord",
    "tri_libelle": "Nom (A → Z)",
    "tri_montant": "Montant prévu (décroissant)",
    "tri_ecart": "Écart le plus important",
    "rechercherPh": "Rechercher un nom ou un montant",
    "comptes": "Comptes",
    "nouveauCompte": "Nouveau compte",
    "modifierCompte": "Modifier le compte",
    "comptePh": "Ex : LCL courant, Livret A…",
    "typeCompte": "Type de compte",
    "cpt_courant": "Courant",
    "cpt_epargne": "Épargne",
    "cpt_credit": "Carte / crédit",
    "cpt_autre": "Autre",
    "banque": "Banque",
    "fin4": "4 derniers",
    "soldeDepart": "Solde de départ",
    "soldeDepartAide": "Le solde du compte à la date ci-dessous. Il sert de point de repère : si le solde calculé ne correspond plus à celui de votre banque, c'est qu'il manque des opérations.",
    "dateSolde": "À la date du",
    "totalComptes": "Total des comptes",
    "aucunCompte": "Aucun compte",
    "aucunCompteAide": "Créez un compte par compte bancaire réel. Chaque opération importée lui sera rattachée : vous saurez d'où vient l'argent, et les virements entre vos comptes seront repérés.",
    "compteDuReleve": "Compte de ce relevé",
    "compteInconnu": "Ce relevé vient d'un compte inconnu — choisissez-en un, le lien sera mémorisé.",
    "transfertsDetectes": "Virements entre vos comptes",
    "transfertsAide": "Même montant, sens opposés, comptes différents, dates proches. Confirmez avec ⊘ pour les sortir des totaux — rien n'est fait sans vous.",
    "confirmerCompte": "Ce relevé est-il bien celui de « {compte} » ?",
    "releveResume": "{n} opération(s) · du {du} au {au} · {debits} de débits, {credits} de crédits",
    "ouiCEstBien": "Oui, importer",
    "vChoisirCompte": "Choisissez d'abord le compte de destination.",
    "vAutreCompte": "Ce relevé porte le numéro de compte {acctid}, qui appartient à un AUTRE compte. Import bloqué.",
    "vNomFichier": "Le nom du fichier contient « {fin4} », alors que ce compte se termine par « {attendu} ». Vérifiez avant de continuer.",
    "vDejaAilleurs": "{n} opération(s) de ce relevé existent déjà sur un autre compte — ce relevé y a peut-être déjà été importé.",
    "imprevus": "Imprévus",
    "nonPrevu": "non prévu",
    "horsCalcul": "Hors calcul",
    "interne": "mouvement interne",
    "actInterne": "Mouvement interne (hors calcul)",
    "actReintegrer": "Réintégrer dans les calculs",
    "interneAide": "Un virement entre vos propres comptes n'est ni un débit ni un crédit réel : il reste visible, mais ne compte dans aucun total.",
    "reste": "reste",
    "depasse": "dépassé de",
    "st_realisee": "réalisée",
    "st_partielle": "partielle",
    "st_manquante": "aucune opération rattachée",
    "st_ignoree": "ignorée",
    "st_absente": "n'a pas eu lieu",
    "st_avenir": "à venir",
    "nouvelleLigne": "Nouvelle ligne prévue",
    "modifierLigne": "Modifier la ligne prévue",
    "libellePlaceholder": "Ex : Loyer, Salaire, Courses…",
    "montantPrevu": "Montant prévu",
    "sansFinAide": "Sans date de fin, la ligne se répète indéfiniment.",
    "actQue": "Que faire ?",
    "actModifierLigne": "Modifier la ligne prévue",
    "actAbsente": "Marquer : n'a pas eu lieu",
    "actIgnorer": "Ignorer ce mois",
    "actRetablir": "Rétablir (calcul normal)",
    "actSupprimerLigne": "Supprimer la ligne prévue",
    "actRattacher": "Rattacher à une ligne prévue",
    "actCreerLigne": "＋ Créer une ligne prévue",
    "suiviNonPointe": "non pointé",
    "suiviHint": "Prévu vs réel par colonne sur {n} mois. L'écart (réel − prévu, vert = favorable) est sur la ligne du nom ; Prévu et Réel en dessous.",
    "suiviEcartSeul": "Écarts seuls",
    "suiviAucun": "Aucun mouvement rattaché à une récurrence sur la période. Confirme des échéances pour alimenter le suivi.",
    "suiviTout": "Tout",
    "echelleColonnes": "Échelle :",
    "evolution": "Évolution dans le temps",
    "aRattacher": "à rattacher",
    "operationsRattachees": "Opérations rattachées",
    "aucuneOpRattachee": "Aucune opération rattachée pour l'instant.",
    "detacher": "Détacher",
    "rattachables": "Opérations rattachables",
    "aucuneRattachable": "Aucune opération à proposer (montant proche).",
    "de": "de",
    "a": "à",
    "depuis": "Depuis",
    "budget": "Budget",
    "triDate": "Par date",
    "sourceRec": "Récurrentes",
    "sourcePonct": "Ponctuelles",
    "sourceTout": "Les deux",
    "ponctuelle": "Ponctuelle (réel)",
    "compteDansTotaux": "Compté dans les totaux",
    "sensRevenus": "crédits",
    "sensDepenses": "débits",
    "vueSoldes": "Soldes",
    "aucunSolde": "Aucun budget partagé où tu as une part ou tu as payé.",
    "onTeDoit": "On te doit",
    "tuDois": "Tu dois",
    "equilibre": "À l'équilibre",
    "maPosition": "Ma position",
    "jusqua": "jusqu'à",
    "teDoit": "{nom} te doit",
    "tuDoisA": "Tu dois à {nom}",
    "parCalendrier": "Par calendrier",
    "parCategorie": "Par catégorie",
    "parPersonne": "Par personne",
    "reelParPersonne": "Réel · par personne",
    "previsionParPersonne": "Prévision · par personne",
    "coutBudget": "Coût du budget",
    "jaiPaye": "J'ai payé",
    "maPart": "Ma part",
    "rembRecu": "Remboursement reçu",
    "rembVerse": "Remboursement versé",
    "mesSoldesNote": "Par personne : + vert = on te doit · − rouge = tu dois, détaillé par budget (remboursements confirmés inclus). Touche un budget pour l'ouvrir (et rembourser).",
    "operationsPonct": "Opérations",
    "reference": "Référence",
    "plusAncienne": "Plus ancienne",
    "plusRecente": "Plus récente",
    "calerDebut": "Caler le début",
    "calerFin": "Caler la fin",
    "calerDebutAide": "« Plus ancienne » cale le début sur l'opération rattachée la plus ancienne. Au rattachement, le début recule automatiquement si besoin.",
    "echeancier": "Échéancier (dates + montants)",
    "echeancierAide": "Ajoute chaque échéance à la main : date + montant + sens (− débit / + crédit). Idéal pour l'impôt (certaines années tu paies, d'autres on te rembourse). Ces échéances alimentent la projection.",
    "ajouterEcheance": "Ajouter une échéance",
    "echeancierVide": "Ajoute au moins une échéance (date + montant).",
    "rendreRecurrente": "Rendre récurrente",
    "rendreRecurrenteAide": "Crée une récurrente (fréquence mensuelle par défaut, ajustable) à partir de ces opérations et les rattache. Début = plus ancienne opération. Choisis la fin :",
    "rrAvecFin": "Fin = plus récente",
    "rrSansFin": "Sans fin (en cours)",
    "rendreRecurrenteOk": "Récurrente créée et {n} opération(s) rattachée(s). Ajuste la fréquence/le montant dans son édition si besoin.",
    "refDepuisOp": "Montant de référence depuis une opération",
    "refAide": "« Référence » reprend le montant d'une opération rattachée comme base de projection. Sinon, saisis le montant à la main (utile si la hausse est ponctuelle ou si les opérations ne sont pas encore fiables).",
    "refPickAide": "Touche une opération (de la plus récente à la plus ancienne) pour en faire le nouveau montant de référence.",
    "aucunePonct": "Aucune opération ponctuelle (non rattachée à une récurrente).",
    "aucuneOpPeriode": "Aucune opération sur {periode}.",
    "notePonct": "Opérations réelles non rattachées à une récurrente, regroupées par catégorie. Uniquement du passé (pas de projection). « Cumulé » = solde réel de ces opérations.",
    "moisPayes": "Mois payés (réel)",
    "moisProjetes": "Mois projetés",
    "graphNet": "Net",
    "graphNetPeriode": "Net période",
    "graphRevenus": "Crédits",
    "graphDepenses": "Débits",
    "graphCumule": "Solde cumulé",
    "graphEmpile": "Empilé",
    "graphLignes": "Lignes",
    "graphCategories": "Catégories",
    "graphBientot": "Bientôt disponible",
    "soldeFinal": "Solde final",
    "budgetsAffiches": "Budgets affichés",
    "sansCalendrier": "Sans calendrier",
    "toutAfficher": "Tout afficher",
    "toutMasquer": "Tout masquer",
    "mois": "Mois",
    "annee": "Année",
    "noteGraphique": "Barres = net de chaque période · Courbe = solde cumulé projeté. Touche/survole pour le détail. Mêmes filtres, regroupements et période que le Planning.",
    "jour": "le",
    "inactive": "inactive",
    "toutes": "Toutes",
    "actives": "Actives",
    "inactives": "Inactives",
    "triJour": "Jour",
    "aucuneRecurFiltre": "Aucune récurrente pour ce filtre.",
    "modeListe": "Liste",
    "modePlanning": "Planning",
    "planMoisCourt": "Mois",
    "planAnsCourt": "Ans",
    "planDecCourt": "Déc.",
    "toutMois": "Tout déplier (mois)",
    "replierAnnees": "Replier en années",
    "replierDecennies": "Replier en décennies",
    "niveau": "Niveau",
    "niv_calendrier": "Calendrier",
    "niv_budget": "Budget",
    "niv_categorie": "Catégorie",
    "augmentation": "Augmentation",
    "avec": "Avec",
    "sans": "Sans",
    "dateFin": "Date de fin",
    "avecFin": "Avec fin",
    "sansFin2": "Sans fin",
    "dateFinFiltre": "Fin (date)",
    "avant": "Avant",
    "leMois": "Le mois",
    "apres": "Après",
    "planMois": "Mois",
    "planAnnee": "Année",
    "ans": "ans",
    "moisCourt": "m",
    "recurrente": "Récurrente",
    "cumule": "Cumulé",
    "notePlanning": "Coût projeté de chaque récurrente période par période (inflation incluse). « Cumulé » = solde projeté. Touche une ligne pour la modifier.",
    "editerRecurrente": "Modifier la récurrente",
    "nouvelleRecurrente": "Nouvelle récurrente",
    "calendrier": "Calendrier",
    "choisirCalendrier": "Choisissez d'abord un calendrier.",
    "debut": "Début",
    "fin": "Fin",
    "optionnel": "optionnel",
    "sansFin": "Sans fin",
    "inflation": "Inflation (projection long terme)",
    "tauxAnnuel": "Taux %/an",
    "depuisMois": "Depuis le mois",
    "inflationAide": "Taux annuel composé : le montant augmente du taux dès le mois indiqué, puis à chaque anniversaire. Laisser vide ou à 0 = pas d'inflation.",
    "inflationCourte": "+{taux} %/an",
    "sansInflation": "sans inflation",
    "moyCourte": "moy. {m}",
    "creditBascule": "Type de ligne",
    "creditClassique": "Classique",
    "credit": "Crédit",
    "creditMensualiteConnue": "Mensualité connue",
    "creditMode": "Mode de saisie",
    "creditModeMensualite": "Mensualité connue",
    "creditModeParams": "Paramètres du prêt",
    "creditModeMensualiteAide": "Le montant ci-dessus EST la mensualité totale (assurance comprise). Le capital restant dû à la date de référence sert à calculer intérêts et capital, mois par mois.",
    "creditModeParamsAide": "La mensualité est CALCULÉE à partir du capital emprunté, du taux et de la durée — inutile de la connaître à l'avance.",
    "creditCapital": "Capital",
    "creditTaux": "Taux annuel (%)",
    "creditDateRef": "Date de référence",
    "creditDateRefVide": "AAAA-MM",
    "creditDateRefAideMensualite": "Le mois où le capital ci-dessus était dû. Vide = le Début de la ligne.",
    "creditDateRefAideParams": "Le mois de démarrage du crédit (premier déblocage s'il y en a). Vide = le Début de la ligne.",
    "creditDuree": "Durée",
    "creditDiffere": "Différé (mois)",
    "creditAssurance": "Assurance mensuelle",
    "creditMensualiteEstimee": "Mensualité estimée : {m}",
    "creditAvance": "Avancé — paliers, déblocages",
    "creditPaliers": "Paliers",
    "creditPaliersAide": "Des mensualités différentes par période (ex. taux progressif). Le dernier segment amortit automatiquement ce qu'il reste.",
    "creditAjouterPalier": "Ajouter un palier",
    "creditPalierMensualite": "Mensualité",
    "creditPalierDuree": "Durée (mois)",
    "creditDeblocages": "Déblocages progressifs",
    "creditDeblocagesAide": "Pour un prêt travaux : le capital est versé en plusieurs fois, avec des intérêts intercalaires sur ce qui est déjà débloqué. Le % de chaque ligne se cumule jusqu'à 100.",
    "creditAjouterDeblocage": "Ajouter un déblocage",
    "creditRembCapitalDeblocage": "Rembourser le capital dès les déblocages",
    "creditErreurParams": "Indique le capital emprunté ET la durée (mois) pour calculer la mensualité — l'enregistrement reste bloqué tant que l'un des deux manque.",
    "creditErreurMensualite": "Indique la mensualité connue ci-dessus.",
    "recurrenteActive": "Récurrente active",
    "dateInvalide": "Date invalide (format attendu : AAAA-MM-JJ, ou AAAA-MM pour l'inflation).",
    "finAvantDebut": "La date de fin doit être après la date de début.",
    "totalGlobal": "Résultat du mois",
    "resultatPaye": "Résultat du mois (payé)",
    "restant": "Restant à payer",
    "estimation": "Estimation du mois",
    "aucun": "Aucune opération ce mois.",
    "mouvements": "mouvement(s)",
    "changerNature": "nature",
    "vueCalendriers": "Calendriers",
    "vueCategories": "Catégories",
    "vueSynthese": "Synthèse",
    "vueTableau": "Tableau",
    "vueProjection": "Projection",
    "total": "Total",
    "categorie": "Catégorie",
    "totalProjection": "Cumul 12 mois",
    "noteProjection": "Toutes tes récurrentes (tous calendriers). Touche-en une pour la modifier. L'estimé prévisionnel apparaît dans la Synthèse (mois/année à venir).",
    "aucuneRecurProjection": "Aucune récurrente. Crée-en dans un budget (Famille → Budget) ; elle alimentera l'estimé de la Synthèse.",
    "note": "Touchez un calendrier (vue Calendriers) pour changer sa nature. Bientôt : plafonds et prévisionnel.",
    "triMontantOp": "Montant (décroissant)",
    "sensEntrees": "Entrées seulement",
    "sensSorties": "Sorties seulement",
    "masquerHorsCalcul": "Masquer les mouvements internes",
    "masquerHorsCalculAide": "Ils restent visibles par défaut : cet argent est bien sorti du compte, et le masquer ferait diverger la liste du solde.",
    "ongletBudget": "Budget",
    "partDe": "part de {total}",
    "honore": "Ce que cette opération honore",
    "configBudget": "Configuration",
    "soldeBanqueLigne": "Solde annoncé par la banque : {solde} au {date}",
    "rapprochementTitre": "Rapprochement bancaire",
    "rapprochementMsg": "La banque annonce {banque} au {date} ; l'app calcule {calcule} — écart de {ecart}. Recaler le compte sur le solde de la banque ?",
    "recalerSolde": "Recaler le solde",
    "sansPrevision": "Sans prévision",
    "unSeulMois": "Un seul mois",
    "etalerSur": "Étaler sur",
    "moisMot": "mois",
    "etaleAide": "≈ {m} par mois — le prévu de chaque mois restant se recalcule selon le réel déjà constaté.",
    "basculerSynthese": "Afficher ou masquer la synthèse",
    "filtreEcheancesMois": "Avec échéance ce mois-ci",
    "triDefaut": "Ordre d'origine",
    "lignesDuMois": "Lignes prévues · {mois}",
    "resteAffecter": "Reste à affecter",
    "selLignesAide": "Cochez une ou plusieurs lignes — la part de chacune se règle en € ou en %.",
    "aucuneLigneMois": "Aucune ligne prévue ne tombe ce mois-ci.",
    "ficheLignesPrevues": "Lignes prévues",
    "ficheBudgetNominal": "Montants nominaux des lignes, toutes fréquences confondues.",
    "supprBudgetLignes": "« {nom} » contient {n} ligne(s) prévue(s) : supprime-les ou change-les d'enveloppe d'abord.",
    "nonApplicables": "Non applicables ce mois-ci",
    "nonApplicablesAide": "Ces prévisions existent, mais leur configuration ne les rend pas dues ce mois-ci.",
    "nd_avantDebut": "commence en {mois}",
    "nd_apresFin": "terminée en {mois}",
    "nd_frequence": "prochaine échéance : {mois}",
    "nd_ponctuelle": "ponctuelle · {mois}",
    "nd_horsEcheancier": "prochaine échéance : {mois}",
    "nd_inactive": "désactivée",
    "nd_sansDebut": "sans date de début",
    "nd_inexistante": "—",
    "nd_moisInvalide": "—",
    "nd_creditInvalide": "paramètres de crédit incomplets",
    "periodeDepuis": "depuis {mois}",
    "periodeJusqua": "jusqu’à {mois}",
    "prochainesEcheances": "Prochaines échéances",
    "echeancesPassees": "Échéances passées",
    "echeancesAnciennes": "{n} plus anciennes",
    "st_soldee": "validée",
    "actSolder": "Totalement consommée",
    "actSolderAide": "Le reste ne sera pas dépensé : cette échéance ne réclame plus rien.",
    "resteADepenser": "Reste à dépenser",
    "dejaRattacheAilleurs": "déjà utilisé pour cette prévision",
    "montantPartAide": "Modifiez le montant pour n’affecter qu’une part de l’opération : le reste demeure disponible pour une autre prévision.",
    "vueParEnveloppe": "Par enveloppe",
    "rattacherOps": "Rattacher des opérations",
    "selectionnees": "{n} sélectionnée(s)",
    "abandonner": "Abandonner les modifications ?",
    "reinitFiltres": "Réinitialiser les filtres",
    "fMontant": "Montant",
    "fPeriode": "Période",
    "fCompte": "Compte",
    "fRattachement": "Rattachement",
    "mExact": "Exact",
    "mTous": "Tous",
    "rNon": "Non rattachées",
    "rOui": "Rattachées",
    "rToutes": "Toutes",
    "choisirMois": "Choisir un mois",
    "moisAffectation": "Mois d’affectation",
    "reinitMoisOp": "Revenir au mois de l’opération",
    "toutAffecter": "Tout affecter à…",
    "ceBudget": "ce budget",
    "partPrise": "prendrait {pct} %",
    "aucuneApresFiltre": "Aucune opération ne correspond aux filtres.",
    "toastRattache": "{n} opération(s) rattachée(s){autres}",
    "toastAutres": " · {n} autre(s) prévision(s) recalculée(s)",
    "dejaRattacheMois": "Déjà rattaché à ce mois",
    "rienDePlusMois": "Valider ce mois",
    "rienDePlusAide": "Valider fige ce mois : le reste ne sera pas consommé, même si le prévu n'est pas atteint.",
    "rouvrirMois": "Invalider ce mois",
    "moisSoldeAide": "Ce mois est validé. L'invalider remet le reste à dépenser.",
    "st_couverte": "rattachée, à valider",
    "modeProposees": "Propositions — cherchez pour voir toutes les opérations",
    "modeToutes": "Toutes les opérations, selon votre recherche",
    "vueListe": "Vue liste",
    "reelMoyen": "Réel moyen",
    "surNMois": "sur {n} mois",
    "horsMois": "hors mois",
    "rattachees": "rattachée(s)",
    "viaPrevision": "via la prévision",
    "toutDetacher": "Tout détacher de ce mois ?",
    "fReste": "Reste à affecter",
    "resteNonNul": "Non nul",
    "inflationCourt": "inflation",
    "err_montantNul": "Cette opération est déjà entièrement affectée : il ne reste rien à rattacher.",
    "err_depassement": "La somme des parts dépasserait le montant de l'opération.",
    "err_doublon": "Cette opération est déjà rattachée à cette échéance — modifiez la part existante.",
    "err_cible": "Choisissez d'abord une prévision et un mois.",
    "err_operation": "Opération introuvable.",
    "ligneBudget": "Ligne de budget",
    "resteDebit": "Reste en débit prévisionnel",
    "resteCredit": "Reste en crédit prévisionnel",
    "gestionCategories": "Gestion des catégories",
    "catDefauts": "Catégories par défaut",
    "catDefautsAide": "Jamais modifiées : l'œil les masque à la saisie, sans toucher à l'historique.",
    "catNouvellePh": "Nouvelle catégorie…",
    "sousCatPh": "Nouvelle sous-catégorie…",
    "catMasquer": "Masquer",
    "catAfficher": "Afficher",
    "catErr_nomVide": "Donnez un nom à la catégorie.",
    "catErr_nomTropLong": "30 caractères maximum.",
    "catErr_doublon": "Une catégorie porte déjà ce nom.",
    "sousCategorie": "Sous-catégorie",
    "sousCatOptionnelle": "Sous-catégorie (optionnel)",
    "syntheseTotal": "Total"
  },
  "commun": {
    "retour": "Retour",
    "baisserClavier": "Baisser le clavier",
    "limitePiecesTitre": "Limite atteinte",
    "limitePiecesMsg": "Votre forfait permet {n} pièce(s) jointe(s) par élément. Supprimez-en une ou changez de forfait pour en ajouter davantage.",
    "annuler": "Annuler",
    "effacer": "Effacer",
    "enregistrer": "Enregistrer",
    "nom": "Nom",
    "emoji": "Emoji",
    "note": "Note",
    "erreur": "Erreur",
    "valider": "Valider",
    "ajouter": "Ajouter",
    "inviter": "Inviter",
    "supprimer": "Supprimer",
    "dupliquer": "Dupliquer",
    "modifier": "Modifier",
    "fermer": "Fermer",
    "rechercher": "Rechercher",
    "filtrer": "Filtrer",
    "trier": "Trier",
    "chargement": "Chargement…",
    "oui": "Oui",
    "non": "Non",
    "creer": "Créer",
    "supprMultiTitre": "Supprimer la sélection ?",
    "supprMultiMsg": "Supprimer {n} élément(s) ? Cette action est définitive.",
    "editer": "Éditer",
    "moisLongs": [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre"
    ],
    "moisCourts": [
      "Jan",
      "Fév",
      "Mar",
      "Avr",
      "Mai",
      "Juin",
      "Juil",
      "Août",
      "Sep",
      "Oct",
      "Nov",
      "Déc"
    ],
    "joursCourts": [
      "L",
      "M",
      "M",
      "J",
      "V",
      "S",
      "D"
    ],
    "joursLongs": [
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
      "Dimanche"
    ],
    "ok": "OK",
    "formulaireFerme": "Formulaire fermé.",
    "chargementEspaces": "Chargement de vos espaces…",
    "choisirDate": "Choisir la date",
    "choisirHeure": "Choisir l'heure",
    "aucune": "Aucune",
    "aucuneDate": "Aucune date",
    "aucuneHeure": "Aucune heure",
    "choisirMoisAnnee": "Choisir le mois et l'année",
    "choisisHeure": "Choisis une heure",
    "heures": "Heures",
    "minutes": "Minutes",
    "accesCameraRefuse": "Accès à l'appareil photo refusé.",
    "retirerPiece": "Retirer la pièce jointe",
    "pieceSeraRetiree": "« {nom} » sera retiré.",
    "bienvenueSuite": "Bienvenue sur MoP Suite",
    "toucherMasquer": "Touche pour masquer.",
    "rienAAfficher": "Rien à afficher.",
    "joursNoms": [
      "Lun.",
      "Mar.",
      "Mer.",
      "Jeu.",
      "Ven.",
      "Sam.",
      "Dim."
    ],
    "reinitialiser": "Réinitialiser",
    "termine": "Terminé",
    "mois": "Mois",
    "annee": "Année",
    "tout": "Tout",
    "basculerAnnee": "Compter en années",
    "basculerMois": "Compter en mois",
    "deplier": "Déplier",
    "replier": "Replier"
  },
  "recurrences": {
    "titre": "Événements récurrents",
    "erreur": "Erreur",
    "sansTitre": "(Sans titre)",
    "aucun": "Aucun événement récurrent",
    "aucunAide": "Touchez « + » pour en créer un",
    "depuis": "Depuis",
    "desactive": "désactivé",
    "recQuotidien": "Tous les jours",
    "recHebdo": "Tous les {jours}",
    "recBimensuel": "Toutes les 2 semaines",
    "recMensuel": "Chaque mois",
    "nSelectionnes": "{n} sélectionné(s)",
    "supprimerSerie": "Supprimer la série",
    "supprimerSerieMsg": "Supprimer tous les événements récurrents « {titre} » ?",
    "supprSeriesTitre": "Supprimer les séries",
    "supprSeriesMsg": "Supprimer les {n} série(s) sélectionnée(s) ?",
    "nouveau": "Nouvel événement récurrent",
    "modifier": "Modifier l'événement récurrent",
    "phTitre": "Titre de l'événement *",
    "phLieu": "Lieu (optionnel)",
    "lieu": "Lieu",
    "phChoisirLieu": "Choisir un lieu déclaré…",
    "phNote": "Note (optionnelle)",
    "heureDebut": "Début",
    "heureFin": "Fin",
    "frequence": "Fréquence",
    "typeHebdo": "Chaque semaine",
    "typeBimensuel": "2 semaines",
    "typeMensuel": "Mensuel",
    "categorie": "Catégorie",
    "periode": "Période",
    "debut": "Début",
    "fin": "Fin",
    "sansFin": "Sans fin",
    "dateFinAvant": "La date de fin doit être après la date de début.",
    "exceptionsTitre": "Exceptions ({n})",
    "exceptionsAide": "Occurrences supprimées de la série. Retirez celles qui ne correspondent plus à la configuration.",
    "exCompatible": "compatible",
    "exSansObjet": "sans objet",
    "exHorsPeriode": "hors période",
    "exPurgeTitre": "Exceptions sans objet",
    "exPurgeMsg": "{n} exception(s) ne correspondent plus à la nouvelle configuration. Les retirer ?",
    "exGarder": "Garder",
    "exRetirer": "Retirer"
  },
  "nav": {
    "calendrier": "Calendrier",
    "evenements": "Événements",
    "famille": "Famille",
    "profil": "Profil",
    "ivv": "IVV",
    "inventaires": "Inventaires",
    "plans": "Plans"
  },
  "langue": {
    "titre": "Langue",
    "sousTitre": "Langue de l'application",
    "actuelle": "Langue actuelle"
  },
  "login": {
    "erreurPrenom": "Entrez votre prénom",
    "erreurRole": "Choisissez votre rôle",
    "erreurNonAutorise": "Cette adresse email n'est pas autorisée à s'inscrire. Contactez l'administrateur.",
    "erreurInterdit": "Cette adresse e-mail a été bloquée. Contactez l'administrateur.",
    "attenteTitre": "Inscription en attente",
    "attenteDesc": "Un administrateur doit ensuite approuver votre inscription avant que vous puissiez vous connecter.",
    "attenteVerifDesc": "Un e-mail de vérification a été envoyé à {email}. Cliquez le lien reçu pour valider votre adresse.",
    "emailNonVerifie": "Vérifiez d'abord votre e-mail : cliquez le lien reçu, puis reconnectez-vous.",
    "renvoyerVerif": "Renvoyer l'e-mail de vérification",
    "verifRenvoyeeTitre": "E-mail envoyé",
    "verifRenvoyeeMsg": "Un lien de vérification a été renvoyé à {email}.",
    "retourConnexion": "Retour à la connexion",
    "placeholderPrenom": "Votre prénom",
    "jeSuis": "Je suis :",
    "maman": "Maman",
    "papa": "Papa",
    "placeholderEmail": "Email",
    "placeholderMdp": "Mot de passe (6 caractères min)",
    "mdpOublie": "Mot de passe oublié ?",
    "resetSucces": "Email envoyé à {email}. Vérifiez votre boîte mail.",
    "resetInfo": "Entrez votre email ci-dessus et appuyez sur \"Envoyer\".",
    "envoyerLienReset": "Envoyer le lien de réinitialisation",
    "sInscrire": "S'inscrire",
    "seConnecter": "Se connecter",
    "dejaCompte": "Déjà un compte ? Se connecter",
    "pasDeCompte": "Pas de compte ? S'inscrire",
    "ou": "ou",
    "continuerGoogle": "Continuer avec Google",
    "googleLierMdp": "Un compte existe déjà avec cet e-mail. Entrez votre mot de passe et connectez-vous pour lier votre compte Google.",
    "sousTitreSuite": "Connecte-toi avec ton compte MoPCal.",
    "phEmail": "E-mail",
    "phMotDePasse": "Mot de passe",
    "masquerMdp": "Masquer le mot de passe",
    "afficherMdp": "Afficher le mot de passe",
    "creerCompte": "Créer un compte",
    "ou": "ou",
    "continuerGoogle": "Continuer avec Google",
    "continuerApple": "Continuer avec Apple"
  },
  "famille": {
    "titre": "Famille",
    "trierTitre": "Trier par titre (A→Z)",
    "rubTemps": "Organiser le temps",
    "rubMaison": "La maison au quotidien",
    "rubEchanges": "Échanger en famille",
    "rubMemoire": "Mémoire & suivi",
    "indisponible": "Indisponible",
    "decDispo": "Disponible avec le forfait {palier}",
    "decOuCarte": " — ou à la carte.",
    "decVoirTuto": "Voir comment ça marche",
    "decVoirForfaits": "Découvrir les forfaits",
    "demandesLabel": "Demandes",
    "demandesDesc": "Valider les modifications de planning",
    "listesLabel": "Listes & courses",
    "listesDesc": "Tâches et courses partagées",
    "inventaireLabel": "Inventaire / stock",
    "inventaireDesc": "Stock par catégories : placards, réserves…",
    "plansEmplacementsLabel": "Plans & emplacements",
    "plansEmplacementsDesc": "Plan 2D des pièces et rangements, objets par lieu",
    "budgetLabel": "Budget",
    "budgetDesc": "Opérations partagées et solde",
    "messagerieLabel": "Messagerie",
    "messagerieDesc": "Discuter en famille",
    "journalLabel": "Journal de bord",
    "journalDesc": "Notes partagées du quotidien",
    "contactsLabel": "Contacts",
    "contactsDesc": "Médecin, école, urgences…",
    "statistiquesLabel": "Statistiques",
    "statistiquesDesc": "Répartition du temps de garde",
    "emploiDuTempsLabel": "Emploi du temps",
    "emploiDuTempsDesc": "Emploi du temps scolaire de l'enfant",
    "exportLabel": "Exporter / Rapport",
    "exportDesc": "Agenda (.ics) et rapport PDF",
    "vacancesLabel": "Vacances & jours fériés",
    "vacancesDesc": "Charger les vacances scolaires",
    "lieuxLabel": "Lieux",
    "lieuxDesc": "Adresses réutilisables du calendrier",
    "recurrencesLabel": "Événements récurrents",
    "recurrencesDesc": "Gérer les séries d'événements",
    "historiqueLabel": "Historique",
    "historiqueDesc": "Journal des changements d'organisation",
    "repasLabel": "Repas",
    "repasDesc": "Compositions de repas (recettes + extras)",
    "menuDesc": "Planning des repas par jour et moment",
    "rubApprendre": "Apprendre",
    "apprentissageLabel": "Tutoriel & Mise en Pratique",
    "apprentissageDesc": "Apprends chaque fonction, puis mets-la en pratique",
    "reorgAstuce": "Glissez les tuiles pour les réagencer",
    "reorgPrendre": "Glissez la poignée ⠿, ou touchez une tuile à déplacer",
    "reorgPoser": "Touchez l'emplacement où la placer",
    "reorgTermine": "Terminé",
    "reorgReinit": "Réinitialiser",
    "reorganiser": "Réorganiser",
    "plusADebloquer": "+{n} à débloquer",
    "reduire": "Réduire",
    "reorgAide": "Déplacez un bloc avec ▲▼. Touchez une tuile puis ◀ ▶ pour la déplacer dans son bloc.",
    "sec": {
      "collaboration": "Collaboration",
      "garde": "Garde",
      "organisation": "Organisation",
      "carnets": "Carnets",
      "finances": "Finances",
      "outils": "Outils"
    },
    "t": {
      "demandes": "Demandes",
      "messagerie": "Messagerie",
      "journal": "Journal",
      "statistiques": "Statistiques",
      "historique": "Historique",
      "listes": "Listes",
      "repas": "Repas",
      "menu": "Menu",
      "courses": "Courses",
      "contacts": "Contacts",
      "lieux": "Lieux",
      "finances": "Budget",
      "exports": "Exports",
      "edt": "Emploi du temps"
    },
    "coursesDesc": "Liste generee depuis les menus"
  },
  "historique": {
    "titre": "Historique",
    "vide": "Aucun changement enregistré",
    "videAide": "Les créations, modifications et suppressions d'événements, d'emplois du temps et de gardes apparaîtront ici.",
    "filtre_tous": "Tous",
    "filtre_evenement": "Événements",
    "filtre_recurrence": "Récurrences",
    "filtre_edt": "Emploi du temps",
    "filtre_garde": "Gardes",
    "filtre_demande": "Demandes",
    "type_evenement": "Événement",
    "type_recurrence": "Série récurrente",
    "type_edt": "Emploi du temps",
    "type_garde": "Garde",
    "type_demande": "Demande",
    "action_creation": "Créé",
    "action_modification": "Modifié",
    "action_suppression": "Supprimé",
    "gardeItem": "Changement de garde",
    "par": "par {nom}",
    "pourLe": "pour le {date}",
    "deplaceDe": "déplacé du {de} au {vers}",
    "dDeplacement": "Déplacement",
    "aujourdhui": "Aujourd'hui",
    "hier": "Hier",
    "sansTitre": "(sans titre)",
    "act_activation": "Activé",
    "act_desactivation": "Désactivé",
    "act_exceptions": "Exceptions modifiées",
    "dAction": "Action",
    "dType": "Type",
    "dDateConcernee": "Date concernée",
    "dPar": "Par",
    "dQuand": "Quand",
    "detailNote": "Le détail des champs modifiés n'est pas conservé ; cette fiche récapitule l'action enregistrée."
  },
  "garde": {
    "preVolTitre": "Appliquer la configuration ?",
    "preVolMsg": "{total} jour(s) forcé(s) à la main : {utiles} utile(s), {redondants} redondant(s) (même garde que la nouvelle config). Que faire des jours forcés ?",
    "conserverAppliquer": "Conserver et appliquer",
    "toutReinitialiser": "Tout réinitialiser",
    "joursForcesTitre": "Jours forcés ({n})",
    "joursForcesDesc": "Jours dont la garde a été changée à la main. Ils sont conservés lors d'un changement de configuration ; supprimez-en un pour qu'il reprenne la garde calculée.",
    "utile": "utile",
    "redondant": "redondant",
    "reinitJourTitre": "Réinitialiser ce jour ?",
    "reinitJourMsg": "Le {date} reprendra la garde calculée par la configuration.",
    "reinitialiser": "Réinitialiser",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "titre": "Gardes",
    "horsVacancesRythme": "Hors vacances — rythme",
    "ajouterPeriode": "Ajouter une période",
    "aucunRythme": "Aucune période de rythme. Touche ➕ pour en ajouter une.",
    "enCours": "en cours",
    "duAu": "du {debut} au {fin}",
    "duSansFin": "du {debut} · sans fin",
    "appliquer": "✓ Appliquer",
    "nePasAppliquer": "◯ Ne pas appliquer",
    "appliquerRythmeAcc": "Appliquer ce rythme ou non",
    "hintRythme": "Balaie à droite pour éditer, à gauche pour supprimer. La garde du rythme s'affiche automatiquement quand « ✓ Appliquer » est actif — sans rien écrire en base ; seuls tes échanges manuels et la répartition des vacances y sont stockés.",
    "semaineAlterneeAide": "« Semaine alternée » démarre le jour choisi, chez {nom}. Le cycle n'est pas calé au lundi.",
    "durantVacancesRepartition": "Durant les vacances — répartition",
    "ajouterGardeVacances": "Ajouter une garde vacances",
    "aucuneGardeVacances": "Aucune garde vacances. Touche ➕ pour en ajouter une.",
    "gardeVacancesLabel": "Garde vacances",
    "demiUnAnPair": "½1 an pair · {nom}",
    "demiUnAnImpair": "½1 an impair · {nom}",
    "debuteVeille": "Débute la veille au soir",
    "debutePremierJour": "Débute le 1er jour",
    "appliquerGardeVacancesAcc": "Appliquer cette garde vacances ou non",
    "hintGardeVacances": "Balaie à droite pour éditer, à gauche pour supprimer. La répartition s'applique aux vacances comprises dans la période active (« ✓ Appliquer »).",
    "repartitionParVacances": "Répartition par vacances",
    "aucunePeriodeVacances": "Aucune période de vacances. Ajoute-les dans « Vacances ».",
    "aucuneGardeVacancesCouvrant": "Aucune garde vacances appliquée sur cette période. Ajoute-en une couvrant {date}.",
    "appliquerGardeSurVacancesAcc": "Appliquer la garde sur cette vacances ou non",
    "supprimerPeriodeMsg": "Ce rythme sera retiré de la chronologie.",
    "supprimerGardeVacancesTitre": "Supprimer la garde vacances",
    "supprimerGardeVacancesMsg": "Cette période de répartition sera retirée.",
    "retablirRythme": "Tout rétablir au rythme",
    "retablirRythmeMsg": "Les {n} gardes échangées sélectionnées reviendront au rythme calculé (surcharges supprimées).",
    "retablirTitre": "Tout rétablir",
    "retablirRepartition": "Tout rétablir à la répartition",
    "retablirRepartitionMsg": "Les {n} gardes modifiées sélectionnées reviendront à la répartition (surcharges supprimées).",
    "repartitionCalculeeAide": "La répartition est calculée à l'affichage : rien n'est écrit en base tant que tu ne modifies pas un jour à la main.",
    "noteParents": "P1 = {p1} · P2 = {p2}. La garde par jour est partagée avec MoPCal.",
    "excTitre": "{n} exception(s) (garde échangée)",
    "filtreTousMois": "Tous mois",
    "aucuneExcFiltre": "Aucune exception sur ce filtre.",
    "hintExcSwipe": "Balaie à droite pour basculer le parent, à gauche pour rétablir.",
    "nouvellePeriode": "Nouvelle période",
    "modifierPeriode": "Modifier la période",
    "modeleGarde": "Modèle de garde",
    "nouveauModelePersoAcc": "Nouveau modèle personnalisé",
    "modifierModele": "Modifier le modèle",
    "aPartirDuJourDepart": "À partir du (jour de départ)",
    "jourDepart": "Jour de départ",
    "finCalculee": "Fin calculée : {fin}",
    "sansFinMin": "sans fin (en cours)",
    "laisseSansFinAide": "Laisse « sans fin » pour la période en cours, ou fixe une date de fin.",
    "cyclePersoDesc": "Cycle personnalisé · {n} sem.",
    "caleS1Impaires": " · calé (S1 = sem. impaires)",
    "caleS1Paires": " · calé (S1 = sem. paires)",
    "nouvelleGardeVacances": "Nouvelle garde vacances",
    "modifierGardeVacances": "Modifier la garde vacances",
    "aPartirDu": "À partir du",
    "jusquAu": "Jusqu'au",
    "premiereMoitiePaires": "1re moitié — années paires (2024, 2026…)",
    "premiereMoitieImpaires": "1re moitié — années impaires (2025, 2027…)",
    "pasAlternanceAide": "Pas d'alternance : {nom} a toujours la 1re moitié. La 2ᵉ revient à l'autre.",
    "alternanceAide": "Alternance annuelle : la 1re moitié passe d'un parent à l'autre chaque année. La 2ᵉ revient à l'autre.",
    "gardeCommenceVeille": "La garde commence la veille au soir",
    "gardeCommenceVeilleSub": "La veille du 1er jour revient au parent de la 1re moitié.",
    "choisisDateDebut": "Choisis une date de début.",
    "dateDebut": "Date de début",
    "modelePerso": "Modèle personnalisé",
    "phModelePerso": "Ex. 1 week-end sur 2",
    "dureeCycle": "Durée du cycle",
    "nSem": "{n} sem.",
    "calageCycle": "Calage du cycle",
    "semainesCalendrier": "Semaines calendrier",
    "s1CorrespondAux": "La 1re semaine (S1) correspond aux",
    "semainesPaires": "Semaines paires",
    "semainesImpaires": "Semaines impaires",
    "repartitionToucheCase": "Répartition (touche une case pour alterner)",
    "paritePaires": "paires",
    "pariteImpaires": "impaires",
    "aideCaleDeux": "Colonnes L→D (lundi→dimanche). S1 = semaines {parite} du calendrier, S2 = les autres. La date de départ ne sert qu'à démarrer l'application : le cycle reste calé sur les semaines.",
    "aideCaleMulti": "Colonnes L→D (lundi→dimanche). Les lignes S1…S{n} suivent le n° de semaine du calendrier. La date de départ ne sert qu'à démarrer l'application.",
    "aideNonCale": "J1 = jour de départ choisi à l'application (le cycle n'est pas calé au lundi).",
    "mdlAlternee": "Semaine alternée",
    "mdlAlterneeDesc": "Une semaine chez un parent, une chez l'autre.",
    "mdl223": "Garde 2-2-3",
    "mdl223Desc": "2 j / 2 j / 3 j, alternés sur 2 semaines.",
    "mdl2255": "Garde 2-2-5-5",
    "mdl2255Desc": "2 j chez chacun, puis 5 j chez chacun (cycle 14 j).",
    "mdl3443": "Garde 3-4-4-3",
    "mdl3443Desc": "3 j / 4 j alternés sur 2 semaines.",
    "mdlPerso": "Personnalisé",
    "errDejaDate": "Une période commence déjà à cette date.",
    "errRecouvre": "Cette période recouvre une période existante.",
    "errIntrouvable": "Période introuvable.",
    "errApresPrec": "La date doit être postérieure au rythme précédent ({date}).",
    "errAvantSuiv": "La date doit être antérieure au rythme suivant ({date}).",
    "errFinApresDebut": "La date de fin doit être postérieure au début.",
    "errFinAvantSuiv": "La fin doit précéder le rythme suivant ({date}).",
    "errSansFinImpossible": "« Sans fin » impossible : un rythme suit cette période.",
    "errGvApresPrec": "La date doit être postérieure à la période précédente ({date}).",
    "errGvAvantSuiv": "La date doit être antérieure à la période suivante ({date}).",
    "errGvFinAvantSuiv": "La fin doit précéder la période suivante ({date}).",
    "errGvSansFinImpossible": "« Sans fin » impossible : une période suit celle-ci."
  },
  "repas": {
    "titre": "Repas",
    "nouvelle": "Nouvelle recette",
    "modifier": "Modifier la recette",
    "aucune": "Aucune recette",
    "aucuneAide": "Touchez « + » pour créer votre première recette.",
    "sansNom": "(sans nom)",
    "nIngredients": "{n} ingrédient(s)",
    "nMin": "{n} min",
    "phNom": "Nom de la recette *",
    "portions": "Personnes",
    "temps": "Temps",
    "minutes": "min",
    "ingredients": "Ingrédients",
    "phIngredient": "Ingrédient",
    "qte": "Qté",
    "unite": "unité",
    "prix": "prix",
    "ajouterIngredient": "Ajouter un ingrédient",
    "preparation": "Préparation",
    "phEtape": "Décrivez l'étape…",
    "ajouterEtape": "Ajouter une étape",
    "supprimer": "Supprimer la recette",
    "supprTitre": "Supprimer la recette",
    "supprMsg": "Supprimer « {nom} » ?",
    "photoCamera": "Caméra",
    "photoGalerie": "Galerie",
    "permissionTitre": "Permission requise",
    "permissionPhotos": "Autorisez l'accès aux photos / à la caméra pour ajouter une image.",
    "planning": "Planning des menus",
    "erreur": "Erreur",
    "choisirCategorie": "Choisir une catégorie",
    "exporter": "Exporter les recettes",
    "importer": "Importer",
    "importTitre": "Importer des recettes",
    "importConfirm": "{n} recette(s) trouvée(s) dans le fichier. Les importer ?",
    "importAucune": "Aucune recette reconnue dans ce fichier (format MoPCal ou Schema.org/Recipe attendu).",
    "importOk": "{n} recette(s) importée(s).",
    "aucunRepas": "Aucun repas composé",
    "aucunRepasAide": "Touchez « + » pour composer votre premier repas à partir de vos recettes.",
    "editerRepas": "Modifier le repas",
    "nouveauRepas": "Nouveau repas",
    "supprimerRepas": "Supprimer le repas",
    "supprimerRepasMsg": "Supprimer « {nom} » ?",
    "phNomRepas": "Nom du repas (ex. Dîner léger)",
    "pour": "Pour",
    "personnes": "personnes",
    "recettes": "Recettes",
    "aucuneRecette": "Aucune recette. Ajoute-en depuis ta bibliothèque.",
    "ajouterRecette": "Ajouter une recette",
    "fermer": "Fermer",
    "toutesAjoutees": "Toutes les recettes sont déjà ajoutées (ou aucune recette créée).",
    "extras": "Extras (hors recette)",
    "phExtra": "Ingrédient (ex. Pommes)",
    "ajouterExtra": "Ajouter un extra",
    "perServ": "pers."
  },
  "repasPlan": {
    "titre": "Planning des menus",
    "menu": "Menu",
    "nouveauMenu": "Nouveau menu",
    "config": "Nombre de personnes",
    "aucun": "Aucun menu",
    "aucunAide": "Créez un menu-type hebdomadaire et assignez vos recettes aux repas de la semaine.",
    "nRepas": "{n} repas planifié(s)",
    "phNomMenu": "Nom du menu",
    "ajouter": "Ajouter…",
    "choisirRecette": "Choisir une recette",
    "viderCase": "Vider la case",
    "aucuneRecette": "Aucune recette — créez-en dans l'onglet Recettes.",
    "ouLibre": "Ou un texte libre",
    "phLibre": "Ex. Restaurant, restes…",
    "recetteSupprimee": "(recette supprimée)",
    "supprMenuTitre": "Supprimer le menu",
    "supprMenuMsg": "Supprimer « {nom} » ?",
    "moments": "Plages de repas du menu",
    "phMoment": "Nom du moment",
    "phHeure": "12:00",
    "momentsAide": "Les plages (déjeuner, dîner…) sont propres à CE menu. Heures facultatives (début → fin) : appliquées aux repas ajoutés au calendrier.",
    "de": "De",
    "a": "à",
    "ajouterMoment": "Ajouter un moment",
    "nbPersonnes": "Nombre de personnes",
    "momentsRequis": "Ajoutez au moins un moment de repas.",
    "genererCourses": "Générer la liste de courses",
    "coursesApercu": "Liste de courses",
    "coursesInfo": "Pour {n} personne(s) — quantités additionnées et mises à l'échelle.",
    "coursesVide": "Aucun ingrédient — assignez des recettes au menu.",
    "creerListe": "Créer la liste",
    "coursesTitre": "Courses —",
    "coursesOkTitre": "✓ Liste créée",
    "coursesOkMsg": "{n} ingrédient(s) ajouté(s) dans le module Listes.",
    "creerDepense": "Ajouter une opération au Budget (~ {c} €)",
    "aucunBudget": "Créez d'abord un budget dans le module Budget familial.",
    "budget": "Budget",
    "ajouterDepense": "Créer l'opération",
    "categorieAlim": "Alimentation",
    "depenseOkTitre": "✓ Opération créée",
    "depenseOkMsg": "L'opération a été ajoutée au budget choisi.",
    "datePrecise": "Modifier une date précise",
    "voirDate": "Voir cette date",
    "exceptionDe": "Exception du {date}",
    "exceptionAide": "Ces repas remplacent le menu-type pour cette date uniquement. Les moments laissés vides reprennent le menu-type (affichés en gris).",
    "reinit": "Réinitialiser",
    "reinitTitre": "Réinitialiser ce jour ?",
    "reinitMsg": "Le {date} reprendra le menu-type.",
    "exceptionsTitre": "Exceptions ({n})",
    "termine": "Terminé",
    "tab_semaines": "Semaines",
    "tab_menus": "Menus",
    "tab_recettes": "Recettes",
    "pourCourses": "Liste de courses",
    "auCalendrier": "Au calendrier",
    "enCours": "Application…",
    "masquerSansMenu": "Masquer les semaines sans menu",
    "afficherToutesSem": "Afficher toutes les semaines",
    "masquerPassees": "Masquer les semaines passées",
    "afficherPassees": "Afficher les {n} semaine(s) passée(s)",
    "menuSansRecette": "Ajoutez d'abord au moins une recette dans l'onglet « Recettes ».",
    "menuVide": "Ajoutez au moins une recette au menu avant d'enregistrer.",
    "appuiLongAjouter": "Appui long sur 💾 pour ajouter ce menu.",
    "aideGenererCourses": "Crée une liste de courses à partir des menus des semaines choisies.",
    "aideConfig": "Configure les moments de repas (déjeuner, dîner…) et le nombre de personnes.",
    "aideAjoutRecette": "Ajoute une nouvelle recette à la bibliothèque.",
    "aideAjoutMenu": "Crée un nouveau menu-type (une semaine de repas).",
    "aideAjoutSemaine": "Ajoute une semaine au planning pour y appliquer un menu.",
    "infoIconeAstuce": "Appui long sur une icône pour afficher son rôle.",
    "semaineDu": "Semaine du {date}",
    "aucunMenuSem": "Aucun menu",
    "choisirMenu": "Choisir un menu",
    "appliquee": "appliquée",
    "semActive": "Active (liste de courses)",
    "semInactive": "Inactive",
    "appliquerCal": "Appliquer au calendrier",
    "reappliquer": "Réappliquer",
    "ajouterSemaine": "Ajouter une semaine",
    "ajouterSemaineAide": "Choisissez une semaine à venir à ajouter à la liste.",
    "aucuneSemaine": "Aucune semaine. Touchez « + » en haut à droite pour en ajouter une.",
    "aucuneSemaineAjout": "Toutes les prochaines semaines sont déjà dans la liste.",
    "choisirMenuSem": "Appliquer un menu à cette semaine",
    "retirerMenuSem": "Retirer le menu de cette semaine",
    "semaineSansMenu": "Créez d'abord un menu (onglet Menus), puis appliquez-le à une semaine.",
    "remplacerTitre": "Remplacer les repas ?",
    "remplacerMsg": "La semaine du {date} a déjà des repas. Les remplacer ? Tes modifications de cette semaine seront écrasées.",
    "remplacer": "Remplacer",
    "retirerTitre": "Retirer le menu ?",
    "retirerMsg": "Supprimer les repas de la semaine du {date} du calendrier ?",
    "retirer": "Retirer",
    "semainesChoix": "Semaines à inclure",
    "nomListe": "Nom de la liste",
    "coursesNomDefaut": "Repas semaine {n}",
    "momentsDansMenu": "Les plages de repas (déjeuner, dîner…) se règlent dans chaque menu, via le ⚙️ de l'éditeur de menu.",
    "categories": "Catégories de recette",
    "categoriesAide": "Rangez vos recettes : petit-déjeuner, rapide en semaine, dessert… Une catégorie ne peut être supprimée que si aucune recette ne s'y trouve.",
    "categorieNonVide": "Cette catégorie contient encore des recettes.",
    "categoriesRequises": "Gardez au moins une catégorie.",
    "ajouterCategorie": "Ajouter une catégorie",
    "phCategorie": "Nom de la catégorie",
    "exporterPdf": "Exporter le menu en PDF",
    "pdfAucuneSemaine": "Sélectionnez au moins une semaine ayant un menu.",
    "menuVideFermer": "Ce menu est vide : aucun repas n'y est placé. Il sera supprimé si vous fermez maintenant.",
    "aucunRepas": "Aucun repas. Créez-en un dans l'onglet « Repas » : un repas peut ne contenir qu'une seule recette.",
    "coursesInfoCases": "Quantités mises à l'échelle du nombre de personnes de chaque case du menu",
    "menuAbandonner": "Des modifications de ce menu n'ont pas été enregistrées. Voulez-vous les abandonner ?",
    "abandonner": "Abandonner",
    "ioTitre": "Recettes",
    "ioImporter": "Importer des recettes",
    "ioImporterSous": "Depuis un fichier JSON (MoPCal ou Schema.org/Recipe)",
    "ioExporter": "Exporter des recettes",
    "ioExporterSous": "Choisis les recettes et le format",
    "ioExporterVide": "Aucune recette à exporter",
    "ioTitreCourt": "Importer / exporter",
    "ioAide": "Sauvegarde ou partage tes recettes (format MoPCal ou Schema.org/Recipe), et importe des recettes depuis un fichier.",
    "ioLabel": "Importer / exporter des recettes",
    "repasAucun": "Aucun repas",
    "repasAucunAide": "Compose un repas avec plusieurs recettes et des extras (fruits, pain…) pour bien remplir le panier de courses.",
    "aideExporterPdf": "Génère un PDF du menu des semaines (grille des repas, recettes et liste de courses).",
    "semainesTitre": "Semaines",
    "aucunMenuSemaine": "Aucun menu pour cette semaine",
    "applique": "Appliqué au calendrier",
    "detacher": "Détacher cette semaine",
    "detacherTitre": "Détacher la semaine",
    "detacherMsg": "Les repas posés sur cette semaine seront retirés du calendrier.",
    "inclureCourses": "Inclure aux courses",
    "versCourses": "Ajouter à la liste de courses",
    "coursesRien": "Rien à acheter pour les semaines cochées.",
    "coursesAjoutees": "{n} ingrédient(s) ajouté(s) à la liste de courses."
  },
  "ingredients": {
    "titre": "Ingrédients",
    "nouveau": "Nouvel ingrédient",
    "modifier": "Modifier l'ingrédient",
    "aucun": "Référentiel vide",
    "aucunAide": "Touchez « + » pour ajouter votre premier ingrédient. Réutilisable dans vos recettes.",
    "phNom": "Nom de l'ingrédient",
    "rayon": "Rayon",
    "unite": "Unité",
    "supprTitre": "Supprimer l'ingrédient",
    "supprMsg": "Supprimer « {nom} » ?",
    "perso": "Perso",
    "modifieBadge": "Modifié",
    "gerer": "Gérer mes ingrédients",
    "mesAjouts": "Mes ajouts ({n})",
    "aucunAjout": "Aucun ingrédient ajouté par vous.",
    "mesCorrections": "Mes corrections ({n})",
    "aucuneCorrection": "Aucun ingrédient de la base corrigé.",
    "original": "Original",
    "mesMasques": "Mes masqués ({n})",
    "aucunMasque": "Aucun ingrédient masqué.",
    "reafficher": "Réafficher",
    "nouvelleCategorie": "Nouvelle catégorie",
    "modifierCategorie": "Modifier la catégorie",
    "phCategorie": "Nom de la catégorie",
    "supprCategorieTitre": "Supprimer la catégorie",
    "categorieNonVideTitre": "Catégorie non vide",
    "categorieNonVideMsg": "Cette catégorie contient encore {n} ingrédient(s). Déplacez-les ou supprimez-les d'abord.",
    "categories": "Catégories",
    "mesAjoutsCategorie": "Mes catégories ajoutées ({n})",
    "aucunAjoutCategorie": "Aucune catégorie ajoutée par vous.",
    "mesCorrectionsCategorie": "Mes corrections de catégorie ({n})",
    "aucuneCorrectionCategorie": "Aucune catégorie de la base corrigée.",
    "mesMasquesCategorie": "Mes catégories masquées ({n})",
    "aucunMasqueCategorie": "Aucune catégorie masquée."
  },
  "courses": {
    "titre": "Courses",
    "ajouterArticle": "Ajouter un article",
    "viderCoches": "Vider les articles cochés",
    "aucune": "Liste de courses vide",
    "aucuneAide": "Ajoutez un article, ou ajoutez les ingrédients d'une recette ou d'un repas depuis leur fiche (🛒).",
    "coches": "Cochés ({n})",
    "ajouterALaListe": "Ajouter à la liste de courses",
    "pourCombien": "Pour combien de personnes ?",
    "ajusterAide": "Corrigez les quantités si besoin : elles seront fusionnées avec ce qui est déjà dans la liste.",
    "pas": "Pas",
    "pasAide": "Appuyez sur le pas pour passer de 1 à 10, puis à 100.",
    "ajoutTitre": "Ajouté à la liste",
    "ajoutMsg": "{n} ingrédient(s) ajouté(s) (ou fusionné(s)) à la liste de courses."
  },
  "profil": {
    "erreur": "Erreur",
    "enregistreTitre": "✓ Enregistré",
    "appliqueTitre": "✓ Appliqué",
    "monProfil": "Mon profil",
    "monRole": "Mon rôle",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "parent1Createur": "Parent 1 (créateur)",
    "createur": "Créateur",
    "coOrganisateur": "Co-organisateur",
    "utilisateur": "Utilisateur",
    "utilisateurs": "Utilisateurs",
    "visiteur": "Visiteur",
    "visiteurs": "Visiteurs",
    "enfant": "Enfant",
    "enfantBadge": "Enfant",
    "general": "Général",
    "profilEnfant": "Profil de l'enfant",
    "profilCalendrier": "Profil du calendrier",
    "prenomLabel": "Prénom :",
    "nomLabel": "Nom :",
    "changerNom": "Changer le nom",
    "changerMdp": "Changer le mot de passe",
    "resetMdpConfirm": "Un email pour réinitialiser ton mot de passe va être envoyé à {email}. Continuer ?",
    "resetMdpEnvoyer": "Envoyer l'email",
    "resetMdpEnvoyeTitre": "Email envoyé",
    "resetMdpEnvoye": "Un email de réinitialisation a été envoyé à {email}. Suis le lien reçu pour définir un nouveau mot de passe.",
    "changerEmail": "Changer l'email de connexion",
    "emailSystemeTitre": "Email système",
    "emailSysteme": "Cet email est celui d'un compte système (admin / commerce) et ne peut pas être modifié ici.",
    "emailInfoAuth": "Pour votre sécurité, saisissez votre mot de passe actuel. Un lien de vérification sera envoyé à la nouvelle adresse : le changement ne sera effectif qu'après avoir cliqué ce lien, puis vous être reconnecté.",
    "nouvelEmail": "Nouvel email",
    "motDePasseActuel": "Mot de passe actuel",
    "emailInvalide": "Adresse email invalide.",
    "emailIdentique": "C'est déjà votre email actuel.",
    "motDePasseRequis": "Saisissez votre mot de passe actuel.",
    "emailVerifTitre": "Vérifiez votre nouvelle boîte mail",
    "emailVerifEnvoye": "Un lien de vérification a été envoyé à {email}. Cliquez-le, puis reconnectez-vous pour finaliser le changement.",
    "envoyerLien": "Envoyer le lien",
    "prenomEnfantPlaceholder": "Prénom de l'enfant",
    "nomCalendrierPlaceholder": "Nom du calendrier",
    "iconeLabel": "Icône :",
    "couleurLabel": "Couleur :",
    "icone": "Icône",
    "couleur": "Couleur",
    "dateNaissanceLabel": "Date de naissance :",
    "dateNaissance": "Date de naissance",
    "ans": "ans",
    "villePrincipaleLabel": "Ville principale (pour la recherche de lieux) :",
    "villePlaceholder": "Ex : Gif-sur-Yvette, Paris…",
    "classeScolaire": "Classe scolaire",
    "classe": "Classe",
    "nonDefinie": "Non définie",
    "pasEncoreConnecte": "Pas encore connecté",
    "nomParent2Label": "Nom affiché (facultatif)",
    "nomParent2Placeholder": "Ex : Marie — évite d'afficher « Parent 2 »",
    "compteEnfantTitre": "Compte de l'enfant",
    "compteEnfantDesc": "Donne à l'enfant un accès avec son propre email de connexion. Ses droits (voir / ajouter / modifier / supprimer) se règlent comme pour un visiteur.",
    "permissionsEvenements": "Permissions événements",
    "permissions": "Permissions",
    "emailParent2Label": "Email du parent 2 :",
    "emailCoOrganisateurLabel": "Email du co-organisateur :",
    "aucunEmailDefini": "Aucun email défini",
    "emailPlaceholder": "Email…",
    "plusAjouter": "+ Ajouter",
    "aucunVisiteur": "Aucun visiteur",
    "aucunUtilisateur": "Aucun utilisateur",
    "configurationGarde": "Configuration de garde",
    "configurationGardeSub": "Mode Garde, alternance, jours spécifiques…",
    "evenementsRecurrents": "Événements récurrents",
    "evenementsRecurrentsSub": "Gérer les séries d'événements",
    "permissionsModalTitre": "Permissions — {nom}",
    "permissionsModalSousTitre": "Choisissez ce que cette personne peut faire avec les événements.",
    "permPeutProposer": "Peut proposer des événements",
    "permPeutProposerDesc": "L'événement sera soumis à approbation du parent gardien",
    "permPeutAjouter": "Peut ajouter des événements",
    "permPeutModifier": "Peut modifier des événements",
    "permPeutSupprimer": "Peut supprimer des événements",
    "ajouterAcces": "Ajouter un accès",
    "emailEnfantPlaceholder": "Email de l'enfant",
    "emailVisiteurPlaceholder": "Email du visiteur",
    "enfantLectureSeule": "L'enfant accèdera à son calendrier en lecture seule. Vous pourrez modifier ses permissions ensuite.",
    "intituleLabel": "Intitulé :",
    "precisezIntitule": "Précisez l'intitulé…",
    "classeDe": "Classe de {nom}",
    "actuelleLabel": "Actuelle :",
    "effacer": "Effacer",
    "aucuneClasse": "Aucune classe sélectionnée",
    "modeGarde": "Mode Garde",
    "modeGardeDesc": "Affiche les couleurs de garde, les indicateurs et la configuration du planning.",
    "impossibleSauvegarderMode": "Impossible de sauvegarder le mode.",
    "modeGardeDesactiveInfo": "Mode Garde désactivé : la configuration du planning est masquée et n'est pas appliquée.",
    "modeGardeActivezPour": "Activez-le pour configurer la garde.",
    "modeGardeSeulParent1": "Seul le Parent 1 peut l'activer.",
    "modeAlternance": "Semaines alternées",
    "modeAlternanceDesc": "Une semaine chez chaque parent",
    "modeJoursSpecifiques": "Jours spécifiques",
    "modeJoursSpecifiquesDesc": "Jours fixes chaque semaine",
    "modePersonnalise": "Personnalisé",
    "modePersonnaliseDesc": "Configuration sur mesure dans le calendrier",
    "modePersonnaliseInfo": "En mode personnalisé, configurez chaque jour directement dans le calendrier.",
    "aucuneRegleAuto": "Aucune règle automatique ne sera appliquée.",
    "aucunePeriodeConfiguree": "Aucune période configurée.",
    "indefini": "indéfini",
    "modifierConfigGarde": "Modifier la configuration de garde",
    "modelesPretsEmploi": "Modèles prêts à l'emploi",
    "modelesDesc": "Appliquer un planning type à {nom}, à partir d'aujourd'hui.",
    "ceCalendrier": "ce calendrier",
    "appliquerModeleTitre": "Appliquer « {modele} » ?",
    "appliquerModeleMsg": "Le planning de garde de {nom} sera généré à partir d'aujourd'hui selon ce modèle. Les jours déjà modifiés manuellement pourront être recalculés.",
    "appliquer": "Appliquer",
    "modeleAppliqueMsg": "Le planning de garde a été mis à jour. Consultez le calendrier pour le vérifier.",
    "modeDeGarde": "Mode de garde",
    "attribution": "Attribution",
    "jourChangementGarde": "Jour de changement de garde :",
    "semaineAppartientA": "Semaine {n} — appartient à :",
    "apercu": "Aperçu",
    "sem": "Sem",
    "pair": "pair",
    "impair": "impair",
    "attributionJours": "Attribution des jours",
    "nbSemainesCycle": "Nombre de semaines dans le cycle :",
    "schemaRepetePluriel": "Ce schéma se répète toutes les {n} semaines.",
    "schemaRepeteSingulier": "Ce schéma se répète toutes les {n} semaine.",
    "dateApplication": "Date d'application",
    "appliquerAPartirDu": "Appliquer ce mode à partir du :",
    "utilisezBoutonEnregistrer": "Utilisez le bouton enregistrer en haut.",
    "repartitionGardeVacances": "Répartition de la garde (vacances)",
    "repartitionVacancesDesc": "Comment la garde se répartit sur chaque période de vacances (½ 1 / ½ 2). Les périodes se chargent dans Famille → « Vacances & jours fériés ».",
    "moitie1": "½ 1 →",
    "moitie2": "½ 2 →",
    "alternerSelonAnnee": "Alterner selon l'année",
    "alternerSelonAnneeDesc": "Schéma ci-dessus pour les années paires, inversé pour les années impaires.",
    "recHebdo": "Hebdo — {jours}",
    "recBimensuel": "Toutes les 2 semaines",
    "recMensuel": "Chaque mois",
    "recurrencesTitre": "Récurrences — {nom}",
    "aucunEvenementRecurrent": "Aucun événement récurrent",
    "creezDepuisFormulaire": "Créez-en un depuis le formulaire d'événement",
    "sansTitre": "(Sans titre)",
    "depuis": "Depuis",
    "couleursTitre": "Couleurs — {nom}",
    "parent1Nom": "Parent 1 — {nom}",
    "parent2Nom": "Parent 2 — {nom}",
    "couleurDansCalendrier": "Couleur dans le calendrier :",
    "creerCalendrier": "Créer un calendrier",
    "typeCalendrier": "Type de calendrier",
    "typeEnfantSub": "Garde, demandes, anniversaire…",
    "typeGeneralSub": "Organisation familiale libre",
    "prenomEnfantRequis": "Prénom de l'enfant *",
    "nomCalendrierRequis": "Nom du calendrier *",
    "prenomEnfantExemple": "Ex: Lucas",
    "nomCalendrierExemple": "Ex: Courses, Travail, Maison…",
    "emailAutreParentOptionnel": "Email de l'autre parent (optionnel)",
    "emailCoOrganisateurOptionnel": "Email d'un co-organisateur (optionnel)",
    "aideRejoindre": "Cette personne pourra rejoindre ce calendrier en entrant votre email ({email}).",
    "rejoindreCalendrier": "Rejoindre un calendrier",
    "calendriersPartages": "Calendriers partagés avec vous",
    "aucuneInvitation": "Aucune invitation trouvée pour {email}. Demandez au créateur d'ajouter votre email, ou cherchez ci-dessous.",
    "creePar": "Créé par : {nom}",
    "rejoindreFleche": "Rejoindre →",
    "chercherParEmailCreateur": "Vous ne le voyez pas ? Cherchez par l'email du créateur",
    "aucunCalDispoEmail": "Aucun calendrier disponible pour cet email.",
    "resterConnecte": "Rester connecté sur cet appareil",
    "resterConnecteSous": "Désactive la déconnexion auto par inactivité. Cet appareil uniquement.",
    "votrePrenom": "Votre prénom",
    "emailConnexion": "Email de connexion",
    "fixe": "fixe",
    "emailContact": "Email de contact",
    "autreEmailFacultatif": "Autre email (facultatif)",
    "telephone": "Téléphone",
    "telephonePlaceholder": "Ex : 06 12 34 56 78",
    "ajouterDateNaissance": "Ajouter ma date de naissance",
    "adresse": "Adresse",
    "adressePlaceholder": "Adresse postale (facultatif)",
    "mesCalendriers": "Mes calendriers",
    "aucunCalendrier": "Aucun calendrier",
    "aucunCalendrierAide": "Créez un calendrier ou rejoignez celui d'un autre parent",
    "reordonnerTitre": "Ordre des calendriers",
    "reordonnerAide": "Réorganisez l'ordre d'affichage des calendriers. Ce réglage est propre à cet appareil. Astuce : appui long sur un calendrier pour réorganiser.",
    "calMasquer": "Masquer ce calendrier des sélecteurs",
    "calAfficher": "Afficher ce calendrier",
    "calendrierDefaut": "Calendrier",
    "monter": "Monter",
    "descendre": "Descendre",
    "monForfait": "Mon forfait",
    "gratuit": "Gratuit",
    "accesSansEcheance": "· accès sans échéance",
    "jusquAu": "· jusqu'au {date}",
    "sansPubBandeau": "Sans pub bandeau",
    "sansPubPleinEcran": "Sans pub plein écran",
    "demandeEnCours": "Demande en cours : passage à {plan}",
    "derniereDemandeRefusee": "Dernière demande refusée",
    "derniereDemandeRefuseeMotif": "Dernière demande refusée : {motif}",
    "voirForfaits": "Voir les forfaits",
    "voirForfaitsSub": "Comparer les offres et demander un changement",
    "valideurIVV": "Valideur (IVV)",
    "valideurIVVSub": "Faits techniques, rapport, outils flottants",
    "ivvRejoindre": "Rejoindre le calendrier IVV",
    "ivvQuitter": "Quitter le calendrier IVV",
    "ivvCalSub": "Calendrier partagé des validateurs (messagerie, versions). Vous choisissez de le rejoindre ou non.",
    "ivvQuitterTitre": "Quitter le calendrier IVV ?",
    "ivvQuitterMsg": "Vous ne verrez plus le calendrier IVV ni sa messagerie. Vous pourrez le rejoindre à nouveau plus tard.",
    "ivvQuitterDernierMsg": "C'est votre seul calendrier : en le quittant, vous reviendrez à l'écran de création / jonction de calendrier. Vous pourrez le rejoindre à nouveau.",
    "ivvQuitterBtn": "Quitter",
    "administration": "Administration",
    "administrationSub": "Utilisateurs, sécurité, configuration",
    "nouveauMotDePasse": "Nouveau mot de passe",
    "nouveauMdpPlaceholder": "Nouveau mot de passe (6 car. min)",
    "confirmerMotDePasse": "Confirmer le mot de passe",
    "couleurAvatar": "Couleur de l'avatar",
    "choisissezCouleurAvatar": "Choisissez une couleur pour votre avatar",
    "couleurParDefautRole": "Couleur par défaut (rôle)",
    "nosForfaits": "Nos forfaits",
    "forfaitActuelLabel": "Forfait actuel :",
    "choisissezForfait": "Choisissez un forfait pour envoyer une demande à l'administrateur.",
    "featCalendriersPluriel": "{n} calendriers",
    "featCalendriersSingulier": "{n} calendrier",
    "featEvenementsIllimites": "Événements illimités",
    "featEvenementsParJour": "{n} évén./jour",
    "featExportPdf": "Export PDF",
    "featSyncCalendrier": "Sync calendrier système",
    "featSansAucunePub": "Sans aucune publicité",
    "parMois": "/mois",
    "forfaitActuel": "Forfait actuel",
    "demandeEnCoursCourt": "Demande en cours…",
    "demandeDejaEnCours": "Demande déjà en cours",
    "demanderForfait": "Demander ce forfait",
    "paiementsNonActifs": "Les paiements ne sont pas encore actifs : l'accès est accordé manuellement par l'administrateur après acceptation.",
    "demandeEnvoyeeTitre": "Demande envoyée",
    "demandeEnvoyeeMsg": "Votre demande a été transmise à l'administrateur. Vous serez informé de sa décision.",
    "entrezPrenom": "Entrez votre prénom",
    "emailContactInvalide": "Email de contact invalide",
    "profilMaj": "Profil mis à jour",
    "mdpTropCourt": "Le mot de passe doit faire au moins 6 caractères.",
    "mdpNonIdentiques": "Les deux mots de passe ne correspondent pas.",
    "entrezPrenomEnfant": "Entrez le prénom de l'enfant",
    "entrezNomCalendrier": "Entrez le nom du calendrier",
    "seDeconnecter": "Se déconnecter",
    "confirmDeconnexionCal": "Voulez-vous vous déconnecter du calendrier « {nom} » ?",
    "deconnecter": "Déconnecter",
    "continuer": "Continuer",
    "soutienTitre": "Soutenir le développeur ☕",
    "soutienSous": "Faire un don et enlever les pubs",
    "rgpdTitre": "Mes données (RGPD)",
    "rgpdTexte": "Tes données sont hébergées de façon sécurisée sur Firebase (Google Cloud). Elles ne servent qu'au fonctionnement de l'application et ne sont ni vendues ni cédées. Tu peux à tout moment demander leur effacement.",
    "rgpdPolitique": "Lire la politique de confidentialité",
    "rgpdBouton": "Supprimer toutes mes données",
    "rgpdNote": "Effacera tes données personnelles et les calendriers dont tu es le seul membre. Les calendriers partagés seront simplement quittés (les autres membres les conservent). Ton compte de connexion est conservé. Action irréversible.",
    "rgpdConfirm1Titre": "Supprimer toutes tes données ?",
    "rgpdConfirm1Msg": "Cette action efface tes données personnelles et les calendriers dont tu es le seul membre. Les calendriers partagés seront quittés sans être supprimés pour les autres. C'est irréversible.",
    "rgpdConfirm2Titre": "Dernière confirmation",
    "rgpdConfirm2Msg": "Es-tu vraiment sûr(e) ? Toutes tes données seront définitivement effacées. Ton compte de connexion, lui, sera conservé.",
    "rgpdConfirmerFinal": "Tout supprimer",
    "rgpdFaitTitre": "Données supprimées",
    "rgpdFaitMsg": "Tes données ont été effacées. Tu vas être déconnecté(e).",
    "supprimerCalTitre": "⚠️ Supprimer le calendrier",
    "supprimerCalMsg": "Êtes-vous sûr de vouloir supprimer définitivement le calendrier « {nom} » ?\n\nTous les événements, les paramètres et les accès seront supprimés. Cette action est irréversible.",
    "supprimerDefinitivement": "Supprimer définitivement",
    "emailInvalideTitre": "Email invalide",
    "emailInvalideMsg": "Veuillez entrer une adresse email valide (ex : parent@email.com).",
    "entrezEmail": "Entrez l'email",
    "dejaAjouteTitre": "Déjà ajouté",
    "dejaAjouteMsg": "Cet email est déjà dans la liste",
    "confirmSupprimerVisiteur": "Supprimer {nom} ?",
    "modeGardeMaj": "Le mode de garde a été mis à jour.",
    "supprimerPeriodeTitre": "Supprimer cette période ?",
    "supprimerPeriodeMsg": "Le calendrier sera recalculé pour toutes les périodes restantes.",
    "repartitionAppliquee": "Répartition de garde des vacances appliquée au calendrier.",
    "supprimerSerie": "Supprimer la série",
    "supprimerSerieMsg": "Supprimer tous les événements récurrents \"{titre}\" ?",
    "classePrecision": "Précision (texte libre)",
    "classePrecisionPlaceholder": "Ex : école, enseignant, niveau spécifique…",
    "supprEspaceTitre": "Supprimer l'espace",
    "supprEspaceMsg": "« {nom} » sera supprimé pour tous ses membres. Les données qui y sont rattachées deviendront inaccessibles.",
    "changerCompte": "Changer de compte",
    "monCompte": "Mon compte",
    "parametresCompte": "Paramètres du compte",
    "nomUtilisateur": "Nom d'utilisateur",
    "nomUtilisateurPlaceholder": "Ex. Cédric",
    "nomUtilisateurAide": "Affiché partout dans la suite. Doit être unique.",
    "nomUtilisateurErreur": {
      "court": "Trop court (2 caractères minimum).",
      "long": "Trop long (30 caractères maximum).",
      "pris": "Ce nom d'utilisateur est déjà pris.",
      "inconnue": "Impossible d'enregistrer, réessaie."
    },
    "mesEspaces": "Mes espaces",
    "nEspacesSingulier": "{n} espace",
    "nEspacesPluriel": "{n} espaces",
    "aucunEspacePossede": "Aucun espace possédé",
    "nouvelEspace": "Nouvel espace",
    "espacesAideAvant": "Un espace regroupe des éléments (calendriers, inventaires, plans…) et les personnes qui y ont accès. Seul son",
    "proprietaireMot": "propriétaire",
    "espacesAideApres": "le voit et le configure ; les membres accèdent aux éléments qu'on partage avec eux.",
    "aucunEspaceAide": "Tu ne possèdes aucun espace. Touche ➕ pour en créer un.",
    "queFaireEspace": "Que faire de cet espace ?",
    "nMembresSingulier": "{n} membre",
    "nMembresPluriel": "{n} membres",
    "actifMin": "actif",
    "espacesAideMini": "Touche pour activer · balaie à droite pour éditer, à gauche pour supprimer (appui long sur le web) · ➕ pour créer.",
    "membresEspace": "Membres de l'espace",
    "nInviteSingulier": "{n} invité",
    "nInvitePluriel": "{n} invités",
    "moi": "(moi)",
    "proprietaire": "Propriétaire",
    "membre": "Membre",
    "inviteEnAttente": "Invité · en attente de sa 1re connexion à My Calendar",
    "emailAInviter": "e-mail à inviter",
    "membresAide": "La personne invitée rejoint l'espace à sa première connexion à My Calendar avec cet e-mail. Règle les accès ci-dessous.",
    "quiVoitQuoi": "Gestion des accès",
    "accesParMembre": "Accès par ressource",
    "quiVoitQuoiAide": "Par défaut, une ressource n'est visible que par son propriétaire. Ouvre l'accès ici, ressource par ressource : « Tout l'espace » ou une personne précise. Toi (propriétaire) gardes toujours l'accès.",
    "finance": "Finance",
    "budgetFinances": "Budget & finances",
    "budgetFinancesSous": "À venir — accès déjà réglable",
    "fonctionsSous": "Activer / désactiver · paliers · à la carte",
    "aPropos": "À propos",
    "supprimerMonCompte": "Supprimer mon compte",
    "supprimerMonCompteTitre": "Supprimer mon compte",
    "supprimerMonCompteMsg": "Ton compte et tes données seront supprimés définitivement après un délai de grâce. Cette action est irréversible passé ce délai. Confirmer ?",
    "versionMot": "version",
    "modulesComposant": "Modules composant cette application :",
    "moduleLecture": "lecture",
    "modifierEspace": "Modifier l'espace",
    "nomEspacePlaceholder": "Ex. Maison, Atelier, Boutique…",
    "voirCalIvv": "Voir les calendriers IVV",
    "voirCalIvvSous": "Ajoute les calendriers de suivi des versions à ta liste (valideurs).",
    "gestionSpecifique": "Gestion spécifique",
    "gestionGenerique": "Gestion générique",
    "gestionAutre": "Gestion autre",
    "surchargeFonctions": "Surcharger les fonctions (IVV)",
    "surchargeFonctionsSous": "Réécrit les autorisations du forfait pour tester — réservé aux valideurs",
    "calIvvVisibles": "Calendriers visibles",
    "calIvvVisiblesSous": "Choisir les calendriers IVV affiches dans la liste",
    "surchargeJetons": "Surcharger mes jetons (IVV)",
    "surchargeJetonsSous": "Forcer le nombre d'elements gerables, pour tester les cas limites",
    "membres": "Membres",
    "espace": "Espace",
    "rendreActif": "Rendre actif",
    "role_proprietaire": "Proprietaire",
    "role_membre": "Membre",
    "role_invite": "Invite",
    "sansLimiteJetons": "Desactiver la limite par jetons (IVV)",
    "sansLimiteJetonsSous": "Tout voir et creer sans quota, pour comparer avec et sans",
    "espacesCompteur": "{n}/{max} espace(s) possede(s)",
    "espacesMaxAtteint": "Maximum d'espaces atteint ({n}/{max}) : supprime un espace pour pouvoir en creer un autre.",
    "aproposVersion": "Version",
    "aproposCore": "Socle commun",
    "aproposEtat": "Mise a jour",
    "aproposCanal": "Canal",
    "aproposBundle": "Bundle",
    "aproposEditeur": "Editeur",
    "aproposBase": "Base"
  },
  "calendrier": {
    "semaineNum": "Sem. {n}",
    "aujourdhui": "Aujourd'hui",
    "evenements": "Événements",
    "maGardeUniquement": "Ma garde uniquement",
    "assigneAMoi": "Assigné à moi",
    "aucunEvenementPeriode": "Aucun événement sur cette période\nAppuyez sur un jour pour en ajouter",
    "horsGarde": "hors garde",
    "aucunCalendrier": "Aucun calendrier",
    "aucunCalendrierAide": "Créez un calendrier depuis l'onglet Profil pour commencer.",
    "legendeVacances": "Vacances",
    "legendeJourFerie": "Jour férié",
    "legendeModifie": "Modifié",
    "legendeDemEnvoyee": "Dem. envoyée",
    "legendeAApprouver": "À approuver",
    "aucunEvenementJour": "Aucun événement ce jour",
    "selectionnerPourModifier": "Sélectionnez un calendrier pour modifier",
    "demanderChangement": "Demander un changement",
    "modifierGarde": "Modifier la garde",
    "demandeEnvoyeeNote": "📬 Une demande sera envoyée à {prenom} pour approbation",
    "gardeActuel": "✓ actuel",
    "demander": "demander ›",
    "revenirPlanning": "↩ Revenir au planning",
    "titre": "Calendrier",
    "chargement": "Chargement du calendrier…",
    "aucunAccessible": "Aucun calendrier accessible",
    "aucunAccessibleAide": "Demande à un propriétaire d'espace de te donner accès à un calendrier, ou crée ton propre espace dans Profil.",
    "erreurLectureListe": "Tes calendriers n'ont pas pu être lus — ce qui suit peut être inexact.",
    "erreurLectureDemandes": "Les demandes n'ont pas pu être lues — la liste peut être incomplète.",
    "erreurLectureEvenements": "Les événements n'ont pas pu être lus — le calendrier peut être incomplet.",
    "erreurLectureEdt": "L'emploi du temps n'a pas pu être lu — il peut être incomplet.",
    "demandesCount": "Demandes ({n})",
    "configuration": "Configuration",
    "vacancesFeries": "Vacances & fériés",
    "gardesCoparentalite": "Gardes (co-parentalité)",
    "gardesDesactiveesTitre": "Gardes désactivées",
    "gardesDesactiveesMsg": "Ce calendrier est de type « Général ». Passe-le en « Co-parentalité » dans la Configuration pour gérer les gardes.",
    "ouvrirConfiguration": "Ouvrir la configuration",
    "demandeGardeEnvoyeeMsg": "Le changement de garde du {date} attend l'accord de {nom}.",
    "erreurAucunCalendrier": "Aucun espace/calendrier actif — impossible d'enregistrer.",
    "erreurEnregistrement": "Enregistrement impossible.",
    "supprEvtMsg": "« {titre} » sera supprimé.",
    "evtTitreGuillemets": "« {titre} »",
    "ignorerCeJour": "Ignorer ce jour",
    "supprimerTouteSerie": "Supprimer toute la série",
    "vueSemCourt": "Sem.",
    "ajouterEvenement": "Ajouter un événement",
    "filtres": "Filtres",
    "voirSemaineA11y": "Double-clic : voir la semaine",
    "legendeFerie": "Férié",
    "legendeEchange": "Échange (contour = garde prévue)",
    "ferieLigne": "🎉 {nom} (férié)",
    "demandesAAcquitter": "🧷 {n} demande(s) de garde à acquitter",
    "journee": "Journée",
    "aucunEvenementPoint": "Aucun événement.",
    "toucherPlusAjouter": " Touche ＋ pour en ajouter.",
    "gererRecurrence": "Gérer la récurrence",
    "touteLaJournee": "Toute la journée",
    "evtPlusieursJours": "Événement sur plusieurs jours",
    "lectureSeuleAide": "Lecture seule (droit d'écriture requis pour modifier).",
    "modifierEvenement": "Modifier l'événement",
    "nouvelEvenement": "Nouvel événement",
    "phTitreEvt": "Ex. Rendez-vous dentiste",
    "categorieOptionnel": "Catégorie (optionnel)",
    "aucuneCategorie": "Aucune catégorie",
    "dateDebut": "Date de début",
    "memeJour": "même jour",
    "jourEntier": "Jour entier",
    "heureDebut": "Heure de début",
    "heureFin": "Heure de fin",
    "heureFinRequise": "L'heure de fin est requise (sinon coche « Jour entier »).",
    "phNote": "Détails…",
    "piecesJointesOptionnel": "Pièces jointes (optionnel)",
    "repetition": "Répétition",
    "jours": "Jours",
    "jusquauOptionnel": "Jusqu'au (optionnel)",
    "repeterJusquau": "Répéter jusqu'au",
    "sansFin": "sans fin",
    "aucuneRecurrence": "Aucune récurrence. Crée‑en une via « Répétition » dans un nouvel événement.",
    "supprimerRecurrence": "Supprimer la récurrence",
    "supprRecurrenceMsg": "« {titre} » et toutes ses occurrences.",
    "inactifSuffixe": " (inactif)",
    "desDate": "dès {date}",
    "filtresIntro": "Décoche pour masquer, sur le calendrier affiché. Partagé par les vues Mois / Semaine / Jour.",
    "nMasques": "{n} masqué(s)",
    "toutAffiche": "Tout affiché",
    "types": "Types",
    "allerAuJour": "Aller au jour",
    "allerALaSemaine": "Aller à la semaine",
    "repetQuotidien": "Chaque jour",
    "repetHebdo": "Chaque semaine",
    "repetBimensuel": "Tous les 15 j",
    "repetMensuel": "Chaque mois",
    "rechercherCalendrier": "Rechercher un calendrier…",
    "switcherLegende": "★ ACTIF (toujours affiché) · 👁 AFFICHER EN PLUS",
    "switcherVide": "Aucun calendrier. Crée‑en un dans l'onglet Calendrier ou Profil.",
    "definirActif": "Définir comme actif",
    "sourceMopcal": "MoPCal (perso)",
    "sourceEspace": "Espace",
    "actifSuffixe": " · actif",
    "toujoursAffiche": "Toujours affiché (actif)",
    "masquer": "Masquer",
    "afficher": "Afficher",
    "switcherPied": "Gestion complète (créer, renommer, MoPCal perso) dans Profil → « Mes calendriers ».",
    "droitVoir": "Voir",
    "droitConfig": "Config",
    "configEnregistree": "Configuration enregistrée ✓",
    "configTitre": "Configuration du calendrier",
    "sectionType": "Type & gardes",
    "sousTitreCoparent": "Co-parentalité · gardes activées",
    "sousTitreGeneral": "Général · gardes désactivées",
    "introType": "Un calendrier de co-parentalité active les fonctions de garde (rythmes, répartition des vacances, couleurs par parent). En « Général », elles sont masquées.",
    "noteGardesGrisees": "« Gardes » sera grisé dans le menu (appui long) et les affichages de garde masqués.",
    "phNomParent": "Nom du parent {n}",
    "personneAssociee": "Personne associée (parmi les accès)",
    "aucune": "Aucune",
    "demandesChangement": "Demandes de changement",
    "demandesChangementSous": "Un changement de garde crée une demande à acquitter par l'autre parent (sinon appliqué directement).",
    "demandesChangementA11y": "Demandes de changement de garde",
    "noteInviterMembres": "Invite des membres (Profil → « Membres de l'espace ») pour pouvoir associer un e‑mail à un parent.",
    "introAffichage": "Grille horaire des vues Semaine et Jour.",
    "zoomCompact": "Compact",
    "zoomNormal": "Normal",
    "zoomLarge": "Large",
    "hauteurHeure": "Hauteur d'une heure (zoom)",
    "dureeDefaut": "Durée par défaut d'un événement",
    "vueDemarrage": "Vue au démarrage",
    "vueMois": "Mois",
    "vueSemaine": "Semaine",
    "vueJour": "Jour",
    "sectionAcces": "Accès des membres",
    "nMembres": "{n} membre(s)",
    "nInvites": "{n} invité(s)",
    "introAcces": "Qui peut voir ce calendrier, y écrire des événements et le configurer. Par défaut, chaque membre voit et écrit.",
    "pointerAcces1": "➕ Pour ajouter une personne, invite-la dans ",
    "pointerAccesFort": "Profil → « Membres de l'espace »",
    "pointerAcces2": " (par e‑mail). Elle apparaîtra ici dès qu'elle aura rejoint l'espace.",
    "noteSeulToi": "Cet espace ne compte que toi pour l'instant — invite des membres pour partager ce calendrier.",
    "aucunMembre": "Aucun membre dans l'espace.",
    "proprietaireAccesTotal": "Propriétaire · accès total",
    "proprietaire": "Propriétaire",
    "membre": "Membre",
    "inviteEnAttente": "Invité · en attente de sa 1re connexion à My Calendar",
    "noteInvitesDroits": "Les invités en attente prendront leurs droits (réglables) dès leur 1re connexion à My Calendar (une connexion à MoPCal ne suffit pas). ",
    "noteAppStricte": "Réglage enregistré sur le calendrier. L'application stricte côté serveur suit dans une prochaine version.",
    "modifierCal": "Modifier le calendrier",
    "nouveauCal": "Nouveau calendrier",
    "nomPlaceholder": "Ex. Perso, Boulot, Enfants…",
    "typeCal_general": "Général",
    "typeCal_coparentalite": "Co-parentalité",
    "actif": "actif",
    "aucunCal": "Aucun calendrier pour l'instant. Crée un espace (Mes espaces) ou demande un accès à un propriétaire.",
    "groupeMesEspaces": "De mes espaces",
    "aideMesEspaces": "Calendriers de tes espaces (tu en es propriétaire). Touche pour choisir l'ACTIF ; balaie à gauche pour supprimer, à droite pour éditer ; ➕ pour en créer.",
    "videMesEspaces": "Aucun calendrier dans tes espaces. Touche ➕ pour en créer un.",
    "supprCalTitre": "Supprimer le calendrier",
    "supprCalMsg": "« {nom} » et ses événements ne seront plus rattachés.",
    "groupePartages": "Partagés avec moi",
    "aidePartages": "Calendriers auxquels un propriétaire t'a donné accès. Touche pour choisir l'ACTIF ; la gestion appartient au propriétaire.",
    "partageAvecToi": "Partagé avec toi",
    "groupePerso": "Mes calendriers MoPCal (perso)",
    "aidePerso": "Des calendriers où tu es participant. Les afficher les superpose dans TA vue uniquement — ça n'expose rien aux autres membres de l'espace.",
    "afficheDansVue": "Affiché dans ma vue",
    "masque": "Masqué",
    "calendriersEspace": "Calendriers de l'espace",
    "accesDansProfil": "L'accès des membres se règle désormais dans Profil → « Qui voit quoi » — comme les inventaires et les plans.",
    "horsPlageTitre": "Événements hors plage",
    "horsPlageSous": "La grille s'étend pour montrer les événements en dehors des heures affichées (zones teintées).",
    "ficheDate": "Date",
    "ficheHoraire": "Horaire",
    "ficheDuree": "Durée",
    "ficheCalendrier": "Calendrier",
    "ficheNote": "Note",
    "badgeRecurrent": "🔁 Récurrent",
    "badgePlage": "🗓️ Plusieurs jours",
    "categories": "Catégories",
    "ficheType": "Type",
    "aideQuinzaineSimple": "Tous les 14 jours à partir de la date de début.",
    "aideQuinzaineJours": "Jours cochés, une semaine sur deux à partir de la semaine de la date de début.",
    "aideMensuelSimple": "Chaque mois, le même jour du mois que la date de début.",
    "aideMensuelJours": "Chaque mois, les jours cochés de la semaine n° {n} du mois.",
    "jusquau": "jusqu'au",
    "reinitFiltres": "Réinitialiser les filtres",
    "reinitMsg": "Quels filtres réinitialiser ? Tous les éléments seront réaffichés (à enregistrer avec la disquette).",
    "reinitOnglet": "Onglet {onglet}",
    "reinitTout": "Tous les filtres",
    "toutesLes": "Toutes les",
    "tousLes": "Tous les",
    "suffSemaines": "semaine(s)",
    "suffMois": "mois",
    "aideSemainesJours": "Jours cochés, une semaine sur {n} à partir de la première occurrence.",
    "aideTousLesNMois": "Appliqué tous les {n} mois.",
    "repetNSemaines": "Toutes les {n} semaines",
    "repetNMois": "Tous les {n} mois",
    "suffJours": "jour(s)",
    "repetNJours": "Tous les {n} jours",
    "afficherGarde": "Afficher la garde",
    "afficherVacances": "Afficher les vacances",
    "vueAnCourt": "An.",
    "repetJourCourt": "Jour",
    "repetSemCourt": "Semaine",
    "repetMoisCourt": "Mois",
    "joursIgnores": "Jours ignorés",
    "retablirAide": "Balaye une ligne vers la gauche pour rétablir ce jour dans la série (une occurrence déplacée revient à sa date d'origine).",
    "deplacerOccurrence": "Déplacer cet événement",
    "deplacerVersLe": "Déplacer au…",
    "ficheDeplace": "Déplacé",
    "evtsDeplacesTitre": "Événements déplacés hors période",
    "evtsDeplacesMsg": "Ces occurrences déplacées ne font plus partie de la nouvelle période de la récurrence. Que faire des événements correspondants ?",
    "garderEvts": "Garder les événements",
    "supprimerEvts": "Supprimer les événements",
    "menuSources": "SOURCES D'ÉVÉNEMENTS",
    "menuConfiguration": "CONFIGURATION",
    "pasAffichage": "Créneaux d'affichage (Semaine/Jour)",
    "rendreActif": "Rendre actif",
    "ficheCalAide": "Le calendrier ACTIF est celui qu'on ouvre par defaut. Balaie a droite pour editer, a gauche pour supprimer.",
    "changerEspace": "Deplacer vers un autre espace",
    "changerEspaceAide": "Vers un espace que tu POSSEDES : le calendrier suit, tu restes proprietaire. Vers l'espace de quelqu'un d'autre : tu le DONNES, la propriete change.",
    "deplacerSimple": "Ton espace — simple deplacement",
    "donnerEtiquette": "Espace d'un autre membre — tu donnes le calendrier",
    "aucunAutreEspace": "Aucun autre espace dont tu es membre.",
    "donnerTitre": "Donner ce calendrier ?",
    "donnerMsg": "Le proprietaire de « {espace} » devient proprietaire du calendrier. Tu perds la main dessus : tu ne pourras plus l'offrir, ni le rendre — seul le nouveau proprietaire le pourra. Tes offres de jetons sur ce calendrier seront retirees.",
    "donnerConfirmer": "Donner"
  },
  "evenements": {
    "erreur": "Erreur",
    "calendrierIntrouvable": "Calendrier introuvable",
    "supprimerEvenements": "Supprimer les événements",
    "supprimerNEvenements": "Supprimer {n} événements ?",
    "supprimerUnEvenement": "Supprimer 1 événement ?",
    "suppressionEchecN": "{n} événement(s) n'ont pas pu être supprimés.",
    "evenementRecurrentTitre": "🔁 Événement récurrent",
    "quoiSupprimer": "Que souhaitez-vous supprimer ?",
    "cetteOccurrence": "Cette occurrence",
    "cetteOccurrenceSeulement": "Cette occurrence seulement",
    "toutesLesOccurrences": "Toutes les occurrences",
    "supprimerEvenement": "Supprimer l'événement",
    "supprimerConfirmation": "Supprimer « {titre} » ?",
    "aucunCalendrier": "Aucun calendrier",
    "aucunCalendrierAide": "Ajoutez un enfant depuis l'onglet Profil.",
    "rechercherPlaceholder": "Rechercher un événement…",
    "periode": "Période",
    "sens": "Voir",
    "sensAvenir": "À venir",
    "sensPasse": "Passé",
    "sensTout": "Tout",
    "durantMaGarde": "Durant ma garde uniquement",
    "nSelectionnes": "{n} sélectionnés",
    "unSelectionne": "{n} sélectionné",
    "aucunResultat": "Aucun résultat pour « {recherche} »",
    "aucunEvenementPeriode": "Aucun événement sur cette période\nAppuyez sur un jour du calendrier pour en ajouter",
    "horsGarde": "hors garde",
    "gardeLabel": "Garde : {nom}",
    "ouvrirDansMaps": "Ouvrir dans Maps →",
    "ouvertureFichierImpossible": "Impossible d'ouvrir cette pièce jointe.",
    "evenementRecurrent": "Événement récurrent",
    "saisiManuellement": "Saisi manuellement",
    "creePar": "✨ Créé par ",
    "modifiePar": "✏️ Modifié par ",
    "commentaires": "Commentaires",
    "quelquun": "Quelqu'un",
    "aucunCommentaire": "Aucun commentaire pour l'instant",
    "commentairePlaceholder": "Écrire un commentaire…",
    "nPiecesJointes": "{n} pièces jointes",
    "unePieceJointe": "{n} pièce jointe",
    "recurrence": "Récurrence",
    "manuel": "Manuel",
    "modifie": "modifié",
    "visibilitePrive": "🔒 Privé",
    "visibiliteParents": "👥 Parents",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "catSport": "Sport",
    "catSante": "Santé",
    "catEcole": "École",
    "catAnniversaire": "Anniversaire",
    "catVacances": "Vacances",
    "catFamille": "Famille",
    "catActivite": "Activité",
    "catRdv": "Rendez-vous",
    "catRepas": "Repas",
    "catAutre": "Autre",
    "filtreRecurrents": "Récurrents",
    "filtrePonctuels": "Ponctuels",
    "typeSimple": "Simple",
    "typeRecurrent": "Récurrent",
    "typeRepas": "Repas",
    "typeEdt": "Emploi du temps"
  },
  "demandes": {
    "titre": "Demandes",
    "enAttenteResume": "{enAttente} réponse(s) en attente sur {total}",
    "statutApprouve": "Approuvé",
    "statutRefuse": "Refusé",
    "statutEnAttente": "En attente",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "toutValider": "Tout valider",
    "tousLesCalendriers": "tous les calendriers",
    "confirmToutValider": "Approuver les {nb} demande(s) en attente sur {portee} ?",
    "validationIncomplete": "Validation incomplète",
    "validationIncompleteMsg": "{echecs} demande(s) n'ont pas pu être approuvée(s).",
    "changementGarde": "Changement de garde",
    "ajoutEvenement": "Ajout d'événement",
    "refuserDemande": "Refuser la demande",
    "approuverDemande": "Approuver la demande",
    "demandePar": "Demandé par {nom} · {date}",
    "traitePar": "Traité par {nom}",
    "info": "(info)",
    "annulerDemande": "Annuler la demande",
    "annulerDemandeMsg": "Voulez-vous retirer cette demande ?",
    "ouiAnnuler": "Oui, annuler",
    "erreur": "Erreur",
    "retirerMaDemande": "Retirer ma demande",
    "ongletATraiter": "À traiter",
    "ongletMesDemandes": "Mes demandes",
    "ongletHistorique": "Historique",
    "autoAcquittee": "Auto — parent unique",
    "toutValiderDemandes": "Tout valider les demandes",
    "videATraiter": "Aucune demande à traiter",
    "videMesDemandes": "Aucune demande en cours",
    "videHistorique": "Historique vide",
    "approuver": "Approuver",
    "refuser": "Refuser",
    "messageOptionnel": "Message (optionnel)",
    "ajouterCommentaire": "Ajouter un commentaire...",
    "confirmer": "Confirmer",
    "statutAppliquee": "Appliquée",
    "statutAcquittee": "Acquittée ✓",
    "statutRefusee": "Refusée ✕",
    "statutAttente": "En attente…",
    "proposePar": "Proposé par {nom}",
    "unParent": "un parent",
    "vousSuffixe": " (vous)",
    "acquitter": "Acquitter ✓",
    "changementRetireMsg": "Le changement du {date} sera retiré.",
    "annulerMaDemande": "Annuler ma demande",
    "retirerLaDemande": "Retirer la demande",
    "retirerLaDemandeMsg": "La demande du {date} sera retirée.",
    "titreGarde": "Demandes de garde",
    "videGarde": "Aucune demande. Un double-appui sur un jour du calendrier propose un changement de garde à l'autre parent.",
    "sectionEnAttente": "En attente ({n})",
    "rechercher": "Rechercher (date, parent, message…)",
    "aucunResultat": "Aucune demande ne correspond à cette recherche.",
    "historiqueTronque": "{n} demandes sur {total} — cherchez une date pour voir les autres.",
    "filtreStatutTitre": "Filtrer par statut",
    "filtreToutes": "Toutes",
    "triTitre": "Trier",
    "triRecent": "Plus récentes d'abord",
    "triAncien": "Plus anciennes d'abord"
  },
  "listes": {
    "titre": "Listes & courses",
    "aucuneListe": "Aucune liste",
    "erreurLectureListes": "Les listes n'ont pas pu être lues — la liste ci-dessous peut être incomplète.",
    "erreurLectureItems": "Les éléments n'ont pas pu être lus — la liste ci-dessous peut être incomplète.",
    "nouvelleListe": "Nouvelle liste",
    "quotaTitre": "Limite atteinte",
    "quotaMsg": "Votre offre ne permet pas d'ajouter plus de listes. Passez à un forfait supérieur pour en créer davantage.",
    "renommer": "Renommer la liste",
    "phNomListe": "Nom de la liste…",
    "phAjouterItem": "Ajouter un élément…",
    "typeTaches": "Tâches",
    "typeCourses": "Courses",
    "listeVide": "Liste vide",
    "compteurSingulier": "{restants} restant · {total} au total",
    "compteurPluriel": "{restants} restants · {total} au total",
    "erreur": "Erreur",
    "supprListeTitre": "Supprimer la liste",
    "supprListeMsg": "Supprimer « {titre} » et tous ses éléments ?",
    "supprItemsTitre": "Supprimer les éléments",
    "supprItemsMsg": "Supprimer les {n} élément(s) sélectionné(s) ?",
    "nSelectionnes": "{n} sélectionné(s)",
    "icone_taches": "Tâches",
    "icone_courses": "Courses",
    "icone_cadeaux": "Cadeaux",
    "icone_voyage": "Voyage",
    "icone_repas": "Repas",
    "icone_ecole": "École",
    "droits": "Droits",
    "droitsTitre": "Droits — {titre}",
    "droitLire": "Voir",
    "droitModifier": "Modifier",
    "droitCocher": "Cocher",
    "aucunMembre": "Aucun membre à configurer",
    "cochePar": "✓ {nom} · {date}",
    "editerTache": "Modifier la tâche",
    "nom": "Nom",
    "quantite": "Quantité",
    "unite": "Unité",
    "prix": "Prix",
    "articlePrix": "Article (prix)",
    "prixIngredient": "Prix ingrédient",
    "totalEstime": "Total estimé",
    "justificatif": "Justificatif (ticket / facture)",
    "justifVide": "Aucun justificatif. Ajoute une photo du ticket de caisse ou de la facture.",
    "phQuantite": "Qté",
    "phUnite": "u, kg, L…",
    "commentaire": "Commentaire",
    "phCommentaire": "Ajouter un commentaire…",
    "photos": "Photos",
    "camera": "Caméra",
    "ajouterPhoto": "Galerie",
    "aucunePhoto": "Aucune photo",
    "supprPhotoTitre": "Retirer la photo",
    "supprPhotoMsg": "Retirer cette photo de la tâche ?",
    "permissionTitre": "Autorisation",
    "permissionPhotos": "Autorisez l'accès aux photos pour ajouter une image.",
    "catalogueTitre": "Référentiel produits",
    "piocherTitre": "Piocher un ingrédient",
    "piocheVide": "Ton référentiel est vide. Ajoute des produits via la carte « Référentiel produits ».",
    "piocheRecherche": "Rechercher un ingrédient…",
    "piocheTous": "Tous",
    "piocheAucun": "Aucun ingrédient ne correspond."
  },
  "plans": {
    "titre": "Plans & emplacements",
    "foyer": "Foyer",
    "aucunCalendrier": "Choisis un calendrier pour voir ses emplacements.",
    "aucunEmplacement": "Aucun emplacement pour ce foyer. Ajoute-en depuis un inventaire (structure des lieux).",
    "lieuVide": "Ce lieu n'a pas encore de sous-emplacement.",
    "aidePlan": "Touche un lieu pour y entrer. La pastille = nombre total d'objets rangés (avec les sous-lieux).",
    "aideListe": "Touche un lieu pour y entrer. La pastille = nombre total d'objets (avec les sous-lieux).",
    "recherchePlaceholder": "Chercher un article, un élément ou un lieu…",
    "aucunResultat": "Aucun résultat.",
    "editerPlan": "Éditer le plan",
    "editerPlanDe": "Plan de {nom}",
    "aPlacer": "À placer (touche-en un, puis une case du plan · double-tap sur le plan = retirer)",
    "editerStructure": "Modifier la structure des lieux",
    "structureFoyer": "Lieux du foyer",
    "structureDe": "Sous-lieux de {nom}",
    "structureVide": "Aucun lieu ici. Ajoutes-en un ci-dessous.",
    "structureAide": "Glisse une ligne pour la modifier ou la supprimer. ➕ ajoute un sous-lieu ; › entre dedans.",
    "ajouterLieu": "Ajouter un lieu",
    "ajouterSousLieu": "Ajouter un sous-lieu",
    "aidePastille": "Touche un lieu pour y entrer, sa pastille pour voir son contenu ci-dessous, ou le nom du lieu courant (fil d'Ariane) pour tout son contenu. Double-tap sur la pastille = fenêtre + recherche.",
    "ouvrirContenu": "Ouvrir en grand",
    "faireInventaire": "Faire l'inventaire de ce lieu",
    "lieuAucunObjet": "Aucun objet rangé ici.",
    "supprArticleMsg": "Supprimer « {nom} » ?",
    "supprElementMsg": "Supprimer l'élément « {nom} » et tous ses articles ?",
    "nLieux": "{n} lieux sélectionnés",
    "suffixeCopie": "(copie)",
    "rechercheContenu": "Filtrer les objets…",
    "type_lieu": "Lieu",
    "type_element": "Élément",
    "type_article": "Article",
    "creerEspaceMsg": "Crée un espace (Profil) pour ajouter un plan.",
    "configuration": "Configuration",
    "comptageEnregistre": "Comptage enregistré : {n} article(s) pointé(s).",
    "qrLieuInexistant": "Ce QR pointe un lieu qui n'existe plus dans cet espace.",
    "objetRangeNullePart": "{nom} est dans l'inventaire, mais rangé nulle part.",
    "codeAucunObjet": "Code {code} : aucun objet correspondant dans cet espace.",
    "supprLieuTitre": "Supprimer le lieu",
    "supprLieuMsg": "« {nom} » et ses sous-lieux seront supprimés. Les objets qui y sont rangés perdront leur emplacement (ils ne sont pas supprimés).",
    "titrePlansEmplacements": "Plans & Emplacements",
    "choisisPlan": "Choisis un plan",
    "aucunPlan": "Aucun plan",
    "aidePlanCreer": "Crée un plan (Maison, Garage, Cave…) avec « ＋ Plan » ci-dessus pour organiser tes lieux de rangement.",
    "aidePlanPartage": "Aucun plan partagé avec toi pour l'instant. Demande un accès à un propriétaire, ou crée un espace dans Profil.",
    "scannerAcc": "Scanner un QR de lieu ou un code-barres",
    "comptageEnCours": "Comptage en cours · {n} article(s) pointé(s)",
    "colonnesN": "Colonnes : {n}",
    "lignesN": "Lignes : {n}",
    "aPlacerTitre": "À placer",
    "aideMurs": "Touche un bord de case pour poser ou retirer la séparation choisie.",
    "aidePlacement": "Choisis un lieu « à placer » puis touche une case. Double-tap sur une tuile pour la retirer, appui long pour la renommer.",
    "lieuxEspace": "Lieux de l'espace",
    "contenuDe": "Contenu de « {nom} »",
    "aucunLieuNiveau": "Aucun lieu à ce niveau",
    "aucunLieuNiveauAide": "Touche ＋ en haut à droite pour en créer un.",
    "nObjets": "{n} objet(s)",
    "nSousLieux": "{n} sous-lieu(x)",
    "aideSwipeLignes": "Glisse une ligne : ← supprimer, → éditer / dupliquer.",
    "masquerVidesAcc": "Masquer les emplacements vides",
    "videsMasques": "Emplacements vides masqués · 🌿 pour tout afficher.",
    "typeLieu": "Lieu",
    "aucunLieuIci": "Aucun lieu ici",
    "aucunLieuIciAideEdit": "Touche 🌳 en haut pour créer tes lieux de rangement.",
    "rienAAfficher": "Rien à afficher.",
    "aucunObjetIci": "Aucun objet ici.",
    "aideTuiles": "Un tap sur une tuile montre son contenu, un double tap y entre. Appui long = sélection multiple.",
    "aucunContenuNiveau": "Aucun contenu à ce niveau.",
    "motifNonTrouve": "« {nom} » non trouvé",
    "motifAide": "Pourquoi ? (prêté, cassé, jeté, mal rangé…) — facultatif.",
    "phMotif": "Motif",
    "passer": "Passer",
    "rangerDans": "Ranger dans…",
    "rangerDansCourt": "Ranger dans",
    "racineSuffixe": "(racine)",
    "phNomLieu": "Ex. Cuisine, Placard du haut, Étagère B…",
    "arbreRangementPartage": "L'arbre de rangement partagé",
    "nouveauPlan": "Nouveau plan",
    "modifierPlan": "Modifier le plan",
    "selecteurAide": "Touche un plan pour l'ouvrir · appui long = renommer / supprimer.",
    "supprimerPlanTitre": "Supprimer le plan",
    "supprimerPlanMsg": "« {nom} » et sa structure de lieux seront supprimés (les objets rangés perdront leur emplacement).",
    "nomPlan": "Nom du plan",
    "nomPlanPlaceholder": "Ex. Maison, Garage, Cave…"
  },
  "inventaire": {
    "titre": "Inventaire / stock",
    "erreur": "Erreur",
    "nouvelInventaire": "Nouvel inventaire",
    "renommer": "Renommer l'inventaire",
    "aucunInventaire": "Aucun inventaire",
    "aucunCalendrier": "Choisis un calendrier pour gérer ton stock.",
    "phNomInventaire": "Nom de l'inventaire…",
    "partirDe": "Partir de…",
    "modeleVide": "Vide",
    "modeleVideDesc": "Tout créer soi-même",
    "nbCategories": "{n} catégories",
    "modeleInfo": "Le modèle chargera des catégories et des propriétés que tu pourras ensuite modifier : {desc}.",
    "supprInvTitre": "Supprimer l'inventaire",
    "supprInvMsg": "« {titre} » et tous ses éléments seront supprimés.",
    "nom": "Nom",
    "faireInventaire": "Faire l'inventaire",
    "modeEdition": "Mode édition",
    "proprietes": "Propriétés",
    "categorieRacine": "Nouvelle catégorie",
    "nPieces": "{n} pièces",
    "dernierInventaire": "Dernier inventaire :",
    "jamaisInventorie": "Jamais inventorié",
    "rechercher": "Rechercher un élément…",
    "hintEdition": "Mode édition (catégories) : touche l'emoji pour le changer · glisse une catégorie pour la modifier/supprimer · ➕ sur la ligne d'une catégorie pour lui ajouter une sous-catégorie · 🏷️ pour les propriétés. Les éléments s'ajoutent avec le bouton ➕ (hors de ce mode).",
    "ajouterSousCategorieIci": "ajouter une sous-catégorie ici",
    "ajouterCategorieRacine": "ajouter une catégorie",
    "exporter": "Exporter",
    "exportChoix": "Choisis ce que tu veux exporter :",
    "exporterModele": "Exporter la structure (modèle)",
    "exporterModeleDesc": "Catégories et propriétés uniquement ({n} catégories). Idéal pour réutiliser ou partager l'organisation.",
    "exporterComplet": "Exporter l'inventaire complet",
    "exporterCompletDesc": "Structure + tous les objets ({n}). Idéal pour une sauvegarde ou un transfert.",
    "exportInclurePhotos": "Inclure les photos",
    "exportInclurePhotosDesc": "Concerne l'export complet : les photos (objets, articles, catégories) sont intégrées au fichier — celui-ci devient plus lourd, mais autonome et ré-importable partout.",
    "exportEnCours": "Génération du fichier… (les photos sont téléchargées et intégrées, cela peut prendre un moment).",
    "exportPdfTitre": "PDF (impression / partage)",
    "exportPdfDesc": "Un document lisible, groupé par catégorie.",
    "pdfRecap": "PDF — récapitulatif",
    "pdfRecapDesc": "Quantités actuelles affichées. Pour partager ou archiver.",
    "pdfComptage": "PDF — feuille de comptage",
    "pdfComptageDesc": "Colonne vierge « à compter » + case à cocher. Pour l'inventaire papier.",
    "pdfOptPhotos": "PDF : inclure les photos",
    "pdfOptProps": "PDF : inclure les propriétés",
    "pdfOptVides": "PDF : inclure les catégories vides",
    "exportPhotosNote": "Les photos ne sont pas encore incluses dans l'export (bientôt).",
    "importerFichier": "Importer un fichier…",
    "importerFichierDesc": "Charge un inventaire exporté (modèle ou complet .json).",
    "importInvalide": "Fichier non reconnu : ce n'est pas un export d'inventaire MoPCal valide.",
    "importTitreDefaut": "Inventaire importé",
    "importPartielTitre": "Import partiel",
    "importPartielMsg": "{ajoutes} objets importés. {ignores} n'ont pas pu être ajoutés (limite d'objets de votre offre atteinte).",
    "hintAjout": "Mode ajout d'éléments : touche « + ajouter un élément ici » sous une catégorie. Retouche ➕ en haut pour quitter ce mode.",
    "hintVidesMasquees": "Éléments et catégories vides masqués · retouche 🌿 pour tout afficher.",
    "masquerCategoriesVides": "Masquer les catégories vides",
    "afficherCategoriesVides": "Afficher les catégories vides",
    "ajouterElement": "Ajouter un élément",
    "aucunElement": "Aucun élément trouvé.",
    "arbreVide": "Cet inventaire est vide. Active le mode édition ⚙️ pour créer des catégories.",
    "arbreVideEdit": "Touche « + ajouter une catégorie » ci-dessous pour créer une première catégorie.",
    "nonClasse": "Non classé",
    "ajouterElementIci": "ajouter un élément ici",
    "compteLe": "compté le",
    "jamaisCompte": "jamais compté",
    "dateInventaire": "Date de l'inventaire",
    "dateInventaireAide": "Choisis la date à laquelle l'inventaire a été (ou est) réalisé. Par défaut aujourd'hui ; tu peux mettre une date passée.",
    "demarrer": "Démarrer",
    "inventaireDu": "Inventaire du {date}",
    "hintSession": "Touche l'icône d'un article pour le pointer : ❔ indéterminé → ✅ présent → ❌ non trouvé. L'icône ⌖ le déplace, 💬 note une raison si non trouvé. 💾 enregistre, ✕ annule.",
    "pointer": "Pointer l'article",
    "deplacer": "Déplacer l'article",
    "raison": "Raison (non trouvé)",
    "raisonTitre": "Pourquoi non trouvé ?",
    "raisonAide": "Explique pourquoi l'article n'a pas été trouvé (prêté, perdu, jeté…). Cette note reste sur l'article et dans son historique d'inventaire.",
    "raisonPlaceholder": "Ex. : prêté à Paul, perdu, jeté…",
    "indetermine": "Indéterminé",
    "histInvTitre": "Historique d'inventaire",
    "historiqueInventaires": "Historique des inventaires",
    "aucunHistorique": "Aucun inventaire enregistré pour le moment.",
    "nbArticlesPointes": "{n} article(s) pointé(s)",
    "rechercheHist": "Chercher un article ou un élément…",
    "aucunResultat": "Aucun résultat",
    "achat": "Achat",
    "prixPlaceholder": "Prix (€)",
    "dateAchat": "Date d'achat",
    "ticketFacture": "Ticket / facture",
    "exporterPdf": "Exporter en PDF",
    "verifie": "Vérifié",
    "categorie": "Catégorie",
    "nouvelleCategorie": "Nouvelle catégorie",
    "sousCategorie": "Nouvelle sous-catégorie",
    "modifierCategorie": "Modifier la catégorie",
    "icone": "Icône",
    "iconeCategorie": "Icône de la catégorie",
    "phNomCategorie": "Ex. Jouets, Livres…",
    "structure": "Structure",
    "ajouterSousCategorie": "Ajouter une sous-catégorie",
    "deplacerVers": "Déplacer sous une autre…",
    "deplacerTitre": "Déplacer vers…",
    "racine": "Racine",
    "supprCatTitre": "Supprimer la catégorie",
    "supprCatMsgN": "{n} élément(s) ici (ou en sous-catégorie) repasseront en « Non classé ».",
    "supprCatMsgVide": "Catégorie vide.",
    "proprietesTitre": "Propriétés de la liste",
    "proprietesIntro": "Champs en plus sur chaque élément (facultatif).",
    "aucunePropriete": "Aucune propriété.",
    "ajouterPropriete": "ajouter une propriété",
    "nouvellePropriete": "Nouvelle propriété",
    "phNomPropriete": "Ex. Taille, Marque, Date d'achat",
    "type": "Type",
    "type_texte": "Texte",
    "type_nombre": "Nombre",
    "type_date": "Date",
    "type_liste": "Liste",
    "options": "Options (séparées par des virgules)",
    "phOptions": "Rouge, Bleu, Vert",
    "phDate": "AAAA-MM-JJ",
    "fiche": "Fiche de l'élément",
    "element": "Élément",
    "article": "Article",
    "seuil": "seuil",
    "seuilBas": "Seuil bas (alerte)",
    "seuilDesactive": "Aucune alerte de stock bas pour cet objet.",
    "seuilElement": "Seuil de détection (élément)",
    "seuilElementAide": "Alerte si la quantité totale passe sous un seuil. Le seuil de chaque article multiple se règle sur l'article.",
    "quantite": "Quantité",
    "nouvelElement": "Nouvel élément",
    "modifierElement": "Modifier l'élément",
    "phNomElement": "Ex. Slips taille 6 ans",
    "detailleSomme": "Élément détaillé → la quantité est la somme des articles. Modifie les articles depuis la fiche.",
    "detaillerParArticle": "Détailler par article",
    "voirArticles": "Voir / masquer les articles",
    "exemplaireUnique": "Exemplaire unique",
    "uniqueAide": "Objet unique : présent ou absent (pas de quantité).",
    "multipleAide": "Objet en plusieurs exemplaires : quantité comptée.",
    "present": "Présent",
    "absent": "Absent",
    "articlesN": "Articles ({n}) — total {total}",
    "ajouterArticle": "ajouter un article",
    "nouvelArticle": "Nouvel article",
    "modifierArticle": "Modifier l'article",
    "nomArticle": "Nom de l'article",
    "elementParent": "Élément (rattachement)",
    "emplacement": "Emplacement",
    "emplacements": "Emplacements",
    "emplacementsAide": "Mode structure : glisse un emplacement pour le modifier ou le supprimer, ➕ pour ajouter un sous-emplacement.",
    "emplacementsPlanAide": "Mode plan : touche 🗺 sur un emplacement pour placer ses sous-emplacements sur une grille 2D.",
    "emplacementsApercu": "Où sont rangés les objets (Maison › Cuisine › Placard 1). En haut à droite : ✏️ modifier la structure · 🗺 configurer le plan.",
    "editerStructure": "Modifier la structure",
    "editerPlan": "Modifier le plan",
    "aucunEmplacement": "Aucun",
    "aucunEmplacementDef": "Aucun emplacement défini. Ajoute-en un pour ranger tes objets par endroit.",
    "gererEmplacements": "Gérer",
    "ajouterEmplacement": "ajouter un emplacement",
    "ajouterSousEmplacement": "+ sous-emplacement",
    "modifierEmplacement": "Modifier l'emplacement",
    "nouvelEmplacement": "Nouvel emplacement",
    "sousEmplacement": "Sous-emplacement",
    "phNomEmplacement": "Ex. Placard 1, Garage, Chez Paul…",
    "filtrerEmplacement": "Filtrer par emplacement",
    "toutInventaire": "Tout l'inventaire",
    "sansEmplacement": "Sans emplacement",
    "emplacementVide": "Aucun objet rangé ici pour le moment.",
    "consommable": "Consommable",
    "consommableAide": "Article qui se consomme et se rachète (nourriture, hygiène, papier…). Sert au filtre 🛒.",
    "filtrerConsommables": "Afficher seulement les consommables",
    "aucunConsommable": "Aucun article consommable pour le moment.",
    "plan": "Plan",
    "planAide": "Place les sous-emplacements sur la grille : touche une tuile pour la sélectionner, puis une case vide pour la déplacer. Ajuste la taille, le nombre de colonnes et de lignes. Pense à 💾 en haut à droite pour enregistrer.",
    "planSelAide": "Touche une tuile pour la sélectionner, puis une case pour la déplacer.",
    "planMursAide": "Mode murs : choisis mur fin, mur épais, porte ou fenêtre, puis touche une bordure (y compris sur le contour) pour la poser. Retouche le même endroit pour l'enlever. Pense à 💾 pour enregistrer.",
    "planMursSelAide": "Touche une bordure (intérieure ou sur le contour) pour poser / retirer la séparation choisie.",
    "planPlacer": "Placer",
    "planMurs": "Murs",
    "planMurFin": "Fin",
    "planMurEpais": "Épais",
    "planPorte": "Porte",
    "planFenetre": "Fenêtre",
    "planForme": "Forme libre",
    "planFormeSelAide": "Forme libre : touche une case voisine pour l'ajouter à la zone (ou une case de la zone pour la retirer). Permet les pièces en L.",
    "planVide": "Ajoute d'abord des sous-emplacements pour pouvoir les positionner.",
    "planViewAide": "Touche une zone pour entrer dans le sous-emplacement. La flèche « ‹ » en haut remonte d'un niveau.",
    "colonnes": "Colonnes",
    "lignes": "Lignes",
    "taille": "Taille",
    "ouEstCeRange": "Où est-ce rangé ?",
    "voirPlan": "Voir le plan",
    "emplacementParentLieu": "Emplacement parent",
    "racineLieu": "Racine (aucun parent)",
    "choisirEmplacement": "Choisir un emplacement",
    "choisirElement": "Rattacher à un élément",
    "gererArbreLieux": "Gérer l'arbre des lieux",
    "lieuCalendrier": "Lieu du calendrier (adresse)",
    "aucunLieuCal": "Aucun",
    "rangerElement": "Lieu de tout l'élément",
    "rangerElementAide": "Choisis un lieu : il sera appliqué à TOUS les articles de « {nom} ».",
    "lieuxMultiples": "lieux multiples",
    "rangerIci": "Ranger ici",
    "rangerIciVers": "Ranger dans {emp}",
    "rangementEnCours": "Rangement en cours",
    "rangementAide": "Scanne des produits : ils se rangent ici.",
    "terminer": "Terminer",
    "imprimerQr": "Imprimer les QR (à coller)",
    "qrAide": "Imprime un QR par emplacement, colle-le sur le meuble. Ensuite, scan-le (bouton 📷) pour voir tout ce qui est rangé dedans.",
    "qrInconnuTitre": "QR d'un autre inventaire",
    "qrInconnuMsg": "Ce QR d'emplacement n'appartient pas à cet inventaire.",
    "supprEmpTitre": "Supprimer l'emplacement",
    "supprEmpMsg": "Les objets rangés ici perdront leur emplacement (ils ne sont pas supprimés).",
    "elementParentDeplace": "L'article sera déplacé vers cet élément.",
    "scanner": "Scanner un code-barres",
    "scanRapide": "Scan rapide",
    "dejaDans": "Déjà présent dans « {cat} ».",
    "dejaUnique": "C'est un exemplaire unique. Ajouter quand même un autre exemplaire ?",
    "ouvrirObjet": "Ouvrir l'objet",
    "creerQuandMeme": "Créer un nouvel objet",
    "passerMultiple": "Passer en multiple (+1)",
    "creerNouveauDistinct": "Créer un objet distinct",
    "scannerSuivant": "Scanner le suivant",
    "recherche": "Recherche…",
    "rechercheProduit": "Recherche du produit…",
    "enregistrement": "Enregistrement…",
    "codeBarres": "Code-barres",
    "produitIntrouvableTitre": "Produit introuvable",
    "produitIntrouvableMsg": "Ce code-barres n'a pas été trouvé dans les bases publiques (livres, alimentaire). Le code est enregistré ; complète les infos à la main.",
    "produitReseau": "Impossible de joindre les bases publiques. Vérifie ta connexion.",
    "phNomArticle": "Ex. Slip rouge",
    "supprimerArticle": "Supprimer cet article",
    "photo": "Photo",
    "photos": "Photos",
    "camera": "Caméra",
    "galerie": "Galerie",
    "permissionTitre": "Autorisation",
    "permissionPhotos": "Autorisez l'accès aux photos pour ajouter une image.",
    "inventairesPlans": "Inventaires & plans",
    "supprModeleTitre": "Supprimer le modèle",
    "supprModeleMsg": "« {nom} » sera retiré de tes modèles.",
    "titreDefaut": "Inventaire",
    "titrePluriel": "Inventaires",
    "aucunInvAideCreer": "Touche ＋ en haut à droite pour en créer un, à partir d'un modèle ou de zéro.",
    "aucunInvEspace": "Aucun inventaire dans cet espace.",
    "aucunInvPartage": "Aucun inventaire partagé avec toi. Crée un espace dans Profil pour en créer, ou demande un accès à un propriétaire.",
    "nbCategoriesN": "{n} catégorie(s)",
    "sansCategorie": "Sans catégorie",
    "nProprietes": "{n} propriété(s)",
    "astuceAppuiLong": "Appui long sur un inventaire pour le modifier.",
    "astuceSwipe": "Glisse une ligne : ← supprimer, → éditer.",
    "modifierInventaire": "Modifier l'inventaire",
    "phTitreInventaire": "Ex. Placards de la cuisine",
    "partirModele": "Partir d'un modèle",
    "inventaireVide": "Inventaire vide",
    "inventaireVideDesc": "Je crée mes catégories moi-même",
    "mesModeles": "Mes modèles",
    "structureEnregistree": "Structure enregistrée",
    "modeleMeta": "{c} catégorie(s) · {p} propriété(s)",
    "appuiLongSupprimer": "appui long pour supprimer",
    "modelesPrets": "Modèles prêts",
    "modeleEnregistre": "Modèle « {nom} » enregistré — réutilisable à la création.",
    "supprElementTitre": "Supprimer l'élément",
    "elementSeraSupprime": "« {nom} » sera supprimé.",
    "supprArticleTitre": "Supprimer l'article",
    "trouve": "Trouvé : {nom}",
    "codeInconnu": "Code {code} inconnu ici — nouvel élément.",
    "supprCatMsgBase": "« {nom} » et ses sous-catégories seront supprimées.",
    "supprCatMsgElements": " {n} élément(s) passera(ont) en « sans catégorie ».",
    "importe": "Importé : {n} élément(s).",
    "nArticles": "{n} article(s)",
    "compter": "Compter",
    "sousCategorieAcc": "Sous-catégorie",
    "structureInventaire": "Structure de l'inventaire",
    "structureInventaireSous": "Catégories, sous-catégories et éléments (boutons + swipe)",
    "proprietesPersonnalisees": "Propriétés personnalisées",
    "proprietesPersoSous": "Champs additionnels des articles (auteur, état…)",
    "enregistrerModele": "Enregistrer comme modèle",
    "enregistrerModeleSous": "Réutiliser cette structure (catégories + propriétés) sur un autre inventaire",
    "exporterTransferer": "Exporter / transférer",
    "exporterTransfererSous": "Partager l'inventaire avec un autre compte (données incluses)",
    "reglagesDe": "Réglages de « {nom} ».",
    "cetInventaire": "l'inventaire",
    "scannerAcc": "Scanner",
    "transfererAcc": "Transférer",
    "imprimerAcc": "Imprimer",
    "configArbreBarre": "Configuration de l'arbre · swipe ← supprimer / → éditer",
    "nPiecesN": "{n} pièce(s)",
    "rechPlaceholder": "Nom, article ou code-barres",
    "hintVides": "Catégories vides masquées · 🌿 pour tout afficher.",
    "aucunElementVide": "Aucun élément",
    "aucunElementAide": "Touche ＋ pour en ajouter un, ou 📷 pour scanner un produit.",
    "aucuneCategorie": "Aucune catégorie",
    "aucuneCategorieAide": "Touche ＋ pour en créer une.",
    "modeleInfoDetail": "Seule la structure est enregistrée : {c} catégorie(s) et {p} propriété(s). Les articles ne sont pas inclus. Réutilisable à la création d'un autre inventaire.",
    "nomModele": "Nom du modèle",
    "phNomModele": "Ex. Bibliothèque par genre",
    "rangerDansTitre": "Ranger dans…",
    "rangerDansLabel": "Ranger dans",
    "phNomCategorieEx": "Ex. Conserves, Hauts…",
    "supprProprieteTitre": "Supprimer la propriété",
    "supprProprieteMsg": "« {nom} » sera retirée des articles.",
    "modifierPropriete": "Modifier la propriété",
    "proprietesPersoTitre": "Propriétés personnalisées",
    "phProprieteExemple": "Ex. Auteur, Éditeur, État…",
    "optionsParLigne": "Options (une par ligne)",
    "phOptionsListe": "Neuf\nBon état\nUsagé",
    "proprietesPersoIntro": "Ces champs s'ajoutent à chaque article de l'inventaire.",
    "aucuneProprietePerso": "Aucune propriété pour l'instant.",
    "transfTitre": "Transférer & imprimer",
    "transfTermine": "{libelle} : terminé.",
    "transfExportModele": "Export du modèle",
    "transfExportComplet": "Export complet",
    "transfExportPdf": "Export PDF",
    "transfPlancheQr": "Planche de QR",
    "transfImport": "Import",
    "transfAucunEmplacement": "Aucun emplacement : crée d'abord tes lieux dans l'onglet Plans.",
    "transfModeleTitre": "Modèle (structure seule)",
    "transfModeleDesc": "Catégories et propriétés, sans les objets — pour recréer le même inventaire ailleurs.",
    "transfCompletTitre": "Sauvegarde complète",
    "transfCompletDesc": "Structure + objets + emplacements, en JSON.",
    "transfEmbarquerPhotos": "Embarquer les photos",
    "transfEmbarquerPhotosDesc": "Fichier bien plus lourd, mais autonome (photos en base64).",
    "imprimer": "Imprimer",
    "transfPdfRecapTitre": "PDF récapitulatif",
    "transfPdfRecapDesc": "Les quantités actuelles, à archiver ou partager.",
    "transfPdfComptageTitre": "Feuille de comptage",
    "transfPdfComptageDesc": "Quantité connue en petit + colonne vierge à remplir sur le terrain.",
    "transfAvecPhotos": "Avec les photos",
    "transfAvecProprietes": "Avec les propriétés",
    "transfInclureCatsVides": "Inclure les catégories vides",
    "transfInclurePlans": "Inclure les plans 2D",
    "transfPlancheQrTitre": "Planche de QR d'emplacements",
    "transfPlancheQrDesc": "Une étiquette par lieu, à découper et coller sur le meuble.",
    "importerTitre": "Importer",
    "transfImportTitre": "Charger un fichier .json",
    "transfImportDesc": "Modèle ou sauvegarde complète, produit par My Inventory ou MoPCal.",
    "transfImportAide": "L'import CRÉE un nouvel inventaire — il ne remplace jamais celui-ci. Les identifiants sont régénérés, les liens catégories / emplacements / propriétés sont reconstruits.",
    "ficheQuantite": "Quantité : {n}",
    "detailsTitre": "Détails",
    "auteur": "Auteur",
    "editeur": "Éditeur",
    "parution": "Parution",
    "pages": "Pages",
    "retirerArticleTitre": "Retirer l'article",
    "retirerArticleMsg": "« {nom} » sera retiré de l'élément.",
    "sansNom": "sans nom",
    "codeInvalideMsg": "Ce code ne ressemble pas à un code-barres produit.",
    "codeInconnuMsg": "Code {c} enregistré, mais inconnu du référentiel — complète le nom à la main.",
    "codeEnregistreMsg": "Code {c} enregistré.",
    "codeReseauMsg": "Réseau indisponible — le code est enregistré, le nom reste à saisir.",
    "sourceReferentiel": "Référentiel",
    "sourcePublique": "Base publique",
    "phNomElementEx": "Ex. Boîtes de tomates",
    "seuilAlerteElement": "Seuil d'alerte de l'élément",
    "seuilAlerteAide": "Comparé à la quantité TOTALE de l'élément (tous articles confondus). 0 = pas d'alerte.",
    "articlesCount": "Articles ({n})",
    "articlesMultiAide": "Plusieurs articles = plusieurs déclinaisons du même objet (tailles, parfums, lots), chacune avec sa quantité, sa photo, son code-barres et son emplacement.",
    "articleN": "Article {n}",
    "commeElement": "Comme l'élément",
    "seuilArticle": "Seuil de l'article",
    "phCodeBarres": "Saisir ou scanner",
    "rangeDans": "Rangé dans",
    "nullePart": "Nulle part",
    "phAnnee": "AAAA",
    "prixAchat": "Prix d'achat (€)",
    "phDateJJMMAAAA": "JJ/MM/AAAA",
    "exemplaireUniqueInline": "Exemplaire unique : présent ou absent (pas de quantité).",
    "consommableInline": "Consommable : se consomme et se rachète (sert au filtre 🛒).",
    "iconeElement": "Icône de l'élément",
    "planCloison": "Cloison",
    "planMur": "Mur",
    "niveauSansSousEmplacement": "Ce niveau n'a pas de sous-emplacement à afficher.",
    "niveauAucun": "Aucun",
    "niveauLecteur": "Lecteur",
    "niveauEditeur": "Éditeur",
    "responsableAccesComplet": "Responsable : accès complet",
    "aucunMembreAutoriser": "Aucun autre membre à autoriser.",
    "aucunInventaireRegler": "Aucun inventaire à régler pour l'instant.",
    "supprPhotoTitre": "Supprimer la photo",
    "supprPhotoMsg": "Cette photo sera retirée de l'article.",
    "photosAide": "Touche une photo pour l'agrandir · appui long pour la retirer.",
    "scannerMixte": "Scanner un code-barres ou un QR",
    "viseMixte": "Vise un code-barres ou un QR",
    "viseBarcode": "Vise le code-barres du produit",
    "scanIndispoNatif": "Le scan par caméra n'est pas disponible ici. Saisis le code à la main.",
    "scanAutoriser": "Autorise l'accès à la caméra pour scanner.",
    "scanPreparation": "Préparation de la caméra…",
    "scanAutoriserBouton": "Autoriser la caméra",
    "scanRefusWeb": "Accès caméra refusé. Autorise-le dans les réglages du navigateur, ou saisis le code à la main.",
    "scanIndispoWeb": "Le scan n'est pas disponible ici. Saisis le code à la main.",
    "scanErreurWeb": "Impossible d'ouvrir la caméra. Saisis le code à la main.",
    "saisirManuel": "Saisir à la main",
    "tplGardeRobe": "Garde-robe",
    "tplGardeRobeDesc": "Vêtements, chaussures et accessoires par type",
    "tplPlacardsFrigo": "Placards & frigo",
    "tplPlacardsFrigoDesc": "Épicerie, conserves, frais, surgelés, boissons",
    "tplUstensilesCuisine": "Ustensiles de cuisine",
    "tplUstensilesCuisineDesc": "Cuisson, vaisselle, couverts, électroménager",
    "tplValiseVacances": "Valise / Vacances",
    "tplValiseVacancesDesc": "Check-list à emporter en voyage",
    "tplOutilsBricolage": "Outils & bricolage",
    "tplOutilsBricolageDesc": "Outils, quincaillerie, peinture, jardin",
    "tplJouetsJeux": "Jouets & jeux",
    "tplJouetsJeuxDesc": "Jouets des enfants par type",
    "tplBibliotheque": "Bibliothèque",
    "tplBibliothequeDesc": "Livres par genre",
    "tplPharmacie": "Pharmacie",
    "tplPharmacieDesc": "Médicaments et matériel de soin",
    "tplCaveVin": "Cave à vin",
    "tplCaveVinDesc": "Bouteilles par couleur et région",
    "tplSalleDeBain": "Salle de bain",
    "tplSalleDeBainDesc": "Hygiène, beauté, entretien",
    "typeTexte": "Texte",
    "typeNombre": "Nombre",
    "typeDate": "Date",
    "typeListe": "Liste de choix"
  },
  "budget": {
    "titre": "Budgets",
    "solde": "Solde",
    "equilibre": "Compte équilibré",
    "doit": "{debiteur} doit {montant} à {crediteur}",
    "totalPartage": "Dépensé",
    "estime": "Estimé",
    "inclureEstime": "Inclure l'estimé (récurrences à venir)",
    "aucunBudget": "Aucun budget",
    "nouveauBudget": "Nouveau budget",
    "modifierBudget": "Modifier le budget",
    "nomBudget": "Nom du budget",
    "emoji": "Emoji (optionnel)",
    "nomBudgetPlaceholder": "Ex : Vacances, École…",
    "membres": "Membres",
    "membresAide": "Peuvent ajouter des paiements.",
    "observateurs": "Observateurs",
    "observateursAide": "Peuvent seulement consulter.",
    "payeurs": "Payeurs (répartition)",
    "payeursAide": "Pourcentage à la charge de chacun. Le total devrait faire 100 %.",
    "pctOk": "Total : {total} %",
    "pctWarn": "Total : {total} % (devrait faire 100 %)",
    "nMembres": "{n} membre(s)",
    "nObservateurs": "{n} observateur(s)",
    "aucunMembreDispo": "Aucun participant sur ce calendrier.",
    "supprBudgetTitre": "Supprimer le budget",
    "supprBudgetMsg": "Supprimer « {nom} » et toutes ses opérations ?",
    "aucunPayeur": "Aucun payeur défini.",
    "payeDu": "Payé {paye} · dû {du}",
    "aucuneDepense": "Aucune opération",
    "depense": "Débit",
    "type": "Type",
    "sensDepense": "Dépense",
    "sensRevenu": "Revenu",
    "revenus": "Crédit",
    "resultat": "Résultat",
    "provision": "Provision",
    "synthese": "Synthèse (tous les budgets)",
    "sansBudget": "Sans budget",
    "rattacher": "Rattacher à un budget",
    "deplacerVers": "Déplacer / réassigner",
    "deplacerAide": "Choisissez le calendrier puis le budget de destination (un calendrier où vous avez les droits).",
    "deplacerAuSave": "Le déplacement s'applique en enregistrant (icône ✓ en haut).",
    "calendrierCible": "Calendrier",
    "budgetCible": "Budget",
    "choisirBudget": "Choisir un budget…",
    "aucunBudgetCible": "Aucun budget disponible ici",
    "deplacerSelTitre": "Déplacer les opérations",
    "deplacerSelConfirm": "Déplacer {n} opération(s)",
    "lierImport": "Lier à une opération importée",
    "lierImportTitre": "Rapprocher avec un import",
    "lierImportAide": "Choisissez l'opération du relevé qui correspond (utile si le montant varie, ex. EDF). Elle sera fusionnée ici et l'application apprendra le rangement.",
    "lierImportVide": "Aucune opération importée en attente dans ce calendrier.",
    "deplacer": "Déplacer ici",
    "autresPayeurs": "Autres (hors répartition)",
    "trier": "Trier",
    "trierPar": "Trier par",
    "triAide": "Touchez un critère pour trier ; touchez-le à nouveau pour inverser le sens (↑ croissant / ↓ décroissant).",
    "tri_date": "Date",
    "tri_nom": "Libellé",
    "tri_montant": "Montant",
    "tri_categorie": "Catégorie",
    "filtrer": "Filtrer",
    "filtreTout": "Tout",
    "filtreAide": "Sélectionnez des catégories pour regrouper la liste. Type et statut affinent à l'intérieur. La fenêtre se ferme avec ✕.",
    "grouperCategorie": "Grouper par catégorie",
    "horsCalcul": "hors calcul",
    "affichage": "Affichage",
    "cashflow": "Solde cumulé",
    "soldeFinal": "Solde cumulé en fin de période",
    "parMois": "Par mois",
    "parJour": "Par jour",
    "aLequilibre": "À l'équilibre",
    "detteLigne": "{de} doit à {a}",
    "rembourser": "Rembourser",
    "remboursement": "Remboursement",
    "creerRemboursement": "Enregistrer le remboursement",
    "rembDejaPaye": "Déjà payé (réglé tout de suite)",
    "rembPayeAide": "Le remboursement est compté immédiatement : la dette est soldée.",
    "rembProvisionAide": "Le remboursement reste ⏳ en attente : la dette ne sera soldée qu'une fois confirmé (manuellement ou par l'import bancaire).",
    "quiDoitAQui": "Qui doit à qui",
    "detteLectureSeule": "Pour rembourser, ouvrez le budget concerné.",
    "epargne": "Épargne",
    "perteEpargne": "Perte d'épargne",
    "exclure": "Exclure des totaux",
    "reintegrer": "Réintégrer dans les totaux",
    "regroupement": "Regroupement",
    "grp_aucun": "Aucun",
    "grp_budget": "Par budget",
    "grp_categorie": "Par catégorie",
    "grp_calendrier": "Par calendrier",
    "grp_budget_cat": "Budget ▸ Catégorie",
    "grp_cat_budget": "Catégorie ▸ Budget",
    "grp_calendrier_budget": "Calendrier ▸ Budget",
    "reinitFiltre": "Réinitialiser le filtre",
    "aucunResultatFiltre": "Aucun mouvement pour ce filtre.",
    "voirTotaux": "Voir les totaux",
    "masquerTotaux": "Masquer les totaux",
    "graphiques": "Graphiques",
    "graph_repartition": "Par catégorie",
    "graph_budget": "Par budget",
    "graph_calendrier": "Par calendrier",
    "graph_jour": "Par jour",
    "graphAucun": "Aucune dépense à représenter ce mois-ci.",
    "graphMaxJour": "Jour le plus élevé : {montant}",
    "depensesTotal": "Total des dépenses",
    "statut": "Statut",
    "statutPaye": "Payé",
    "statutProvision": "Provision (à payer)",
    "recurrentes": "Récurrentes",
    "aConfirmer": "À confirmer",
    "confirmer": "Confirmer",
    "nouvelleRecurrente": "Nouvelle récurrente",
    "aucuneRecurrente": "Aucune récurrente pour ce budget.",
    "frequence": "Fréquence",
    "freq_mensuelle": "Mensuelle",
    "freq_trimestrielle": "Trimestrielle",
    "freq_semestrielle": "Semestrielle",
    "freq_annuelle": "Annuelle",
    "freq_ponctuelle": "Une seule fois",
    "jour": "jour",
    "jourEcheance": "Jour d'échéance (1-28)",
    "ajouterRecurrente": "Ajouter la récurrente",
    "modifierRecurrente": "Modifier la récurrente",
    "filtreRecurrence": "Récurrence",
    "recurLiees": "Liées",
    "recurNonLiees": "Non liées",
    "passerEnRecurrent": "Rendre récurrent",
    "rendrePonctuelle": "Rendre ponctuelle (détacher)",
    "rattacherExistante": "Rattacher à une récurrente existante",
    "rattacherAutre": "Rattacher à une autre récurrente",
    "detacherRattacherTitre": "Détacher puis rattacher ?",
    "detacherRattacherMsg": "Cette opération est liée à « {libelle} ». La rattacher à une autre récurrente la détachera d'abord de « {libelle} ». Continuer ?",
    "detacherRattacherOui": "Détacher et choisir",
    "recurrenteIntrouvableAide": "Cette opération est liée à une récurrente introuvable (supprimée). Vous pouvez la rattacher à une autre récurrente, ou la rendre ponctuelle.",
    "rattacheeA": "Rattachée à",
    "recurrenteInconnue": "récurrente introuvable",
    "operationARattacher": "Opération à rattacher",
    "rattachMasse": "Rattacher en masse",
    "rattachMasseSous": "Pour chaque récurrente, ses opérations non liées au montant proche. Touche ✓ pour rattacher, ✗ pour ignorer.",
    "rattachMasseVide": "Aucune opération à rattacher (tout est déjà lié, ou aucun montant ne correspond).",
    "rattachTout": "Tout rattacher",
    "meilleurMatch": "Meilleur match",
    "montantExact": "montant exact",
    "ecart": "écart",
    "rattacherSous": "Le mouvement reprendra le nom de la récurrente et sera rapproché banque. Les prochains imports de ce libellé s'y rattacheront aussi.",
    "rattacheTitre": "Mouvement rattaché",
    "rattacheMsg": "Rattaché à « {nom} » : nom repris, rapproché banque, règle d'import enregistrée.",
    "recurrenceEtat": "Opération récurrente",
    "recurrenteOuiAide": "Cette opération est liée à une récurrente. Vous pouvez la rendre ponctuelle (elle se détache ; la récurrente reste pour les autres mois).",
    "recurrenteNonAide": "Transformez cette opération en modèle récurrent (loyer, abonnement…) qui sera proposé chaque échéance.",
    "changerEchelle": "Changer l'échelle (mois / année / tout)",
    "recurrenteCreee": "Récurrente créée",
    "recurrenteCreeeMsg": "Tu peux la gérer (ou la supprimer) via le bouton « Récurrentes » du budget.",
    "nouvelleDepense": "Nouvelle opération",
    "montant": "Montant",
    "libelle": "Libellé",
    "libellePlaceholder": "Ex : Cantine, médecin…",
    "payePar": "Payé par",
    "categorie": "Catégorie",
    "date": "Date",
    "datePlaceholder": "AAAA-MM-JJ",
    "dateReception": "Date de réception (facture)",
    "datePaiement": "Date de paiement",
    "datePaiementPlaceholder": "Choisir une date (si payé)",
    "typePaiement": "Moyen de paiement",
    "pmt_cb": "CB",
    "pmt_virement": "Virement",
    "pmt_cheque": "Chèque",
    "pmt_espece": "Espèce",
    "enregistrement": "Enregistrement…",
    "ajouterDepense": "Ajouter l'opération",
    "modifierDepense": "Modifier l'opération",
    "detailDepense": "Détail de l'opération",
    "commentaire": "Commentaire",
    "commentairePlaceholder": "Note, précision…",
    "pieces": "Pièces jointes",
    "photo": "Galerie",
    "camera": "Caméra",
    "fichier": "Fichier",
    "aucunePiece": "Aucune pièce jointe",
    "lectureSeule": "Seul le créateur de l'opération peut la modifier.",
    "permission": "Autorisation",
    "permCamera": "Autorisez l'accès à la caméra pour prendre une photo.",
    "permPhotos": "Autorisez l'accès aux photos pour en ajouter une.",
    "erreur": "Erreur",
    "supprimerTitre": "Supprimer l'opération",
    "supprimerConfirm": "Supprimer « {libelle} » ?",
    "cat_scolaire": "Scolaire",
    "cat_sante": "Santé",
    "cat_activites": "Activités",
    "cat_vetements": "Vêtements",
    "cat_alimentation": "Alimentation",
    "cat_salaire": "Salaire",
    "cat_loyer": "Loyer",
    "cat_charges": "Charges",
    "cat_energie": "Énergie",
    "cat_travaux": "Travaux",
    "cat_assurance": "Assurance",
    "cat_credit": "Prêt",
    "cat_taxeFonciere": "Impôts",
    "cat_transport": "Transport",
    "cat_abonnements": "Abonnements",
    "cat_import": "Import",
    "cat_remboursement": "Remboursement",
    "cat_autre": "Autre",
    "importer": "Importer un relevé",
    "importTitre": "Importer un relevé (OFX / CSV)",
    "importCalendrier": "Calendrier de destination",
    "importChoisir": "Choisir un fichier OFX ou CSV",
    "importChoisirFichier": "Sélectionner un fichier…",
    "importWebSeul": "L'import de relevé se fait depuis la version web (myfinance.mopsuite.fr).",
    "importApercu": "{n} opération(s) lues",
    "importVersBudget": "Vers le budget « Import » de ce calendrier",
    "importLancer": "Importer {n} opération(s)",
    "importEnCours": "Import en cours…",
    "importResultat": "{crees} importée(s), {doublons} doublon(s) ignoré(s).",
    "importErreurFichier": "Fichier illisible ou format non reconnu.",
    "importAucune": "Aucune opération trouvée dans ce fichier.",
    "importNote": "Zone de transit : ces opérations ne sont PAS comptées tant que vous ne les affectez pas à un budget (Déplacer / réassigner).",
    "toutesPeriodes": "Toutes périodes",
    "importDoublonDeja": "Déjà importée",
    "importDoublonPossible": "Doublon possible de :",
    "importSelection": "{n} sélectionnée(s) sur {total}",
    "importActionRapprocher": "Rapprocher",
    "importActionImporter": "Importer",
    "importActionIgnorer": "Ignorer",
    "importAppris": "appris",
    "importRapprocheAvec": "Rapprocher avec :",
    "importPlusieurs": "{n} correspondances possibles — choisissez en conscience",
    "importResume": "{rap} à rapprocher · {imp} à importer · {dej} déjà présente(s) — sur {total}",
    "importMasquerDeja": "Masquer les déjà importées ({n})",
    "importValider": "Valider — {rap} rapprochement(s), {imp} import(s)",
    "importResultat2": "{rapproches} rapprochée(s), {crees} importée(s).",
    "banqueRef": "Réf. banque",
    "banqueLibelle": "Libellé banque",
    "banqueDate": "Date banque",
    "banqueInfos": "Infos banque",
    "importActionRattacher": "Rattacher",
    "importPrevu": "prévu",
    "importResultat3": "{rapproches} rapprochée(s) · {rattaches} rattachée(s) · {crees} créée(s)",
    "sansBudgetAide": "à ranger dans une enveloppe"
  },
  "messagerie": {
    "titre": "Messagerie",
    "discussionParDefaut": "Discussion",
    "nouvelleDiscussion": "Nouvelle discussion",
    "membresDeLaDiscussion": "Membres de la discussion",
    "sujet": "Sujet",
    "sujetExemple": "Ex : Vacances d'été",
    "visibleParTous": "Visible par tout le monde",
    "membresHint": "Vous êtes inclus automatiquement. Choisissez les autres :",
    "aucunAutreMembre": "Aucun autre membre sur ce calendrier.",
    "creer": "Créer",
    "aucunMessage": "Aucun message",
    "demarrezConversation": "Démarrez la conversation",
    "quelquun": "Quelqu'un",
    "votreMessage": "Votre message…",
    "photo": "Photo",
    "camera": "Caméra",
    "document": "Document",
    "position": "Position",
    "positionPartagee": "Position partagée",
    "partagerPosition": "Partager ma position",
    "adresse": "Adresse",
    "adressePlaceholder": "Adresse (modifiable si besoin)",
    "envoyer": "Envoyer",
    "lieu": "Lieu enregistré",
    "positionExacte": "Position exacte",
    "actionsIndispo": "Pièces jointes et position non incluses dans votre offre.",
    "choisirLieu": "Choisir un lieu du calendrier",
    "aucunLieu": "Aucun lieu enregistré dans ce calendrier.",
    "voirSurCarte": "Voir sur la carte",
    "lieuSansCoord": "Adresse sans position précise — voir sur la carte",
    "ouvrirDansPlans": "Ouvrir dans Plans / Google Maps",
    "discussionFermeeBanner": "Discussion fermée — plus de nouveaux messages.",
    "fermer": "Fermer",
    "fermerDiscussionTitre": "Fermer la discussion",
    "fermerDiscussionConfirm": "Fermer « {titre} » ? Plus aucun message ne pourra y être écrit.",
    "supprimerMessageTitre": "Supprimer le message",
    "supprimerMessageConfirm": "Supprimer ce message ?",
    "supprimerDiscussionCloseConfirm": "Supprimer cette discussion close ?",
    "erreur": "Erreur",
    "permission": "Permission",
    "permPhotosRefusee": "Accès aux photos refusé.",
    "permCameraRefusee": "Accès à la caméra refusé.",
    "permLocalisationRefusee": "Accès à la localisation refusé.",
    "positionIndispo": "Position indisponible.",
    "ouvertureFichierImpossible": "Impossible d'ouvrir le fichier.",
    "repondre": "Répondre",
    "repondreA": "Réponse à {nom}",
    "enregistrer": "Enregistrer",
    "enregistrerImpossible": "Enregistrement impossible.",
    "ouvrir": "Ouvrir l'attachement",
    "fichierLabel": "Fichier",
    "triTitre": "Trier les discussions",
    "triRecent": "Dernier message (récent d'abord)",
    "triAncien": "Dernier message (ancien d'abord)",
    "triAZ": "Alphabétique (A → Z)",
    "triZA": "Alphabétique (Z → A)",
    "general": "Général",
    "aucuneDiscussion": "Aucune discussion pour l’instant.",
    "restreinte": "Visible par une sélection",
    "fermee": "Fermée",
    "discussionFermee": "Discussion fermée : plus de nouveaux messages.",
    "fermerDiscussion": "Fermer la discussion",
    "confirmFermer": "Une discussion fermée ne se rouvre pas. Pour reprendre le sujet, créez-en une nouvelle. Continuer ?",
    "confirmSupprimerDiscussion": "Supprimer cette discussion et tous ses messages ? C’est définitif.",
    "actionsMessage": "Ce message",
    "signaler": "Signaler ce message",
    "leverSignalement": "Lever le signalement",
    "retirerPourTous": "Retirer pour les autres",
    "modererMasquer": "Modérer (masquer aux autres)",
    "confirmSupprimer": "Le contenu sera effacé définitivement. Le message restera affiché comme supprimé. Continuer ?",
    "confirmRetirer": "Votre message ne sera plus visible par les autres, et vous ne pourrez pas le réafficher. Continuer ?",
    "confirmModerer": "Ce message sera masqué pour les autres. Son auteur en sera informé et pourra le supprimer. C’est sans retour. Continuer ?",
    "messageSupprime": "Message supprimé",
    "messageModereAuteur": "Message retiré par son auteur",
    "messageModereAdmin": "Message modéré",
    "mentionModereMoi": "Modéré : masqué pour les autres. Vous pouvez le supprimer.",
    "mentionModereAutres": "Masqué pour les autres membres.",
    "mentionSignale": "Signalé : une décision est attendue.",
    "piecesJointes": "Joindre",
    "erreurLecture": "Les discussions n'ont pas pu être lues — la liste ci-dessous peut être incomplète.",
    "sansCalendrier": "Aucun calendrier actif : choisis un calendrier pour voir ses discussions."
  },
  "journal": {
    "titre": "Journal de bord",
    "nouvelleNote": "Nouvelle note",
    "placeholderNote": "Écrire une note du jour…",
    "aucuneNote": "Aucune note",
    "supprimerTitre": "Supprimer la note",
    "supprimerMsg": "Cette note sera définitivement supprimée.",
    "erreur": "Erreur",
    "erreurLecture": "Le journal n'a pas pu être lu — la liste ci-dessous peut être incomplète.",
    "aucuneAide": "Notez ce qui compte au fil des jours : une info de santé, un mot de l'école, un incident.",
    "modifierNote": "Modifier la note",
    "nature": "Nature",
    "natNote": "Note",
    "cat_humeur": "Humeur",
    "cat_incident": "Incident",
    "valeur_note": "Catégorie",
    "valeur_humeur": "Humeur",
    "valeur_incident": "Type d'incident",
    "valeurLibre": "Autre…",
    "phValeurLibre": "Préciser l'incident…",
    "aideValeurLibre": "Ce texte ne vaut que pour cette note. Il n'est ajouté à aucune liste.",
    "date": "Date",
    "texte": "Note",
    "auteur": "Écrit par",
    "hum_joyeux": "Joyeux",
    "hum_calme": "Calme",
    "hum_neutre": "Neutre",
    "hum_inquiet": "Inquiet",
    "hum_triste": "Triste",
    "hum_enerve": "Énervé",
    "hum_fatigue": "Fatigué",
    "inc_blessure": "Blessure",
    "inc_maladie": "Maladie",
    "inc_dispute": "Dispute",
    "inc_ecole": "Souci scolaire",
    "inc_retard": "Retard",
    "inc_objet": "Objet perdu ou cassé",
    "inc_trajet": "Trajet",
    "inc_autre": "Autre",
    "voirJour": "Voir jour par jour",
    "voirTout": "Voir toutes les notes",
    "aujourdhui": "Aujourd'hui",
    "jourPrec": "Jour précédent",
    "jourSuiv": "Jour suivant",
    "jourNotePrec": "Note précédente",
    "jourNoteSuiv": "Note suivante",
    "heure": "Heure",
    "heureAide": "Facultative — à défaut, l'heure d'écriture"
  },
  "contacts": {
    "titre": "Carnet de contacts",
    "vide": "Aucun contact",
    "nouveau": "Nouveau contact",
    "modifier": "Modifier le contact",
    "erreur": "Erreur",
    "supprimerTitre": "Supprimer le contact",
    "supprimerConfirm": "Supprimer « {nom} » ?",
    "appeler": "Appeler",
    "envoyerEmail": "Envoyer un email",
    "phPrenom": "Prénom",
    "phNom": "Nom *",
    "phTelephone": "Téléphone",
    "phEmail": "Email",
    "phAdresse": "Adresse",
    "phNote": "Note",
    "prenom": "Prénom",
    "nom": "Nom",
    "surnom": "Surnom",
    "phSurnom": "Surnom (facultatif)",
    "categorie": "Catégorie",
    "telephone": "Téléphone",
    "telephones": "Téléphones",
    "emails": "Emails",
    "lieux": "Lieux",
    "ajouterTel": "Ajouter un téléphone",
    "ajouterEmail": "Ajouter un email",
    "ajouterLieu": "Ajouter un lieu",
    "email": "Email",
    "adresse": "Adresse",
    "lieu": "Lieu",
    "choisirLieu": "Choisir un lieu…",
    "erreurEnregistrer": "Enregistrement impossible.",
    "note": "Note",
    "aucunAide": "Ajoute les contacts utiles (médecin, école, urgences…) pour les avoir à portée de main.",
    "ajouterChamp": "Ajouter un champ",
    "champsPerso": "Autres informations",
    "champPerso": "Personnalisé",
    "champPersoIcone": "Icône du champ",
    "champPersoNom": "Nom du champ (ex. Étage, Code…)",
    "phValeur": "Valeur",
    "rechercher": "Rechercher un contact",
    "aucunResultat": "Aucun résultat",
    "tri_nom": "Nom",
    "tri_categorie": "Catégorie",
    "role_medecin": "Médecin",
    "role_ecole": "École",
    "role_famille": "Famille",
    "role_garde": "Garde / nounou",
    "role_urgence": "Urgence",
    "role_autre": "Autre",
    "jour": "Jour",
    "ajouterHoraire": "Ajouter une plage",
    "horaire": "cette plage horaire",
    "modifierChamp": "Modifier le nom et le type",
    "erreurLecture": "Le carnet n'a pas pu être lu — la liste peut être incomplète."
  },
  "stats": {
    "titre": "Statistiques de garde",
    "aucunCalendrierEnfant": "Aucun calendrier enfant.",
    "statsEnfantSeulement": "Les statistiques de garde ne concernent que les calendriers de type enfant.",
    "aucunJourPeriode": "Aucun jour de garde renseigné sur cette période.",
    "erreurLecture": "La garde n'a pas pu être lue — les statistiques peuvent être fausses.",
    "repartitionTemps": "Répartition du temps de garde",
    "parMois": "Par mois",
    "legende": "{nom} — {jours} j ({pct}%)",
    "jourRenseigne": "{n} jour renseigné",
    "joursRenseignes": "{n} jours renseignés",
    "nonRenseigne": " · {n} non renseigné",
    "nonRenseignes": " · {n} non renseignés",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "per_30j": "30 jours",
    "per_3m": "3 mois",
    "per_6m": "6 mois",
    "per_12m": "1 an"
  },
  "edt": {
    "titre": "Emploi du temps",
    "erreur": "Erreur",
    "datesRequises": "Veuillez indiquer une date de début et une date de fin.",
    "plageHoraire": "Plage horaire",
    "dureeCellule": "Durée d'un créneau",
    "nbCreneaux": "Nombre de créneaux",
    "creneauDepart": "Créneau de départ",
    "associer": "Associer à la suivante",
    "dissocier": "Dissocier",
    "collerFusionTitre": "Coller un bloc fusionné",
    "collerFusionMsg": "Ce bloc occupe {n} créneaux et écrasera le contenu de {perdus} cellule(s). Continuer ?",
    "collerNbSlots": "Nombre de créneaux à couvrir",
    "collerEcrasera": "{perdus} cellule(s) seront écrasées",
    "collerAucunEcrase": "Aucune cellule ne sera écrasée",
    "collerConfirmer": "Coller",
    "plageInvalide": "L'heure de fin doit être après l'heure de début.",
    "caseCopiee": "Case copiée — touchez une case pour coller · double-clic pour terminer",
    "aucunCalendrier": "Aucun calendrier.",
    "grille": "Grille",
    "aucuneGrille": "Aucune grille d'emploi du temps.",
    "nSelectionnees": "{n} sélectionné(s)",
    "supprGrillesTitre": "Supprimer les emplois du temps",
    "supprGrillesMsg": "Supprimer {n} emploi(s) du temps ?",
    "nom": "Nom",
    "nomPlaceholder": "Ex. Période 1",
    "periodeActivite": "Période d'activité",
    "du": "Du {date}",
    "au": "Au {date}",
    "chevauchement": "Cette période en chevauche une autre.",
    "categorieCours": "Catégorie des cours (sur le calendrier)",
    "appliquerCal": "Appliquer au calendrier",
    "appliqueCal": "Appliqué au calendrier",
    "retirerCal": "Retirer",
    "application": "Application…",
    "modifRetire": "Modification enregistrée. L'emploi du temps a été retiré du calendrier ; ré-appliquez-le quand vous aurez terminé vos changements.",
    "appliquer": "Appliquer",
    "retirer": "Retirer",
    "appliquerTitre": "Appliquer au calendrier",
    "appliquerConfirm": "Générer les cours de « {nom} » comme événements sur le calendrier, du {debut} au {fin} (lundi → vendredi) ?",
    "appliqueOk": "Cours générés sur {n} jour(s). Ils apparaissent sur le calendrier (catégorie « École »).",
    "retirerTitre": "Retirer du calendrier",
    "retirerConfirm": "Retirer du calendrier les cours générés de « {nom} » ?",
    "supprimerCetteGrille": "Supprimer cette grille",
    "toucherCase": "Touchez une case pour renseigner une matière.",
    "matiereActivite": "Matière / activité",
    "matierePlaceholder": "Ex. Mathématiques",
    "salleOptionnel": "Salle (optionnel)",
    "sallePlaceholder": "Ex. B204",
    "lieuOptionnel": "Lieu (optionnel)",
    "couleur": "Couleur",
    "viderCase": "Vider la case",
    "supprimerGrilleTitre": "Supprimer la grille",
    "supprimerGrilleMsg": "Supprimer « {nom} » et tous ses créneaux ?",
    "nouvelleGrille": "Nouvelle grille",
    "creer": "Créer",
    "choisirDate": "Choisir une date",
    "datePrecise": "Modifier une date précise",
    "exceptionDe": "Exception du {date}",
    "reinitialiser": "Réinitialiser",
    "termine": "Terminé",
    "reinitJourTitre": "Réinitialiser ce jour ?",
    "reinitJourMsg": "L'emploi du temps du {date} reprendra la grille normale.",
    "exceptionsTitre": "Exceptions ({n})",
    "exHorsPeriode": "hors période",
    "exHorsGrille": "créneau supprimé",
    "exSupprTitre": "Supprimer l'exception ?",
    "exSupprMsg": "Le {date} reprendra l'emploi du temps normal.",
    "exPurgeTitre": "Exceptions incohérentes",
    "exPurgeMsg": "{n} exception(s) ne correspondent plus à la grille (date hors période ou créneau supprimé). Les retirer ?",
    "exGarder": "Garder",
    "exRetirer": "Retirer",
    "parametres": "Paramètres",
    "nomGrille": "Nom de la grille",
    "phNomGrille": "Année 2026-2027, semestre 1…",
    "remapAide": "Les créneaux existants seront recalés sur les nouveaux horaires.",
    "caseTitre": "Créneau",
    "matiere": "Matière",
    "phMatiere": "Maths, Français, Sport…",
    "phSalle": "B204…",
    "finCours": "Fin du cours",
    "creneau": "Créneau",
    "aucuneGrilleAide": "Crée une grille avec ＋ : ses cours apparaîtront automatiquement dans le calendrier (type EDT), sur sa période.",
    "listeAide": "Touche une grille pour la remplir · balaye pour éditer les paramètres ou supprimer · la bascule active/désactive la grille.",
    "grilleInactive": "Grille désactivée — ses cours ne s'affichent pas dans le calendrier.",
    "grilleAide": "Touche un créneau vide pour ajouter un cours, un créneau rempli pour l'éditer (fusion via le nombre de créneaux).",
    "active": "Active",
    "copier": "Copier",
    "collerBarre": "« {matiere} » copié — touche un créneau vide pour coller (appui long sur un cours = copier)",
    "actionCreneau": "Que faire de ce cours ?",
    "deplacer": "Déplacer",
    "deplacerBarre": "« {matiere} » — touche un créneau vide pour le déplacer",
    "conflitTitre": "Cours déjà en place",
    "conflitMsg": "{n} cours occupent déjà ces horaires. Que faire ?",
    "conflitSupprimer": "Supprimer le(s) cours en place",
    "conflitReduire": "Réduire le cours collé",
    "basculeNoms": "Afficher / masquer les noms (icônes seules)",
    "renommer": "Modifier le nom / la salle",
    "nomCreneau": "Nom",
    "phNomCreneau": "Ex. Ecole, Cours de maths, Entrainement...",
    "emplacement": "Emplacement",
    "matiereOptionnel": "Matière (optionnel)",
    "periodicite": "Périodicité (semaines)",
    "periodiciteAide": "2 et plus : la grille alterne S1/S2/… — chaque semaine se configure dans son onglet.",
    "semaineCourte": "S{n}",
    "vacApplique": "Appliquer pendant les vacances",
    "vacAide": "Réglage global — ajustable pour chaque période ci-dessous.",
    "vacListe": "Vacances de la période"
  },
  "export": {
    "titre": "Exporter / Importer",
    "perso": "Perso",
    "depart": "Depart {d}",
    "semVersFin": "{n} sem. → {d}",
    "du": "Du {d}",
    "au": "Au {d}",
    "envSemaine": "≈ {n} semaine",
    "envSemaines": "≈ {n} semaines",
    "exporterIcs": "Exporter .ics",
    "imprimerPdf": "Imprimer / PDF",
    "rapport": "Rapport imprimable",
    "note": "Après avoir cliqué, choisissez par catégorie ce que vous exportez. Le rapport ajoute un planning hebdomadaire (n° de semaine, garde, EDT, vacances).",
    "importerFichierIcs": "Importer un fichier .ics",
    "resumeEvt": "{n} événement",
    "resumeEvts": "{n} événements",
    "resumeGarde": " · {n} garde",
    "resumeGardes": " · {n} gardes",
    "resumeDemande": " · {n} demande",
    "resumeDemandes": " · {n} demandes",
    "resumeDepense": " · {n} opération",
    "resumeDepenses": " · {n} opérations",
    "surLaPeriode": " sur la période.",
    "documentInformatif": "Document informatif — non certifié pour un usage judiciaire.",
    "queExporter": "Que veut-on exporter ?",
    "coches": "{n}/{total} coché(s)",
    "toutCocher": "Tout cocher",
    "toutDecocher": "Tout décocher",
    "sansTitre": "(sans titre)",
    "alternancesGarde": "Alternances de garde",
    "gardeDe": "Garde {nom}",
    "demandesGroupe": "Demandes (approbations / refus)",
    "refuse": "Refusé",
    "approuve": "Approuvé",
    "demPar": "dem. {nom}",
    "rienAExporter": "Rien à exporter sur cette période.",
    "genererIcs": "Générer le .ics ({n})",
    "genererRapport": "Générer le rapport",
    "aucunEvtTitre": "Aucun événement",
    "aucunEvtMsg": "Sélectionnez au moins un événement.",
    "aucunEvtLisible": "Ce fichier ne contient pas d'événement lisible.",
    "erreur": "Erreur",
    "lectureImpossible": "Lecture du fichier impossible.",
    "bloqueTitre": "Bloqué",
    "bloqueMsg": "Autorisez les fenêtres pop-up pour générer le PDF.",
    "importTermineTitre": "Import terminé",
    "importTermineMsg": "{n} événement(s) ajouté(s) à « {nom} »",
    "importEchecs": " · {e} échec(s)",
    "importIcsTitre": "Import .ics",
    "importWebSeulement": "L'import de fichier .ics est disponible sur la version web pour le moment.",
    "confirmImport": "Importer {n} événement(s) dans « {nom} » ?",
    "aide": "Exporte les evenements du calendrier actif. Aucun module natif : ca marche aussi sur le web et en mise a jour a distance.",
    "p1s": "1 sem.",
    "p2s": "2 sem.",
    "p1m": "1 mois",
    "p3m": "3 mois",
    "nEvenements": "{n} evenement(s) sur la periode",
    "ics": "Fichier .ics",
    "icsSous": "Importable dans Google Agenda, Apple Calendrier, Outlook",
    "rapportSous": "Web : imprimer → PDF. Mobile : partage.",
    "telecharge": "Fichier telecharge.",
    "partage": "Partage ouvert.",
    "rapportPret": "Rapport genere.",
    "rien": "Rien a exporter",
    "rienAide": "Aucun evenement sur la periode choisie — essaie une periode plus longue.",
    "pdf": "PDF",
    "pdfSous": "Fichier enregistrable ou partageable",
    "pdfPret": "PDF genere.",
    "impressionOuverte": "Impression ouverte : choisis « Enregistrer au format PDF ».",
    "popupBloquee": "Le navigateur a bloque la fenetre : autorise les pop-ups pour ce site.",
    "inclureGardes": "Inclure les gardes",
    "nSegmentsGarde": "{n} periode(s) de garde",
    "inclureEdt": "Inclure l'emploi du temps",
    "calendrier": "Calendrier a exporter",
    "filtres": "Filtres",
    "filtresAide": "Rien de selectionne = tout est exporte. Touche pour restreindre.",
    "importGroupe": "Importer",
    "importer": "Importer un fichier .ics",
    "importerSous": "Ajoute les evenements du fichier a ce calendrier",
    "icsIllisible": "Aucun evenement lisible dans ce fichier.",
    "importTitre": "Importer les evenements",
    "importMsg": "{n} evenement(s) vont etre ajoutes a « {nom} ». Cette action ecrit dans le calendrier.",
    "importOk": "{n} evenement(s) importe(s).",
    "importPartiel": "{n} importe(s), {e} en echec.",
    "paysage": "PDF au format paysage"
  },
  "vacances": {
    "titre": "Vacances & jours fériés",
    "aucunCalendrier": "Aucun calendrier.",
    "note": "Les jours fériés sont affichés automatiquement sur le calendrier. Chargez ici les vacances scolaires officielles",
    "notePour": " pour « {nom} »",
    "zoneScolaire": "Zone scolaire",
    "anneeScolaire": "Année scolaire",
    "chargerVacances": "Charger les vacances",
    "periodes": "Périodes ({actives}/{total} affichées)",
    "chevauchementGlobal": "Des périodes se chevauchent (cartes en rouge).",
    "infoSchema": "La répartition de la garde (½ 1 / ½ 2 et alternance paire/impaire) se règle dans Profil → « Configuration de garde ». Elle s'affiche ici par période.",
    "chevauchementCarte": "Chevauchement avec une autre période",
    "edtPendantVacances": "Emploi du temps pendant ces vacances",
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "dejaChargeesTitre": "Déjà chargées",
    "dejaChargeesMsg": "Ces périodes sont déjà dans la liste.",
    "ajouteTitre": "✓ Ajouté",
    "ajouteMsg": "{n} période(s) ajoutée(s). Pensez à enregistrer.",
    "erreurTitre": "Erreur",
    "chargementImpossible": "Chargement impossible.",
    "supprimerTitre": "Supprimer la période",
    "supprimerMsg": "Supprimer « {nom} » ?",
    "enregistreTitre": "✓ Enregistré",
    "enregistreGardeMsg": "Vacances affichées et garde appliquée au calendrier.",
    "enregistreMsg": "Les vacances sont affichées sur le calendrier.",
    "enregistrementImpossible": "Enregistrement impossible.",
    "aucuneNouvellePeriode": "Aucune nouvelle période (déjà présentes).",
    "periodesAjoutees": "{n} période(s) ajoutée(s).",
    "periodeRetireeMsg": "« {nom} » sera retirée.",
    "aucunNouveauFerie": "Aucun nouveau férié {annee} (déjà présents).",
    "feriesAjoutes": "{n} jour(s) férié(s) {annee} ajouté(s).",
    "ferieExisteDeja": "Un jour férié existe déjà à cette date.",
    "supprimerFerieTitre": "Supprimer le jour férié",
    "ferieRetireMsg": "« {nom} » sera retiré.",
    "enregistreOk": "Enregistré ✓",
    "sectionScolaires": "Vacances scolaires",
    "nPeriodes": "{n} période(s)",
    "introScolaires": "Choisis ta zone et l'année, puis touche ⬇️ pour ajouter les périodes (sans doublon). La garde durant les vacances se règle dans « Gardes ».",
    "zone": "Zone",
    "ajouterVacancesDe": "⬇️  Ajouter les vacances de {zone} · {annee}",
    "aideSwipePeriode": "Balaie pour supprimer · touche une période pour la voir/modifier.",
    "sectionFeries": "Jours fériés",
    "nJours": "{n} jour(s)",
    "introFeries": "Importe les jours fériés français d'une année, ou ajoute-en un personnalisé (ex. pont, jour de rentrée).",
    "ajouterFeries": "⬇️  Ajouter les jours fériés {annee}",
    "ajouterFerie": "Ajouter un jour férié",
    "phNomFerie": "Nom (ex. Pont de l'Ascension)",
    "choisirDate": "Choisir la date…",
    "aideSwipe": "Balaie pour supprimer.",
    "dateFerieTitre": "Date du jour férié",
    "modifierPeriode": "Modifier la période",
    "fichePeriode": "Période de vacances",
    "du": "Du",
    "au": "Au",
    "repartitionMoities": "Répartition (½1 / ½2)",
    "moitie1Ligne": "½1 : {debut} → {fin} · {n}j",
    "moitie2Ligne": "½2 : {debut} → {fin} · {n}j",
    "gardeMoitiesNote": "La garde de chaque moitié se règle dans « Gardes ».",
    "phNomPeriode": "Ex. Vacances de la Toussaint",
    "erreurNomDates": "Renseigne un nom et des dates valides (début ≤ fin)."
  },
  "lieux": {
    "titre": "Lieux",
    "choisir": "Choisir un lieu",
    "aucun": "Aucun",
    "aucunListe": "Aucun lieu",
    "aucunAide": "Ajoute des lieux (onglet Famille → Carnets → Lieux) pour les proposer ici.",
    "ajouter": "Ajouter un lieu",
    "modifier": "Modifier le lieu",
    "nom": "Nom",
    "adresse": "Adresse",
    "phNom": "Ex. École, Maison, Gymnase…",
    "phAdresse": "Adresse ou description",
    "rechercheAdresse": "Rechercher une adresse ou un lieu…",
    "recherche": "Recherche…",
    "aucunResultat": "Aucun résultat",
    "maPosition": "Ma position",
    "localisation": "Localisation…",
    "itineraire": "Itinéraire",
    "supprimerTitre": "Supprimer ce lieu ?",
    "supprimerMsg": "« {nom} » sera retiré de la liste des lieux.",
    "sansAdresse": "Aucune adresse enregistrée pour ce lieu."
  },
  "apparence": {
    "titre": "Configuration de l'application",
    "theme": "Thème",
    "auto": "Système",
    "clair": "Clair",
    "sombre": "Sombre",
    "icones": "Icônes",
    "emoji": "Emoji",
    "fines": "Icônes fines",
    "hint": "« Système » suit le thème clair/sombre de votre téléphone. Le nouveau look (thème + icônes) s'applique d'abord à la page Lieux, puis progressivement au reste.",
    "calendrier": "Calendrier",
    "boutonsVue": "Boutons de vue en haut du calendrier",
    "boutonsVueHint": "Masqués par défaut : un clic sur l'onglet Calendrier ouvre déjà le menu des vues, un double-clic passe à la vue suivante.",
    "boutonsVueOn": "boutons de vue en haut",
    "boutonsVueOff": "pas de boutons de vue en haut",
    "section": "Apparence"
  },
  "parametres": {
    "profil": "Profil",
    "deconnexion": "Se déconnecter"
  },
  "premierCal": {
    "bienvenue": "Bienvenue",
    "sousTitre": "Ton espace « {nom} » n'a pas encore de calendrier. Crée ton premier calendrier pour commencer.",
    "inviteTitre": "Vous êtes invité",
    "inviteSous": "Touchez « Rejoindre » pour accéder à un calendrier partagé avec vous.",
    "rejoindre": "Rejoindre",
    "deParent": " · de {prenom}",
    "roleParent2": "Parent 2",
    "roleCoOrganisateur": "Co-organisateur",
    "roleVisiteur": "Visiteur",
    "ouSepare": "— ou créez le vôtre —",
    "labelNom": "Nom du calendrier *",
    "placeholderNom": "Ex : Emma, Calendrier famille…",
    "placeholderEnfant": "Ex : Emma, Lucas…",
    "connecteEnTant": "Connecté(e) en tant que {email}",
    "roleIVV": "Validation (IVV)",
    "noteProfil": "Vous pourrez à tout moment rejoindre un calendrier partagé ou en créer un nouveau depuis l'onglet Profil.",
    "labelIcone": "Icône",
    "labelCouleur": "Couleur",
    "creerBtn": "Créer mon calendrier →",
    "erreurNomVide": "Donnez un nom au calendrier.",
    "erreurLimite": "Limite de calendriers atteinte.",
    "nomPlaceholder": "Ex. Général, Perso, Boulot…",
    "creer": "Créer le calendrier",
    "note": "Tu pourras créer d'autres calendriers plus tard dans Profil → « Mes calendriers ».",
    "errNom": "Donne un nom à ton calendrier.",
    "errEspace": "Aucun espace actif.",
    "errCreation": "Création impossible."
  },
  "ft": {
    "titre": "Faits techniques",
    "choisir": "Choisir…",
    "brouillons": "Brouillons ({n})",
    "brouillonSansTitre": "Brouillon sans titre",
    "contextePrefix": "Contexte : {c}",
    "nbCaptures": "{n} capture(s)",
    "continuer": "Continuer ›",
    "supprimerBrouillonConfirm": "Supprimer ce brouillon ?",
    "aFaire": "À faire ({n})",
    "groupeACompleter": "À compléter",
    "groupeAValider": "À valider",
    "groupeAClore": "À clore",
    "actionCompleter": "Compléter ›",
    "actionValider": "Valider ›",
    "actionClore": "Clore ›",
    "vueEnsemble": "Vue d'ensemble",
    "lesMiens": "Les miens",
    "tous": "Tous",
    "total": "Total : {n}",
    "astuceFiltre": "Touchez un état pour filtrer la liste ci-dessous.",
    "mesFaits": "Mes faits techniques ({n})",
    "reinitFiltre": "Réinit. filtre",
    "vide": "Aucun pour l'instant. Touchez + pour en créer.",
    "cloreTitre": "Clore le FT",
    "cloreConfirm": "Marquer ce FT comme résolu et le clore ?",
    "clore": "Clore",
    "supprimerFaitConfirm": "Supprimer FT {n} ?",
    "complementDemande": "Complément demandé",
    "votreReponse": "Votre réponse au complément",
    "placeholderReponse": "Répondez ici à la demande ci-dessus…",
    "labelTitre": "Titre",
    "labelType": "Type",
    "labelGravite": "Gravité",
    "labelCategorie": "Catégorie",
    "labelPage": "Page / onglet",
    "labelFonctionnalite": "Fonctionnalité",
    "labelPreciser": "Préciser",
    "placeholderPreciser": "De quoi s'agit-il ?",
    "labelPlateforme": "Plateforme",
    "labelVersion": "Version de l'app",
    "labelContexte": "Contexte",
    "labelEtapes": "Étapes",
    "labelComportement": "Comportement attendu",
    "labelConfiance": "Niveau de confiance",
    "labelCaptures": "Captures",
    "hintRenvoyer": "Touchez ✈️ en haut pour renvoyer (complété).",
    "hintEnregistrer": "Touchez ✈️ en haut pour enregistrer.",
    "phaseSoumis": "Soumis",
    "gravitePrefix": "Gravité : {g}",
    "attenduPrefix": "Attendu : {a}",
    "confianceSuffix": " (confiance : {c})",
    "etapesPrefix": "Étapes : {e}",
    "soumisPar": "Soumis par {nom}",
    "phaseAnalyse": "Analyse",
    "cause": "Cause",
    "correctionPrevue": "Correction prévue",
    "phaseRealisation": "Réalisation",
    "corrigeEn": "Corrigé en v{v}",
    "majAvantValider": "Mets à jour l'app puis vérifie avant de valider.",
    "rejete": "Rejeté",
    "cloreCeFt": "Clore ce FT",
    "historique": "Historique",
    "histCause": "Cause : ",
    "histCorrection": "Correction : ",
    "histEchec": "Échec : ",
    "histVersion": "Version : ",
    "histPriorite": "Priorité : ",
    "echec": "Échec",
    "labelCommentaire": "Commentaire (optionnel)",
    "placeholderValidation": "Un mot sur la validation…",
    "confirmerValidation": "Confirmer la validation",
    "labelMotifEchec": "Motif de l'échec",
    "labelDetailObligatoire": "Détail (obligatoire)",
    "placeholderDetailEchec": "Décrivez ce qui ne va pas…",
    "labelCapturesOptionnel": "Captures (optionnel)",
    "renvoyerEchec": "Renvoyer (échec)",
    "metaVersion": "Version {v} · {p}",
    "aideTitre": "Aide — Faits techniques",
    "aideEtats": "Les états",
    "aideChamps": "Les champs",
    "aideBrouillons": "Brouillons",
    "permissionTitre": "Permission",
    "permissionPhotos": "Accès aux photos refusé.",
    "erreurTitre": "Erreur",
    "reponseComplementPrefix": "Réponse au complément : {r}",
    "nouveau": "Nouveau fait technique",
    "actionNouveau": "Nouveau",
    "labelModule": "Module concerné",
    "phTitreEx": "Ex. Le bouton ne réagit pas",
    "phContexte": "Où, quand, ce que tu attendais…",
    "envoiEnCours": "Envoi…",
    "envoyerRemontee": "Envoyer la remontée",
    "depuisLabel": "Depuis",
    "mesRemonteesSur": "Mes remontées sur {app}",
    "aucuneRemontee": "Aucune remontée depuis {app} pour l'instant.",
    "ivvFaitsTechniques": "IVV — Faits techniques"
  },
  "valideur": {
    "titre": "Valideur (IVV)",
    "erreur": "Erreur",
    "faitsTechniques": "Faits techniques",
    "faitsTechniquesSub": "Remonter, suivre et valider les anomalies",
    "fichesTest": "Fiches de test",
    "fichesTestSub": "Scénarios de vérification rejouables, étape par étape",
    "outilsFlottants": "Outils flottants",
    "fabLabel": "Bouton flottant pour ajouter un FT",
    "fabSub": "Affiche un « + » déplaçable sur toutes les pages.",
    "draftLabel": "Pastille flottante de brouillon",
    "draftSub": "Garde un brouillon de FT accessible en flottant pendant la navigation.",
    "testLabel": "Pastille flottante de test",
    "testSub": "Réduire un test de fiche pour aller faire l'action dans l'app, puis le reprendre via la pastille.",
    "questionnaires": "Questionnaires",
    "questionnairesSub": "Donner son avis sur les évolutions proposées",
    "calIvv": "Calendrier des versions",
    "calIvvSub": "Les FTs livrés, regroupés par version",
    "compteValideur": "Compte valideur IVV",
    "compteStandard": "Compte standard — tu peux quand même remonter un fait"
  },
  "calIvv": {
    "titre": "Calendrier des versions",
    "intro": "Chaque version livrée regroupe les faits techniques (FTs) implémentés.",
    "aucune": "Aucune version livrée pour le moment.",
    "nFts": "{n} FT"
  },
  "quest": {
    "titre": "Questionnaires",
    "titreDetail": "Questionnaire",
    "nouveau": "Nouveau questionnaire",
    "lever": "Lever le questionnaire",
    "aucun": "Aucun questionnaire pour le moment",
    "creeLe": "Créé le",
    "cloLe": "clôturé le",
    "ouvert": "Ouvert",
    "ferme": "Fermé",
    "accepte": "Accepté",
    "rejete": "Rejeté",
    "aujourdhui": "Aujourd'hui",
    "demain": "Évolution prévue",
    "decision": "Décision",
    "sansDecision": "Clôturé sans décision",
    "ftLie": "FT d'implémentation lié : #{n}",
    "implementeEn": "Implémenté en {v}",
    "votreAvis": "Votre avis",
    "utilite": "Niveau d'utilité (1 = inutile, 5 = très utile)",
    "phCommentaire": "Votre commentaire (optionnel)…",
    "envoyer": "Envoyer mon avis",
    "mettreAJour": "Mettre à jour mon avis",
    "retirer": "Retirer",
    "retirerTitre": "Retirer votre avis",
    "retirerMsg": "Supprimer votre réponse à ce questionnaire ?",
    "fermeInfo": "Questionnaire fermé — les réponses ne sont plus possibles.",
    "rapport": "Rapport des avis",
    "aucuneReponse": "Aucune réponse pour le moment.",
    "nReponses": "{n} réponse(s)",
    "commentaires": "Commentaires",
    "anonyme": "Anonyme",
    "participation": "Participation",
    "ontRepondu": "Ont répondu ({n})",
    "enAttente": "En attente ({n})",
    "tousRepondu": "Tous les valideurs ont répondu 🎉",
    "aucunValideur": "Aucun valideur IVV enregistré.",
    "relancer": "Relancer par mail ({n})",
    "relanceTitre": "Relance",
    "relanceAucunMail": "Aucune adresse e-mail pour les valideurs en attente.",
    "relanceErr": "Impossible d'ouvrir l'application e-mail.",
    "relanceSujet": "Rappel — Questionnaire IVV #{n}",
    "relanceCorps": "Bonjour,\n\nVotre avis est attendu sur l'évolution « {titre} » dans MoPCal : Profil → Valideur (IVV) → Questionnaires.\n\nMerci !",
    "admin": "Administration",
    "fermer": "Fermer le questionnaire",
    "cloturerTitre": "Clôturer le questionnaire",
    "cloturerSub": "Choisissez d'accepter (un FT d'implémentation sera créé) ou de rejeter l'évolution.",
    "phDecisionNote": "Note de décision (optionnel)…",
    "accepter": "Accepter",
    "rejeter": "Rejeter",
    "rouvrir": "Rouvrir",
    "rouvrirTitre": "Rouvrir le questionnaire",
    "rouvrirMsg": "Rouvrir ce questionnaire pour permettre à nouveau les réponses ?",
    "versionImpl": "Version d'implémentation",
    "supprTitre": "Supprimer le questionnaire",
    "supprMsg": "Supprimer définitivement ce questionnaire et tous ses avis ?",
    "champTitre": "Titre",
    "phTitre": "Titre de l'évolution",
    "phActuel": "Ce que l'utilisateur peut faire aujourd'hui…",
    "phEvolution": "Ce que l'utilisateur pourra / devra faire…",
    "erreur": "Erreur"
  },
  "fiches": {
    "titre": "Fiches de test",
    "titreModifier": "Modifier FdT-{n}",
    "titreNouvelle": "Nouvelle fiche",
    "titreTest": "Test FdT-{n}",
    "aide": "Aide",
    "aideTitre": "Aide — Fiches de test",
    "nouvelle": "Nouvelle fiche de test",
    "vide": "Aucune fiche de test. Touchez + pour en créer.",
    "nbEtape": "{n} étape",
    "nbEtapes": "{n} étapes",
    "lancer": "Lancer",
    "editer": "Éditer la fiche",
    "nomRequisTitre": "Nom requis",
    "nomRequisMsg": "Donne un nom à la fiche.",
    "etapesRequisesTitre": "Étapes requises",
    "etapesRequisesMsg": "Ajoute au moins une étape.",
    "erreur": "Erreur",
    "supprimerTitre": "Supprimer la fiche",
    "supprimerConfirm": "Supprimer définitivement « {nom} » ?",
    "labelNom": "Nom *",
    "phNom": "Ex. Suppression d'un calendrier",
    "labelDesc": "Explication du problème",
    "phDesc": "Contexte, pourquoi cette vérification…",
    "labelFt": "FT liée (numéro, optionnel)",
    "phFt": "Ex. 50",
    "labelEtapes": "Étapes",
    "etapeNum": "Étape {n}",
    "labelAction": "Action à effectuer",
    "phAction": "Ce que le testeur doit faire",
    "labelAttendu": "Résultat attendu",
    "phAttendu": "Ce qu'on doit voir",
    "ajouterEtape": "Ajouter une étape",
    "enregistrerModifs": "Enregistrer les modifications",
    "creerFiche": "Créer la fiche",
    "supprimerFiche": "Supprimer la fiche",
    "indisponibleTitre": "Indisponible",
    "indisponibleMsg": "La création de FT n'est pas disponible ici.",
    "ftObserve": "\nObservé : {note}",
    "ftTitre": "Échec test : {nom}",
    "ftContexte": "Fiche FdT-{numero} — {nom}",
    "ftEtapes": "Action : {action}\nAttendu : {attendu}{obs}",
    "brouillonTitre": "Brouillon FT créé",
    "brouillonMsg": "Un brouillon de FT a été pré-rempli. Complète-le (catégorie + capture) puis soumets-le.",
    "plusTard": "Plus tard",
    "ouvrirFt": "Ouvrir les FT",
    "incompletTitre": "Étapes incomplètes",
    "incompletMsg": "Renseigne un résultat (OK / KO / N/A) pour chaque étape avant d'enregistrer.",
    "abandonTestTitre": "Abandonner ce test ?",
    "abandonTestMsg": "Les réponses saisies seront perdues.",
    "abandonner": "Abandonner",
    "vueEnsemble": "Vue d'ensemble des tests",
    "couverture": "{passees} / {total} passées · couverture {pct} %",
    "nonPasse": "Non passé",
    "ficheLbl": "fiche",
    "fichesLbl": "fiches",
    "reinitFiltre": "Réinitialiser le filtre",
    "resultatTitre": "Résultat enregistré",
    "resultatMsg": "Test {statut}.",
    "progressSingulier": "{faites}/{total} étape traitée",
    "progressPluriel": "{faites}/{total} étapes traitées",
    "attendu": "Attendu",
    "phObserve": "Qu'as-tu observé ?",
    "creerFtAnomalie": "Créer un FT pour cette anomalie",
    "labelCommentaire": "Commentaire global (optionnel)",
    "phCommentaire": "Synthèse du passage de test…",
    "enregistrerResultat": "Enregistrer le résultat"
  },
  "rapportFT": {
    "titre": "Rapport de FTs",
    "bientot": "Bientôt disponible",
    "description": "Cette page de rapport / synthèse des faits techniques sera complétée ultérieurement (statistiques, exports, filtres…)."
  },
  "admin": {
    "titre": "Administration",
    "bonjour": "👋 Bonjour, administrateur",
    "bientot": "Bientôt",
    "masque": "Masqué",
    "erreur": "Erreur",
    "envoyer": "Envoyer",
    "creer": "Créer",
    "restaurer": "Restaurer le compte",
    "approuver": "Approuver",
    "refuser": "Refuser",
    "retirer": "Retirer",
    "chargerPlus": "Charger plus",
    "reinitialiser": "Réinitialiser",
    "reinitTitre": "Réinitialiser",
    "reinitDefauts": "Réinitialiser aux valeurs par défaut",
    "enregistre": "✓ Enregistré",
    "sauvegarde": "✓ Sauvegardé !",
    "sauvegardeEnCours": "Sauvegarde…",
    "grpUtilisateursAcces": "Utilisateurs & accès",
    "grpConfigApp": "Configuration de l'app",
    "grpSuivi": "Suivi",
    "menuUtilisateurs": "Utilisateurs",
    "menuUtilisateursDesc": "Ajouter · IVV · forfaits · mots de passe",
    "menuEmails": "Inscription",
    "menuEmailsDesc": "Autorisés · en attente · interdits",
    "menuAdmins": "Administrateurs",
    "menuAdminsDesc": "Gérer les comptes admin",
    "menuFonctionnalites": "Fonctionnalités",
    "menuFonctionnalitesDesc": "Activer/désactiver globalement",
    "menuSecurite": "Sécurité & timeout",
    "menuSecuriteDesc": "Déconnexion auto ({n} min)",
    "menuPub": "Publicité & plans",
    "menuPubDesc": "No-pub · plans premium",
    "menuPlans": "Plans & forfaits",
    "menuPlansDesc": "Limites et options par plan",
    "menuTelechargements": "Téléchargements",
    "menuTelechargementsDesc": "Liens web & stores (production)",
    "menuTraductions": "Traductions",
    "menuTraductionsDesc": "Textes de l'interface par langue",
    "menuFaits": "Faits techniques",
    "menuFaitsDesc": "Remontées des valideurs (FT)",
    "menuForfaits": "Demandes de forfait",
    "menuForfaitsDesc": "Accepter / refuser les changements",
    "menuConnexions": "Connexions",
    "menuConnexionsDesc": "Historique utilisateurs",
    "menuCalendriers": "Calendriers",
    "menuCalendriersDesc": "Tous les calendriers · supprimer",
    "utilisateursTitre": "👥 Utilisateurs",
    "ajouterUser": "Ajouter un utilisateur",
    "aucunUser": "Aucun utilisateur",
    "roleMaman": "🔴 Maman",
    "rolePapa": "🔵 Papa",
    "roleEnfant": "👦 Enfant",
    "creeParAdmin": " · créé par admin",
    "supprimeLe": "Supprimé le {date}",
    "inscritLe": "Inscrit le {date}",
    "enLigne": "En ligne",
    "enLigneDepuis": "En ligne · depuis le {date} à {heure}",
    "vuLe": "Vu le {date} à {heure}",
    "connexionNonEnregistree": "Connexion non encore enregistrée",
    "resetMdpTitre": "Réinitialiser le mot de passe",
    "forfaitFonctions": "Forfait",
    "plusActions": "Plus d'actions",
    "groupeValideurs": "Groupe de valideurs",
    "reinitMdpAction": "Réinitialiser le mot de passe",
    "refuserAcces": "Bloquer l'accès",
    "supprimer": "Supprimer",
    "resetMdpMsg": "Envoyer un email de réinitialisation à \"{email}\" ?",
    "emailEnvoyeTitre": "✓ Email envoyé",
    "emailEnvoyeMsg": "Un lien de réinitialisation a été envoyé à {email}.",
    "suppUserTitre": "Supprimer l'utilisateur",
    "suppUserMsg": "Désactiver le compte de \"{nom}\" ?\n\nIl ne pourra plus se connecter. Vous pourrez le restaurer depuis l'onglet Supprimés.",
    "errPrenom": "Entrez un prénom.",
    "errRole": "Choisissez un rôle.",
    "errEmail": "Adresse e-mail invalide.",
    "errMdp": "Mot de passe : 6 caractères minimum.",
    "userCreeTitre": "✓ Utilisateur créé",
    "userCreeMsg": "Le compte de \"{nom}\" a été créé avec succès.",
    "errEmailExiste": "Cette adresse email est déjà utilisée.",
    "errEmailInvalide": "Adresse email invalide.",
    "nouvelUserTitre": "➕ Nouvel utilisateur",
    "nouvelUserDesc": "Le compte sera créé directement avec le statut Actif.",
    "placeholderPrenom": "Prénom",
    "placeholderEmail": "Adresse email",
    "placeholderMdp": "Mot de passe (6 car. min)",
    "foncTitre": "🔧 Fonctionnalités",
    "foncWarning": "⚠️  Cet utilisateur n'a pas accès à l'application. Les fonctionnalités sont visibles mais désactivées.",
    "desactiveGlobalement": "🌍 Désactivé globalement",
    "planSimulation": "Plan (simulation)",
    "planSimulationDesc": "Forcer un plan pour simuler l'expérience premium.",
    "planGratuit": "Gratuit",
    "planFamille": "Famille",
    "planFamillePlus": "Famille+",
    "sansPub": "Sans publicite",
    "sansPubDesc": "Désactiver toutes les pubs pour cet utilisateur",
    "validateurIvv": "Validateur (IVV)",
    "validateurIvvDesc": "Accès à la page « Faits techniques » pour remonter des anomalies",
    "reinitUserMsg": "Remettre les fonctionnalités, le plan (gratuit) et le sans-publicité de cet utilisateur aux valeurs par défaut ?",
    "fonctGlobalesTitre": "🌍 Fonctionnalités globales",
    "fonctGlobalesNote1a": "Ces réglages s'appliquent à ",
    "fonctGlobalesNote1b": "tous les utilisateurs",
    "fonctGlobalesNote1c": " sans exception.",
    "fonctGlobalesNote2a": "Une fonctionnalité désactivée ici ",
    "fonctGlobalesNote2b": "disparaît complètement",
    "fonctGlobalesNote2c": " de l'application, indépendamment des réglages individuels.",
    "connexionsTitre": "📋 Historique des connexions",
    "aucuneConnexion": "Aucune connexion",
    "aucuneConnexionDesc": "Les connexions apparaîtront ici dès la prochaine ouverture de session.",
    "connexionsChargeesSingulier": "{n} connexion chargée",
    "connexionsChargeesPluriel": "{n} connexions chargées",
    "calendriersTitre": "📅 Tous les calendriers",
    "calBaseTitre": "Calendriers de la base",
    "calBaseDesc": "Liste paginée (25 par page) — conçue pour des milliers d'entrées sans perte de performance. La recherche filtre les calendriers déjà chargés.",
    "rechercheCalPlaceholder": "Rechercher (nom ou email créateur)…",
    "suppCalTitre": "Supprimer ce calendrier",
    "suppCalMsg": "Supprimer définitivement « {nom} » et TOUTES ses données (événements, planning, récurrents) ? Action irréversible.",
    "calChargesSingulier": "{n} chargé",
    "calChargesPluriel": "{n} chargés",
    "suffixeTout": " (tout)",
    "suffixeGeneral": " · général",
    "suffixeParticipants": " · {n} part.",
    "adminsTitre": "🛡️ Administrateurs",
    "comptesAdminTitre": "Comptes administrateur",
    "comptesAdminDesc": "Les administrateurs ont accès à ce panneau. Pour qu'un email fonctionne, la personne doit créer un compte dans l'app avec cette adresse (elle arrivera directement avec les droits).\nSécurités : vous ne pouvez pas vous retirer vous-même, ni supprimer le dernier administrateur.",
    "errAdminExiste": "Cet email est déjà administrateur.",
    "actionImpossible": "Action impossible",
    "retraitSoiMeme": "Vous ne pouvez pas vous retirer vous-même.",
    "retraitDernierAdmin": "Il doit rester au moins un administrateur.",
    "retirerAdminTitre": "Retirer cet administrateur",
    "retirerAdminMsg": "Retirer « {email} » des administrateurs ?",
    "adminEmailPlaceholder": "admin@mopsuite.fr",
    "btnAjouter": "+ Ajouter",
    "adminsCompteSingulier": "{n} administrateur",
    "adminsComptePluriel": "{n} administrateurs",
    "suffixeVous": "  (vous)",
    "emailsTitre": "📝 Inscription",
    "modeInscrTitre": "Mode d'inscription",
    "modeAutoDesc": "Accès automatique dès que l'e-mail est vérifié (sans approbation).",
    "modeManuelDesc": "E-mail vérifié + approbation manuelle requis.",
    "tabAutorises": "Autorisés",
    "tabAttente": "En attente",
    "tabInterdits": "Interdits",
    "aucuneAttente": "Aucune demande en attente.",
    "aucunInterdit": "Aucun e-mail interdit.",
    "autoriser": "Autoriser",
    "interdire": "Interdire",
    "interdireTitre": "Interdire cet e-mail",
    "interdireMsg": "Bloquer définitivement \"{email}\" ? La demande sera refusée et l'adresse ajoutée à la liste interdite.",
    "debloquer": "Débloquer",
    "interditLe": "Interdit le {date}",
    "attMin": "en attente depuis {n} min",
    "attHeures": "en attente depuis {n} h",
    "attJours": "en attente depuis {n} j",
    "listeBlancheTitre": "Liste blanche d'inscription",
    "listeBlancheDesc": "Si la liste est vide, toute adresse email peut s'inscrire.\nSi elle contient des entrées, seules les adresses actives peuvent créer un compte.",
    "errEmailDejaListe": "Cet email est déjà dans la liste",
    "lienManquantTitre": "Lien manquant",
    "lienManquantMsg": "Configurez d'abord le lien Expo dans \"Mise à jour & Invitations\".",
    "invitationEnvoyeeTitre": "✅ Envoyé",
    "invitationEnvoyeeMsg": "Invitation envoyée à {email}",
    "retirerEmailMsg": "Retirer \"{email}\" de la liste ?",
    "emailPlaceholder": "nouvelle@adresse.fr",
    "aucunEmail": "Aucune adresse autorisee",
    "aucunEmailDesc": "Toute adresse peut s'inscrire actuellement",
    "adressesSingulier": "{n} adresse",
    "adressesPluriel": "{n} adresses",
    "activesSingulier": "{n} active",
    "activesPluriel": "{n} actives",
    "ajouteLe": "Ajouté le {date}",
    "telechargementsTitre": "📲 Téléchargements",
    "majAutoTitre": "Mises à jour automatiques",
    "majAutoDesc": "Plus besoin d'envoyer un lien : sur le web il suffit de recharger la page, et sur mobile l'app se met à jour seule au démarrage (un message la propose). Cette page sert à préparer les liens de téléchargement pour la mise en production (App Store / Google Play).",
    "liensAccesTitre": "Liens d'accès",
    "lienWebLabel": "Application web (lien d'accès / invitations)",
    "lienIosLabel": "App Store (iOS) — production",
    "lienAndroidLabel": "Google Play (Android) — production",
    "securiteTitre": "⏱ Sécurité & Timeout",
    "deconnexionAutoTitre": "Déconnexion automatique",
    "deconnexionAutoDesc": "Les utilisateurs sont automatiquement déconnectés après la durée d'inactivité configurée ci-dessous.\n\nL'administrateur n'est pas soumis à cette règle.",
    "dureeInactivite": "Durée d'inactivité avant déconnexion",
    "minutes": "minutes",
    "minAbbr": "{n} min",
    "errTimeout": "Valeur entre 1 et 480 minutes",
    "securiteNote": "ℹ️  La vérification se fait toutes les 30 secondes. Si l'utilisateur revient sur l'application après inactivité, il est déconnecté immédiatement au retour au premier plan.",
    "pubTitre": "📢 Publicité",
    "pubNote1a": "Ces paramètres contrôlent ",
    "pubNote1b": "quand et où",
    "pubNote1c": " la ",
    "pubNote1d": "pub plein écran (événement)",
    "pubNote1e": " s'affiche.",
    "pubNote2a": "Deux types de pub, réglables par plan dans « Plans & forfaits » : ",
    "pubNote2b": "bandeau (fixe)",
    "pubNote2c": " et ",
    "pubNote2d": "plein écran (événement)",
    "pubNote2e": ".",
    "pubNote3a": "Par défaut — ",
    "pubNote3b": " : bandeau + plein écran · ",
    "pubNote3c": " : bandeau seul · ",
    "pubNote3d": " : aucune.",
    "pubNote4a": "« Sans publicité » (fiche utilisateur 🔧) désactive les ",
    "pubNote4b": "deux",
    "pubNote4c": " pour ce compte.",
    "pubPleinEcran": "Publicité plein écran",
    "pubActivee": "Activée",
    "pubActiveeDesc": "Afficher des publicités plein écran dans l'application",
    "conditionsDeclenchement": "Conditions de déclenchement (OU)",
    "apresNOuvertures": "Après N ouvertures de l'app",
    "memeSession": "Dans la même session",
    "apresNMinutes": "Après N minutes d'utilisation",
    "dureeCumulee": "Durée cumulée dans la session",
    "limitesAffichage": "Limites d'affichage",
    "delaiEntreAffichages": "Délai entre deux affichages",
    "delaiEntreAffichagesDesc": "Minutes minimum entre deux publicités",
    "maxParJour": "Maximum par jour",
    "maxParJourDesc": "Nombre max d'affichages par utilisateur par jour",
    "pagesAutorisees": "Pages autorisées",
    "pagesAutoriseesDesc": "Écrans où la pub peut se déclencher",
    "plansTitre": "🏷️ Plans & forfaits",
    "plansNote1a": "Ajustez les ",
    "plansNote1b": "limites",
    "plansNote1c": " et ",
    "plansNote1d": "options",
    "plansNote1e": " de chaque plan. Les modifications s'appliquent ",
    "plansNote1f": "en temps réel",
    "plansNote1g": " à tous les utilisateurs concernés.",
    "plansAstuce": "Astuce : « ∞ » = illimité.",
    "activeAffichees": "(activé = affichées)",
    "prixMensuel": "Prix mensuel (€)",
    "prixAnnuel": "Prix annuel (€)",
    "enregistrerPlans": "Enregistrer les plans",
    "plansEnregistresTitre": "Enregistré",
    "plansEnregistresMsg": "Les plans ont été mis à jour pour tous les utilisateurs.",
    "reinitPlansMsg": "Revenir aux valeurs par défaut de tous les plans ?",
    "forfaitsTitre": "💳 Demandes de forfait",
    "adminParDefaut": "Admin",
    "aucuneDemande": "Aucune demande.",
    "utilisateurParDefaut": "Utilisateur",
    "demandeLe": "Demandé le {date}",
    "accesSansEcheance": "Accès sans échéance",
    "jusquAu": "Jusqu'au {date}",
    "parTraitePar": " · par {nom}",
    "motifLabel": "Motif : {motif}",
    "accepter": "Accepter",
    "refuserCourt": "Refuser",
    "accepterDemandeTitre": "Accepter la demande",
    "passerAuPlanA": "Passer {nom} au plan",
    "cetUtilisateur": "cet utilisateur",
    "echeance30j": "30 jours (renouvelable)",
    "sansEcheance": "Sans échéance",
    "refuserDemandeTitre": "Refuser la demande",
    "motifOptionnel": "Motif (optionnel)",
    "confirmerRefus": "Confirmer le refus",
    "comptes": "Comptes",
    "forfaits": "Forfaits",
    "compte": "Compte",
    "rechercheCompte": "E-mail, prénom…",
    "tous": "Tous",
    "aucunCompte": "Aucun compte",
    "aucunCompteAide": "Aucun compte ne correspond à cette recherche.",
    "nComptes": "{n} compte(s)",
    "forfait": "Forfait",
    "statut": "Statut",
    "statut_actif": "Actif",
    "statut_en_attente": "En attente",
    "statut_suspendu": "Suspendu",
    "roles": "Rôles",
    "role_admin": "Administrateur",
    "role_commerce": "Commerce",
    "role_ivv": "Valideur IVV",
    "rolesAide": "Les rôles ne prennent effet en base qu'une fois le jeton (custom claim) mis à jour côté serveur.",
    "plansPaliers": "Ce que chaque forfait inclut",
    "palierInclusAide": "Palier inclus par ce forfait.",
    "fonctions": "Fonctions",
    "nFonctions": "{n} fonction(s)",
    "autresFonctions": "Autres",
    "forfaitsAide": "L'interrupteur coupe la fonction pour TOUS (coupe-circuit). Le palier détermine à partir de quel forfait elle est incluse ; au-delà, elle reste achetable à la carte.",
    "accesRefuse": "Accès réservé",
    "accesRefuseAide": "Cette application est réservée à l'administration et au commerce.",
    "demandeForfait": "Demande de forfait : {plan}",
    "nDemandes": "{n} demande(s) de forfait en attente",
    "acces": "Acces",
    "prenom": "Prenom",
    "phPrenom": "Prenom affiche",
    "nouveauCompte": "Nouveau compte",
    "mdpProvisoire": "Mot de passe provisoire",
    "phMdp": "6 caracteres minimum",
    "nouveauCompteAide": "Le compte est cree actif. Envoie ensuite le lien de mot de passe pour que la personne choisisse le sien.",
    "options": "Options",
    "accesIllimite": "Acces illimite (toutes fonctions)",
    "actions": "Actions",
    "envoyerLienMdp": "Envoyer un lien de mot de passe",
    "envoyerLienMdpMsg": "Envoyer un lien de reinitialisation a {email} ?",
    "lienEnvoye": "Lien envoye",
    "supprimerCompte": "Supprimer le compte",
    "supprimerCompteMsg": "Le compte {email} sera marque supprime (restaurable).",
    "supprimerDefinitif": "Supprimer definitivement",
    "supprimerDefinitifMsg": "Compte {email} : suppression DEFINITIVE et IRREVERSIBLE (identite Firebase + toutes les donnees). Continuer ?",
    "compteSupprimeDefinitivement": "Compte supprime definitivement",
    "queFaireCompte": "Que faire de ce compte ?",
    "creeLe": "Cree le",
    "derniereConnexion": "Derniere connexion",
    "compteSupprime": "Compte supprime",
    "compteRestaure": "Compte restaure",
    "suppressionAide": "La suppression est douce : le compte reste restaurable et l'historique est conserve.",
    "inscriptionEnAttente": "Inscription en attente d'approbation",
    "rejeter": "Rejeter",
    "compteApprouve": "Compte approuve",
    "compteRejete": "Compte rejete",
    "forfaitApplique": "Forfait applique",
    "groupeIVV": "Groupe IVV",
    "aucunGroupe": "Aucun",
    "nomGroupe": "Nom du groupe",
    "phNomGroupe": "Ex. Famille Martin",
    "groupeIVVAide": "Les comptes partageant ce nom forment une seule identite de valideur : memes faits techniques et memes reponses aux questionnaires.",
    "emailsAutorises": "E-mails autorises",
    "nEmails": "{n} e-mail(s)",
    "emailsAutorisesAide": "Seules ces adresses peuvent creer un compte. L'interrupteur suspend une adresse sans la supprimer ; balaie pour retirer.",
    "administrateurs": "Administrateurs & commerce",
    "nAdmins": "{n} admin(s) - {c} commerce",
    "nAttente": "{n} en attente",
    "nInterdits": "{n} interdit(s)",
    "administrateursAide": "Ces listes determinent les roles reels (jeton de securite). Un changement recalcule automatiquement les droits.",
    "aucunCommerce": "Aucun commercial",
    "retirerAdmin": "Retirer l'administrateur",
    "retirerCommerce": "Retirer le commercial",
    "retirerRoleMsg": "Retirer ce role a {email} ?",
    "rolesDepuisComptes": "Pour DONNER un role, ouvre le compte dans l'onglet Comptes.",
    "filtreStatut": "Statut",
    "avecDemande": "Avec demande",
    "statut_supprime": "Supprime",
    "aTraiter": "A traiter",
    "sansDemande": "Sans demande",
    "fonctionsParApp": "Fonctions par application",
    "moduleAVenir": "Module a venir",
    "moduleAVenirAide": "Cette application n'a pas encore declare ses fonctions.",
    "rechercheEmail": "Rechercher une adresse",
    "choisirCompte": "Choisir un compte",
    "autoriserCompte": "Autoriser un compte",
    "swipeRetirer": "Balaie une ligne (ou appui long sur le web) pour retirer le role.",
    "appuiLongSupprimer": "Appui long pour retirer",
    "ivv": "IVV",
    "sansIVV": "Sans IVV",
    "nonInscrit": "Pas encore inscrit",
    "sansNom": "Inscrit — nom non renseigné",
    "avecIVV": "Compte IVV",
    "jetonsGestion": "Elements gerables",
    "jetonsVue": "Elements consultables",
    "jetonsAide": "Nombre d'elements (calendrier, inventaire...) utilisables avec ce forfait. Un jeton ⚙️ permet de modifier et peut etre donne a quelqu'un ; un jeton 👁 permet seulement de consulter.",
    "maxEspaces": "Espaces",
    "maxEspacesAide": "Nombre d'espaces qu'un compte de ce forfait peut posseder (1 minimum). Un espace ne consomme pas de jeton.",
    "modifierForfait": "Modifier le forfait",
    "nomAffiche": "Nom affiché",
    "prixMensuel": "Prix mensuel (€)",
    "prixAnnuel": "Prix annuel (€)",
    "piecesJointesMax": "Pièces jointes par mois",
    "demandesMoisMax": "Demandes par mois",
    "historiqueJours": "Historique (jours)",
    "pubFixe": "Bandeau publicitaire",
    "pubEvenement": "Publicité plein écran",
    "exportPdf": "Export PDF",
    "syncCalendrier": "Synchronisation calendrier externe",
    "tarifsAide": "Ces valeurs sont lues par toutes les apps (écran « Mon forfait ») dès l'enregistrement — aucune mise à jour à publier.",
    "limitesParType": "Limites par élément",
    "limitesParTypeAide": "Plafond du nombre de chaque type d'élément, indépendant des jetons ci-dessus. Pas encore appliqué par les autres apps : réglable dès maintenant, à consommer plus tard.",
    "typeCalendriers": "Calendriers",
    "typeInventaires": "Inventaires & plans",
    "typeRepas": "Repas & menus",
    "typeComptes": "Budgets & comptes",
    "poidsFonction": "Poids (points)",
    "pointsInclus": "Points inclus",
    "pointsInclusAide": "Budget de points offerts pour l'achat à la carte, au-delà de ce que le forfait inclut déjà.",
    "baremePoints": "Barème à la carte",
    "baremePointsAide": "Prix mensuel selon le nombre de points pris AU-DELÀ du budget inclus par le forfait — pas un prix par fonction.",
    "baremeJusqua": "Jusqu'à {n} pts",
    "baremeAuDela": "Au-delà",
    "jusqua": "Jusqu'à",
    "pts": "pts",
    "ajouterPalier": "Ajouter un palier",
    "demandeAchats": "Demande d'achats à la carte",
    "demandeAchatsResume": "{n} point(s) demandé(s)",
    "achatsAppliques": "Achats appliqués"
  },
  "adminFT": {
    "choisir": "Choisir…",
    "permission": "Permission",
    "permissionPhotos": "Accès aux photos refusé.",
    "champsRequis": "Champs requis",
    "champsRequisMsg": "Titre et catégorie (+ précision) obligatoires.",
    "cree": "✓ Créé",
    "creeMsg": "FT {n} créé.",
    "erreur": "Erreur",
    "titre": "Faits techniques",
    "historique": "Historique",
    "historiqueVide": "Aucun fait technique clôturé",
    "rechercheHist": "Rechercher (n° de FT, mots-clés…)",
    "rechercheAucun": "Aucune FT ne correspond à votre recherche",
    "versionNonRenseignee": "Version non renseignée",
    "aTraiter": "À traiter ({n})",
    "parEtat": "Par état",
    "total": "Total : {n}",
    "anomaliesParVersion": "Anomalies par version",
    "corrigeesTotal": "corrigées / total",
    "afficherVersions100": "Afficher les versions à 100 % ({n})",
    "masquerVersions100": "Masquer les versions à 100 % ({n})",
    "toutesCorrigees": "Toutes les versions sont corrigées à 100 %.",
    "totalCorrigees": "Total : {res}/{tot} corrigées",
    "reinitFiltres": "Réinitialiser les filtres",
    "soumisClotures30j": "Soumis / clôturés (30 jours)",
    "soumis": "Soumis",
    "clotures": "Clôturés",
    "implementes": "Implémentés",
    "totalSoumisClotures": "Total : {soumis} soumis · {clotures} clôturés",
    "totalSoumisCloturesImpl": "Total : {soumis} soumis · {impl} implémentés · {clotures} clôturés",
    "filtre": "Filtre : {liste}",
    "aucun": "Aucun fait technique",
    "ligneTypeCategorie": "Type : {type} · Catégorie : {categorie}",
    "autoAnalyseDemandee": "Analyse automatique demandée",
    "autoImplementationDemandee": "Implémentation automatique demandée",
    "routineProchainCycle": "La routine traitera ce FT au prochain cycle.",
    "echecTraitementAuto": "Échec du traitement automatique",
    "lignePageFonc": "Page : {page} · Fonctionnalité : {fonctionnalite}",
    "ligneAttendu": "Attendu : {attendu}",
    "ligneConfiance": " (confiance : {confiance})",
    "ligneContexte": "Contexte : {contexte}",
    "ligneEtapes": "Étapes : {etapes}",
    "analyseCause": "Analyse — cause",
    "correctionPrevue": "Correction prévue",
    "implementeEnVersion": "Implémenté en v{version}",
    "suivi": "Suivi",
    "labelPageOnglet": "Page / onglet (à revoir)",
    "labelFonctionnalite": "Fonctionnalité (à revoir)",
    "labelCause": "Cause du problème",
    "phRaison": "Raison…",
    "labelCorrection": "Correction possible",
    "phCorrection": "Explication de la correction…",
    "validerAnalyse": "Valider l'analyse → Analysé",
    "labelInfoManquante": "Information manquante",
    "phInfoManquante": "Que doit préciser le valideur ?",
    "demanderComplementNeedInfo": "Demander complément → Need-info",
    "labelVersionImpl": "Version d'implémentation",
    "phVersionImpl": "ex : 3.4.0.0",
    "marquerImplemente": "Marquer Implémenté",
    "labelRaisonRejet": "Raison du rejet",
    "labelPiecesJointes": "Pièces jointes (optionnel)",
    "rejeter": "Rejeter",
    "labelRaisonReport": "Raison du report",
    "phRaisonReport": "Pourquoi reporter (pas dans une version immédiate) ?",
    "reporterVersReporte": "Reporter → Reporté",
    "analyseDemandee": "⏳ Analyse demandée…",
    "analyserAuto": "⚡ Analyser automatiquement",
    "analyserManuellement": "Analyser manuellement",
    "demanderComplement": "Demander complément",
    "affecterPriorite": "Affecter une priorité (CCB)",
    "reporter": "Reporter",
    "implementationDemandee": "⏳ Implémentation demandée…",
    "implementerAuto": "⚡ Implémenter automatiquement",
    "marquerImplementeManuel": "Marquer Implémenté manuellement…",
    "reanalyserSolution": "Ré-analyser (revoir la solution)",
    "cloturer": "Clôturer",
    "attenteValidation": "En attente de validation par le valideur.",
    "reporteAReprendre": "Reporté — à reprendre quand planifié.",
    "reanalyser": "Ré-analyser",
    "aideTitre": "Aide — Faits techniques",
    "aideLesEtats": "Les états",
    "aideLesChamps": "Les champs"
  },
  "layout": {
    "moi": "Moi",
    "infoFiltreAstuce": "Touchez le filtre pour l'activer ou le désactiver.",
    "aideMoi": "N'afficher que les événements que vous avez créés.",
    "aideCategorie": "Masquer ou réafficher les événements de la catégorie « {nom} ».",
    "aideRecurrent": "Masquer ou réafficher les événements récurrents (qui se répètent automatiquement).",
    "aideRepas": "Masquer ou réafficher les repas planifiés (planning des menus).",
    "aideEdt": "Masquer ou réafficher les créneaux d'emploi du temps.",
    "aideAutre": "Masquer ou réafficher les autres événements (ni récurrents, ni repas, ni emploi du temps)."
  },
  "membres": {
    "titre": "Qui peut voir cet événement ?",
    "groupes": "Groupes",
    "personnes": "Personnes",
    "aucun": "Aucune personne à proposer."
  },
  "formJour": {
    "parent1": "Parent 1",
    "parent2": "Parent 2",
    "baisserClavier": "Baisser le clavier",
    "spectateurs": "Spectateurs",
    "ajouterSpectateurs": "Ajouter",
    "erreur": "Erreur",
    "moi": "Moi",
    "inconnu": "Inconnu",
    "heureInvalide": "Heure invalide",
    "heureFinApres": "L'heure de fin doit être après l'heure de début.",
    "heuresDeuxRequises": "Renseignez l'heure de début ET de fin, ou laissez les deux vides.",
    "permissionRefusee": "Permission refusée",
    "autoriserPhotos": "Autorisez l'accès aux photos.",
    "autoriserCamera": "Autorisez l'accès à la caméra.",
    "fichierImpossible": "Impossible d'ouvrir le fichier : {msg}",
    "ouvertureFichierImpossible": "Impossible d'ouvrir cette pièce jointe.",
    "locServicesDesactives": "📵 Services de localisation désactivés. Activez-les dans Réglages → Confidentialité → Service de localisation.",
    "locNonAutorisee": "⚠️ Localisation non autorisée. Activez-la dans Réglages → MoPCal.",
    "adresseIntrouvable": "Position obtenue mais adresse introuvable.",
    "gpsLent": "⏱ GPS trop lent. Réessayez à l'extérieur ou cherchez manuellement.",
    "positionImpossible": "Impossible d'obtenir la position.",
    "dateFinApres": "La date de fin doit être après la date de début.",
    "evtRecurrentTitre": "🔁 Événement récurrent",
    "quoiSupprimer": "Que souhaitez-vous supprimer ?",
    "cetteOccurrence": "Cette occurrence seulement",
    "toutesOccurrences": "Toutes les occurrences",
    "supprimerEvt": "Supprimer l'événement",
    "supprimerConfirm": "Supprimer \"{titre}\" ?",
    "envoyer": "📬 Envoyer",
    "garde": "Garde : {label}",
    "changementGarde": "Changement de garde → {label}",
    "evenementLabel": "Événement : {titre}",
    "sansTitre": "(sans titre)",
    "demandeAValider": "📬 Demande à valider",
    "demandePar": "Demandé par {nom}",
    "refuser": "Refuser",
    "approuver": "Approuver",
    "aucunEvenement": "Aucun événement ce jour",
    "modifie": "· modifié",
    "recurrent": "Récurrent",
    "exportIcs": "Exporté vers l'agenda",
    "nonExporte": "Non exporté vers l'agenda",
    "piecesJointes": "Pièces jointes",
    "visPrive": "🔒 Privé",
    "visParents": "👥 Parents",
    "heureDebut": "⏰ Heure de début",
    "heureFin": "⏰ Heure de fin",
    "proposerEvenement": "📬 Proposer un événement",
    "ajouterEvenement": "+ Ajouter un événement",
    "choisirLieu": "📍 Choisir un lieu",
    "localisation": "Localisation…",
    "utiliserPosition": "🎯  Utiliser ma position actuelle",
    "ouRechercher": "ou rechercher",
    "lieuPlaceholder": "École, médecin, parc…",
    "resultatSingulier": "{n} résultat",
    "resultatsPluriel": "{n} résultats",
    "defiler": "↕ défiler",
    "aucunResultat": "Aucun résultat — essayez avec d'autres mots",
    "visTous": "Tous",
    "visParentsCourt": "Parents",
    "visPriveCourt": "Privé",
    "visDescTous": "Visible par les deux parents et les visiteurs",
    "visDescParents": "Visible par les deux parents uniquement",
    "visDescPrive": "Visible par vous uniquement",
    "recBanner": "🔁 Événement récurrent — utilisez le bouton 🗑️ pour supprimer cette occurrence ou toute la série.",
    "titrePlaceholder": "Titre *",
    "deplace": "déplacé",
    "transfertVersAutre": "Déplacer / copier vers un autre calendrier",
    "transfertChoisirCal": "Vers quel calendrier ?",
    "transfertTitre": "Déplacer ou copier",
    "transfertVers": "Vers « {nom} » : déplacer (retirer d'ici) ou copier ?",
    "deplacer": "Déplacer",
    "copier": "Copier",
    "calendrier": "Calendrier",
    "debut": "Début",
    "fin": "Fin",
    "lieuOptionnel": "Lieu (optionnel)",
    "notePlaceholder": "Note (optionnel)",
    "categorie": "📂 Catégorie",
    "visiblePar": "👁 Visible par :",
    "inclureExport": "📤 Inclure par défaut à l'export",
    "responsable": "Responsable",
    "modeGarde": "🔄 Mode garde",
    "demanderApprobation": "📬 Demander approbation",
    "demandeApprobationDesc": "L'autre parent devra approuver avant publication",
    "messagePlaceholder": "Message pour l'autre parent (optionnel)...",
    "plageDates": "📅 Plage de dates",
    "duAu": "Du {debut} au {fin}",
    "finLabel": "Fin :",
    "choisirDate": "Choisir une date…",
    "repetition": "🔁 Répétition",
    "recHebdo": "Chaque semaine — {jours}",
    "recBimensuel": "Toutes les 2 semaines",
    "recMensuel": "Chaque mois",
    "recJusquau": " jusqu'au {date}",
    "recSansFin": " — sans fin",
    "typeHebdo": "Chaque semaine",
    "typeBimensuel": "2 semaines",
    "typeMensuel": "Mensuel",
    "sansFin": "Sans fin",
    "enAttenteEnvoi": "En attente d'envoi",
    "galerie": "🖼️ Galerie",
    "camera": "📸 Caméra",
    "fichier": "📎 Fichier",
    "envoiFichiers": "📤 Envoi des fichiers en cours…"
  },
  "brouillon": {
    "choisir": "Choisir…",
    "permissionTitre": "Permission",
    "permissionPhotos": "Accès aux photos refusé.",
    "enregistreOk": "🔖 Brouillon enregistré",
    "erreur": "Erreur",
    "champsRequisTitre": "Champs requis",
    "champsRequisMsg": "Titre, catégorie (+ précision) et au moins une capture.",
    "envoyeOk": "✓ Envoyé",
    "ftCree": "FT {n} créé.",
    "fermerTitre": "Fermer",
    "fermerMsg": "Garder ce brouillon ?",
    "abandonner": "Abandonner",
    "titre": "Brouillon",
    "labelTitre": "Titre *",
    "phResumeCourt": "Résumé court",
    "labelType": "Type",
    "labelGravite": "Gravité",
    "labelCategorie": "Catégorie *",
    "labelPage": "Page / onglet concerné *",
    "labelFonctionnalite": "Fonctionnalité *",
    "labelPreciser": "Préciser *",
    "phPreciser": "De quoi s'agit-il ?",
    "labelPlateforme": "Plateforme",
    "labelVersion": "Version de l'app",
    "labelContexte": "Contexte",
    "phContexte": "Ce qui s'est passé…",
    "labelEtapes": "Étapes pour reproduire",
    "phEtapes": "1. … 2. …",
    "labelComportement": "Comportement attendu",
    "phComportement": "Ce qui devrait se passer…",
    "labelNiveauConfiance": "Niveau de confiance",
    "labelCaptures": "Captures *",
    "hint": "Obligatoires : titre, catégorie (+ précision) et au moins une capture. 🔖 enregistre, ✈️ soumet."
  },
  "erreur": {
    "titre": "Oups, un souci d'affichage",
    "message": "L'application a rencontré une erreur sur cet écran, mais elle n'est pas perdue. Touchez « Réessayer » pour revenir.",
    "reessayer": "Réessayer",
    "detailLabel": "Détail (à transmettre au support) :",
    "inattendue": "Erreur inattendue"
  },
  "horsLigne": {
    "message": "Connexion instable — l'app reste utilisable, vos modifications seront synchronisées au retour du réseau."
  },
  "pub": {
    "simulation": "SIMULATION",
    "titre": "Publicité plein écran",
    "sousTitre": "Cet espace sera occupé par une vraie publicité.",
    "dimensions": "Interstitiel · 320 × 480 px",
    "accessibilite": "Publicité (simulation)",
    "annonce": "Annonce",
    "titreBanniere": "Votre publicité ici",
    "sousBanniere": "Emplacement bandeau · simulation"
  },
  "selecteurLieu": {
    "placeholder": "Choisir un lieu…",
    "titre": "Lieux du calendrier",
    "vide": "Aucun lieu enregistré.",
    "videAjout": "Ajoute-en dans Famille → Lieux.",
    "aucun": "Aucun"
  },
  "forfait": {
    "lim_calendriers": "Calendriers",
    "lim_evenementsParJour": "Événements / jour",
    "lim_piecesJointes": "Pièces / événement",
    "lim_demandesParMois": "Demandes / mois",
    "lim_historiqueDays": "Historique (jours)",
    "opt_exportPdf": "Export PDF",
    "opt_syncCalendrier": "Synchronisation calendrier",
    "groupeCore": "Cœur — commun à la suite",
    "groupeApp": "Application — {nom}",
    "cetteApp": "cette app",
    "aLaCarte": "à la carte",
    "indisponible": "indisponible",
    "fonctionsActivation": "Fonctions & activation",
    "intro": "Active ou désactive les fonctions pour préparer les forfaits. Le palier requis et les options « à la carte » sont indiqués. La configuration des plans reste gérée par l'administrateur.",
    "aucuneFonction": "Aucune fonction déclarée.",
    "monForfait": "Mon forfait",
    "monForfaitAide": "Ton forfait détermine les fonctions disponibles. Touche un autre forfait pour en faire la demande.",
    "plan_essentiel": "Essentiel",
    "plan_pro": "Pro",
    "actuel": "Actuel",
    "nFonctions": "{n} fonction(s) incluse(s)",
    "contenuNonConfigure": "Contenu à préciser",
    "demander": "Demander",
    "demanderTitre": "Demander un forfait",
    "demanderMsg": "Envoyer une demande pour le forfait « {plan} » ? Elle sera validée par l'équipe.",
    "demandeEnCours": "Demande en cours : {plan}",
    "validationAide": "Un forfait gratuit change après validation par l'équipe. Un forfait payant s'active tout de suite après paiement, sans validation.",
    "payer": "Payer {prix} €/mois",
    "passerGratuit": "Passer en gratuit",
    "passerGratuitTitre": "Passer en gratuit",
    "passerGratuitMsg": "Ton abonnement est annulé immédiatement et ton forfait repasse en gratuit. Confirmer ?",
    "erreurPaiement": "Impossible d'ouvrir la page de paiement. Réessaie dans un instant.",
    "featJetons": "{g} element(s) gerable(s) + {v} en consultation",
    "featFonctions": "{n} fonction(s) incluses",
    "featPieces": "{n} piece(s) jointe(s) par mois",
    "featHistorique": "Historique : {n} jours",
    "featExportPdf": "Export PDF",
    "featSync": "Synchronisation calendrier",
    "featSansPub": "Aucune publicite",
    "featSansPubPleinEcran": "Sans publicite plein ecran",
    "parMois": "/mois",
    "demandeEnvoyee": "Demande envoyee",
    "desactivee": "desactivee par toi",
    "toujoursIncluse": "toujours incluse",
    "sansEffet": "coupee, mais sans effet",
    "surchargeRequise": "Ces interrupteurs ne s'appliquent que si « Surcharger les fonctions (IVV) » est active dans ton profil. Sans elle, seul le forfait decide.",
    "indispensable": "indispensable",
    "demandeAchatsEnCours": "Demande à la carte en cours",
    "demandeAchatsAide": "En attente de validation par l'équipe. Aucun paiement n'est demandé pendant la phase de test.",
    "aLaCarteIntro": "Votre forfait inclut {n} point(s) à dépenser librement ci-dessous, en plus de ce qu'il donne déjà.",
    "aLaCarteAucune": "Aucune fonction supplémentaire à ajouter — tout ce qui est achetable est déjà inclus dans votre forfait.",
    "aLaCarteQuotasIntro": "Plafonds (calendriers, éléments, espaces…)",
    "aLaCartePoints": "{n} point(s) au total ({inclus} inclus par le forfait)",
    "envoyerDemande": "Envoyer la demande",
    "aLaCarte": "À la carte",
    "aLaCarteSous": "Fonctions et plafonds en plus du forfait"
  },
  "apprentissage": {
    "titre": "Tutoriel & Mise en Pratique",
    "intro": "Apprends à utiliser chaque fonction : lis le tutoriel, puis mets-le en pratique. Une mise en pratique se réduit pour que tu ailles faire l'action dans l'app, puis reviennes cocher.",
    "progression": "Votre progression",
    "tutoriels": "Tutoriels",
    "misesEnPratique": "Mises en pratique",
    "vus": "Vus",
    "aVoir": "À voir",
    "faites": "Faites",
    "aFaire": "À faire",
    "voir": "Voir",
    "revoir": "Revoir",
    "faire": "Faire",
    "refaire": "Refaire",
    "mepAVenir": "Mises en pratique à venir.",
    "mepCompteur": "Mises en pratique · {n}/{tot}",
    "termine": " · terminé ✓",
    "grp_general": "Général & compte",
    "grp_calendrier": "Calendrier & événements",
    "grp_echanger": "Échanger en famille",
    "grp_organiser": "Organiser le temps",
    "grp_maison": "La maison au quotidien",
    "grp_memoire": "Mémoire & suivi",
    "etapeFaite": "Fait",
    "indice": "Indice",
    "sExercer": "S'exercer",
    "enCours": "en cours"
  },
  "version": {
    "enAttente": "en attente…",
    "aJour": "à jour",
    "mettreAJour": "mettre à jour"
  },
  "comptes": {
    "titre": "Mes comptes",
    "sessionExpiree": "Session expirée pour ce compte. Ajoute-le à nouveau.",
    "basculeImpossible": "Bascule impossible.",
    "retraitImpossible": "Retrait impossible.",
    "identifiantsRequis": "E-mail et mot de passe requis.",
    "connexionImpossible": "Connexion impossible.",
    "retirerCompte": "Retirer ce compte",
    "email": "E-mail",
    "motDePasse": "Mot de passe",
    "masquerMdp": "Masquer le mot de passe",
    "afficherMdp": "Afficher le mot de passe",
    "ajouterCompte": "Ajouter un compte",
    "note": "Tes sessions restent sur cet appareil. La bascule se fait sans ressaisir ton mot de passe."
  },
  "ferie": {
    "jourAn": "Jour de l'An",
    "lundiPaques": "Lundi de Pâques",
    "feteTravail": "Fête du Travail",
    "victoire1945": "Victoire 1945",
    "ascension": "Ascension",
    "lundiPentecote": "Lundi de Pentecôte",
    "feteNationale": "Fête nationale",
    "assomption": "Assomption",
    "toussaint": "Toussaint",
    "armistice1918": "Armistice 1918",
    "noel": "Noël"
  },
  "acces": {
    "titre": "Accès",
    "sousTitre": "Un membre par élément, un niveau chacun",
    "intro": "Par défaut, un élément n'est visible que par toi. Ajoute un membre à sa liste, puis choisis son niveau. Le propriétaire garde toujours l'accès complet.",
    "proprietaireComplet": "Propriétaire : moi · accès complet",
    "personneDautre": "Personne d'autre pour l'instant.",
    "ajouterAcces": "Ajouter un accès",
    "toutEspace": "Tout l'espace",
    "niveauLecteur": "Lecteur",
    "niveauLecteurDesc": "Consulte, ne modifie rien",
    "niveauContributeur": "Contributeur",
    "niveauContributeurDesc": "Ajoute et modifie le contenu (événements, articles, rangements)",
    "niveauGestionnaire": "Gestionnaire",
    "niveauGestionnaireDesc": "Contenu, configuration et gestion des accès",
    "ajoutTitre": "Ajouter un accès",
    "modifierTitre": "Modifier l'accès",
    "qui": "Qui",
    "niveau": "Niveau",
    "retirerAcces": "Retirer l'accès",
    "retirerAccesMsg": "{nom} n'aura plus accès à « {titre} ».",
    "aucunMembreDispo": "Tous les membres ont déjà un accès.",
    "moi": "Moi",
    "aucunMembreEspace": "Aucun membre dans l'espace. Invite-en dans « Membres de l'espace ».",
    "niveauAucun": "Pas d'accès",
    "niveauAucunDesc": "Ne voit plus cette ressource (retire l'accès à l'enregistrement)"
  },
  "aideCal": {
    "titreCal": "Le calendrier",
    "introCal": "Trois vues : Mois (pastilles rondes), Semaine et Jour (grille horaire). Un appui long sur l'onglet Calendrier ouvre les fonctions liées (Demandes, Configuration, Récurrences, Vacances, Gardes).",
    "s1t": "Plusieurs calendriers",
    "s1x": "Le calendrier ACTIF est affiché à droite de la barre des filtres — touche-le (ou double-clique l'onglet Calendrier) pour ouvrir le sélecteur : ★ définit l'actif, 👁 superpose d'autres calendriers. La gestion complète est dans Profil → « Mes calendriers », et les droits dans Profil → « Qui voit quoi ».",
    "s2t": "Gestes sur un jour (vue Mois)",
    "s2x": "Un tap sélectionne le jour. Un double-tap bascule la garde vers l'autre parent (co-parentalité — peut créer une demande à acquitter). Un appui long ouvre la liste des événements du jour.",
    "s3t": "Vues Semaine et Jour",
    "s3x": "Appui long sur l'en-tête d'un jour : liste des événements du jour. Appui long sur un créneau : nouvel événement prérempli. Pincement : zoom de la grille. Re-taper la vue active bascule l'affichage icône ↔ nom.",
    "s4t": "Événements sur plusieurs jours",
    "s4x": "En vue Mois : barre continue de la couleur de l'événement au-dessus des jours couverts. En Semaine/Jour : bloc couvrant côte à côte avec les autres événements (style Outlook), début et fin toujours affichés (date JJ/MM si un autre jour).",
    "s5t": "Filtres et hors plage",
    "s5x": "Deux filtres en haut : Catégories et Types (simple, récurrent — repas et emploi du temps à venir). Les événements hors de la plage d'heures configurée étendent la grille (réglable dans Configuration → Affichage).",
    "tutoT": "Premier tour du calendrier",
    "tutoE1": "Choisis la vue Mois, Semaine ou Jour en haut.",
    "tutoE2": "Touche un jour puis ＋ pour ajouter un événement (heure de fin obligatoire, ou « Jour entier »).",
    "tutoE3": "Appui long sur l'onglet Calendrier → Configuration pour la plage d'heures, le zoom et le type de calendrier.",
    "titreVac": "Vacances scolaires",
    "introVac": "La liste des périodes de vacances et des jours fériés, indépendante des gardes. Choisis ta zone et l'année, puis touche ⬇️ pour ajouter les périodes officielles (sans doublon).",
    "vac1t": "Voir / modifier",
    "vac1x": "Touche une période pour ouvrir sa fiche (dates, durée, moitiés). Balaie pour supprimer ; ✏️ pour changer nom et dates.",
    "vac2t": "Garde des vacances",
    "vac2x": "La répartition ½1 / ½2 entre parents se règle dans « Gardes » (périodes de garde vacances), pas ici.",
    "titreGardes": "Gardes",
    "introGardes": "Deux chronologies : le rythme HORS vacances (semaine alternée, 2-2-3, modèles perso…) et les gardes VACANCES (qui a la 1re moitié selon l'année paire/impaire). La garde est calculée à l'affichage — seuls tes échanges manuels sont écrits.",
    "g1t": "Périodes « du … au … »",
    "g1x": "Chaque rythme ou garde vacances couvre une période (début → fin, ou « sans fin »). ➕ pour en ajouter, balaie pour éditer/supprimer, et la puce « ✓ Appliquer » active ou suspend la période.",
    "g2t": "Exceptions",
    "g2x": "Les jours dont la garde diffère du rythme calculé apparaissent en « exceptions » sous chaque période : nombre de jours par parent, filtre par année/mois, et « Tout rétablir ».",
    "titreDem": "Demandes de garde",
    "introDem": "Quand deux parents sont déclarés, changer la garde d'un jour (double-tap en vue Mois) crée une demande que l'autre parent doit acquitter.",
    "d1t": "Proposer",
    "d1x": "Double-tap sur un jour en vue Mois → une demande est envoyée à l'autre parent. Tu peux annuler ta demande tant qu'elle est en attente.",
    "d2t": "Acquitter",
    "d2x": "Ouvre « Demandes » (appui long sur l'onglet) : Acquitter ✓ applique le changement, Refuser l'annule."
  },
  "mep": {
    "calPremEvtT": "Créer un premier événement",
    "calPremEvtS": "Avec une heure de début et de fin",
    "calPremEvt1": "Ouvre le Calendrier et touche un jour pour le sélectionner.",
    "calPremEvt2": "Touche ＋ en haut à droite : donne un titre à l'événement.",
    "calPremEvt3": "Choisis l'heure de début puis l'heure de fin (obligatoire, sauf « Jour entier »).",
    "calPremEvt4": "Enregistre 💾 puis retrouve ton événement : point sous le jour (Mois), bloc dans la grille (Semaine/Jour).",
    "calVuesT": "Naviguer entre les vues",
    "calVuesS": "Mois, Semaine, Jour",
    "calVues1": "Passe en vue Semaine avec le sélecteur en haut.",
    "calVues2": "Double-tape un jour de l'en-tête : tu bascules en vue Jour.",
    "calVues3": "Fais un appui long sur l'en-tête d'un jour : la liste de ses événements s'ouvre.",
    "calVues4": "Reviens en vue Mois et fais un appui long sur un jour : même liste. Terminé !",
    "calFiltT": "Filtrer le calendrier",
    "calFiltS": "Catégories et types",
    "calFilt1": "Touche « Catégories » au-dessus du calendrier et décoche une catégorie : ses événements disparaissent.",
    "calFilt2": "Le chip affiche le nombre de masqués. Recoche pour tout réafficher.",
    "calFilt3": "Fais pareil avec « Types » (simple / récurrent).",
    "calGardeT": "Échanger une garde",
    "calGardeS": "Calendrier de co-parentalité",
    "calGarde1": "Sur un calendrier de co-parentalité, va en vue Mois.",
    "calGarde2": "Double-tape un jour : la garde bascule vers l'autre parent (ou crée une demande à acquitter).",
    "calGarde3": "Le contour du jour prend la couleur de la garde d'origine : c'est une exception. Re-double-tape pour revenir au rythme.",
    "invPremT": "Créer un premier inventaire",
    "invPremS": "À partir d'un modèle",
    "invPrem1": "Ouvre Inventaires et touche ＋ en haut à droite.",
    "invPrem2": "Choisis un modèle prêt (ex. Placards & frigo) ou « Inventaire vide », donne un titre.",
    "invPrem3": "Enregistre : ton inventaire apparaît avec ses catégories.",
    "invElemT": "Ajouter et compter un élément",
    "invElemS": "Quantité et seuil",
    "invElem1": "Ouvre ton inventaire et touche ＋ pour créer un élément dans une catégorie.",
    "invElem2": "Règle sa quantité avec − / ＋, et un seuil d'alerte si besoin.",
    "invElem3": "Reviens à la liste : le compteur de la catégorie reflète tes ajouts.",
    "invScanT": "Scanner un produit",
    "invScanS": "Code-barres → fiche remplie",
    "invScan1": "Dans un inventaire, touche 📷 (scanner).",
    "invScan2": "Vise le code-barres d'un produit : s'il est connu, le nom se remplit tout seul.",
    "invScan3": "Valide : l'article est créé avec son code. Terminé !"
  },
  "erreurs": {
    "heureFinAvantDebut": "L'heure de fin doit être après l'heure de début.",
    "dateFinAvantDebut": "La date de fin doit être après la date de début."
  },
  "avenir": {
    "bientot": "{nom} arrive bientôt.",
    "bientotCourt": "bientôt",
    "migration": "Écran préparé — fonction en cours de migration depuis MoPCal.",
    "destination": "Destination",
    "perimetre": "Périmètre prévu",
    "dest": {
      "core": "Core (toutes les apps)",
      "mycalendar": "My Calendar",
      "meals": "My Meals",
      "finance": "My Finance",
      "transverse": "Transverse"
    },
    "f": {
      "messagerie": [
        "Conversations d'espace et par calendrier",
        "Photos, fichiers et prise de vue",
        "Notifications",
        "Sous-fonctions activables par forfait"
      ],
      "journal": [
        "Entrées datées par calendrier",
        "Photos et notes du quotidien",
        "Fil chronologique",
        "Recherche et filtres"
      ],
      "statistiques": [
        "Répartition de la garde (jours, nuitées, vacances)",
        "Compteurs d'événements par catégorie et type",
        "Comparaison entre périodes",
        "Export des chiffres"
      ],
      "historique": [
        "Journal des actions de l'espace",
        "Filtres par fonction et par membre",
        "Consultation par élément"
      ],
      "listes": [
        "Listes partagées de tâches",
        "Quantités, unités, photos et commentaires",
        "Droits par personne",
        "Compteur fait / total"
      ],
      "repas": [
        "Menu de la semaine en lecture dans My Calendar",
        "Repas planifiés = événements de type « repas »",
        "Édition complète (recettes, composition, plages) dans My Meals"
      ],
      "courses": [
        "Liste générée depuis le menu de la semaine",
        "Cochage en magasin depuis My Calendar",
        "Prix, totaux et rayons dans My Meals"
      ],
      "contacts": [
        "Fiches contacts de l'espace",
        "Adresse avec carte et itinéraire",
        "Champs à la carte (prédéfinis + personnalisés)"
      ],
      "lieux": [
        "Lieux enregistrés de l'espace",
        "Carte et itinéraire",
        "Rattachement aux événements"
      ],
      "finances": [
        "Postes budgétaires par calendrier",
        "Dépenses, revenus et récurrentes",
        "Répartition entre parents et « qui doit à qui »",
        "Remboursements",
        "Projection des mois à venir",
        "Synthèses et exports"
      ],
      "exports": [
        "PDF du menu des semaines (recettes + courses)",
        "Export de la liste de courses",
        "Export du calendrier (iCal)",
        "Export des données (JSON)"
      ],
      "edt": [
        "Grille type hebdomadaire (semaines A/B)",
        "Créneaux par enfant / calendrier",
        "Événements de type « EDT » dans le calendrier",
        "Exceptions et jours particuliers"
      ],
      "appmeals": [
        "Recettes et composition (ingrédients, extras)",
        "Catégories de recettes",
        "Menus par semaine et plages de repas",
        "Génération de la liste de courses",
        "Catalogue produits, prix et scan",
        "Repas visibles dans My Calendar",
        "Export PDF du menu"
      ],
      "appfinance": [
        "Postes budgétaires par calendrier et par espace",
        "Dépenses, revenus, opérations récurrentes",
        "Répartition entre parents, « qui doit à qui »",
        "Remboursements",
        "Projection et synthèses mensuelles",
        "Exports"
      ]
    }
  },
  "filtres": {
    "titre": "Filtres",
    "reinitialiser": "Reinitialiser",
    "aide": "Coche ce que tu veux voir. Les filtres s'appliquent a l'enregistrement ; la fleche remet tout.",
    "toutCocher": "Tout cocher",
    "toutDecocher": "Tout decocher"
  },
  "jetons": {
    "titre": "Selection des elements visibles",
    "sousTitre": "{n} element(s) retenu(s)",
    "aide": "Touche ⚙️ pour GERER un element, 👁 pour le CONSULTER seulement (re-toucher le mode actif y renonce), 🎁 pour l'offrir a quelqu'un. En haut, la FILE : une ligne par jeton consomme, que tu ordonnes avec ▲ — si des jetons disparaissent, le bas de file saute.",
    "mensuelAide": "Ajouter un element ne se fait qu'une fois par mois. Retirer, reordonner ou reprendre un jeton confie reste libre.",
    "donsEnCours": "{n} jeton(s) confie(s) a quelqu'un : ils restent decomptes de tes jetons.",
    "aucunElement": "Aucun element de ce type",
    "enGestion": "Gere (modifiable)",
    "enConsultation": "Consultation seule",
    "nonRetenu": "Non retenu",
    "retrograde": "passe en consultation faute de jeton",
    "confieParAutre": "Confie par son proprietaire (gratuit pour toi)",
    "joursRestants": "{n} j avant fermeture",
    "confierA": "Confier a",
    "confierAide": "Le jeton reste decompte de tes jetons tant que tu ne le reprends pas. La personne pourra gerer cet element sans depenser les siens.",
    "aucunMembre": "Aucun autre membre dans cet espace",
    "offrir": "Offrir",
    "offrirQuoi": "Quel element offrir ?",
    "offrirQuoiDroit": "Qu'est-ce que tu offres ?",
    "offrirGestion": "La gestion (coute un jeton ⚙️)",
    "offrirVue": "La consultation (coute un jeton 👁)",
    "offertA": "Offert ({nature}) : le jeton reste decompte chez toi",
    "file": "Ma file de jetons (par priorite)",
    "pourMoi": "Pour moi",
    "pourQui": "Offert a {qui}",
    "ecarte": "ecarte, faute de jeton",
    "aussiOffert": "aussi offert ({nature})",
    "donProprietaireSeul": "Seul le proprietaire de cet element peut l'offrir.",
    "donHorsForfait": "« Confier un element » n'est pas inclus dans ton forfait.",
    "accesLecture": "lecture seule (droit accorde)",
    "lectureSeuleAcces": "Le proprietaire ne t'a accorde que la LECTURE sur cet element : meme avec un jeton ⚙️, il resterait en consultation.",
    "accesAide": "Un jeton ⚙️ ne donne pas le droit de modifier : il faut aussi que le proprietaire t'ait accorde l'ecriture. La selection n'ecrase jamais les droits — le droit reel est le plus restrictif des deux.",
    "espaceDe": "Espace",
    "espaceInconnu": "(espace inconnu)",
    "proprietaire": "Proprietaire",
    "moi": "Moi",
    "autreMembre": "Un autre membre",
    "monRole": "Mon role",
    "contenu": "Contenu",
    "nElements": "{n} element(s)",
    "espaceVide": "Cet espace ne contient encore aucun element.",
    "creationBloquee": "Maximum d'elements atteint ({n}/{max}) : supprime un element pour pouvoir en creer un autre. Le retirer seulement des elements visibles ne suffit pas.",
    "compteurElements": "{n}/{max} elements possedes",
    "comptageIncomplet": "comptage incomplet, creation suspendue",
    "modeConfiguration": "Configuration (modifiable)",
    "modeVisualisation": "Visualisation seule",
    "donSansJeton": "Plus de jeton libre : reprends-en un ou libere un element avant d'offrir."
  },
  "suppr": {
    "emporte": "Cette suppression emporte aussi {n} element(s) :",
    "f_evenements": "evenement(s)",
    "f_garde": "jour(s) de garde",
    "f_edt": "element(s) d emploi du temps",
    "f_listes": "liste(s) et taches",
    "f_finances": "element(s) de finances",
    "f_journal": "note(s) de journal",
    "f_contacts": "contact(s)",
    "f_messagerie": "message(s) et discussion(s)",
    "f_demandes": "demande(s)",
    "f_repas": "element(s) de repas",
    "f_historique": "entree(s) d historique"
  }
}
